export var headers = {
	"Project-Id-Version": "ox.de_DE",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2025-05-16 10:05+0200",
	"Last-Translator": "",
	Language: "de_DE",
	"Language-Team": "American English <kde-i18n-de@kde.org>",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=(n != 1);",
	"MIME-Version": "1.0",
	"X-Generator": "Poedit 3.5",
	"X-POOTLE-MTIME": "1410268670.000000"
};
export default {
	headers: headers,
	"\u0000 and \u0001": [
	" und "
],
	"\u0000%1$d %2$s\u0001": [
	"%1$d %2$s"
],
	"\u0000%1$d Day\u0001%1$d Days": [
	"Ein Tag",
	"%1$d Tage"
],
	"\u0000%1$d Hour\u0001%1$d Hours": [
	"Eine Stunde",
	"%1$d Stunden"
],
	"\u0000%1$d Minute\u0001%1$d Minutes": [
	"Eine Minute",
	"%1$d Minuten"
],
	"\u0000%1$d Week\u0001%1$d Weeks": [
	"Eine Woche",
	"%1$d Wochen"
],
	"\u0000%1$d address selected\u0001%1$d addresses selected": [
	"Eine Adresse ausgewählt",
	"%1$d Adressen ausgewählt"
],
	"\u0000%1$d appointment\u0001%1$d appointments": [
	"%1$d Termin",
	"%1$d Termine"
],
	"\u0000%1$d attachment\u0001%1$d attachments": [
	"Ein Anhang",
	"%1$d Anhänge"
],
	"\u0000%1$d autocomplete entry found\u0001%1$d autocomplete entries found": [
	"Ein Autovervollständigungseintrag gefunden",
	"%1$d Autovervollständigungseinträge gefunden"
],
	"\u0000%1$d contact\u0001%1$d contacts": [
	"%1$d Kontakt",
	"%1$d Kontakte"
],
	"\u0000%1$d contact selected\u0001%1$d contacts selected": [
	"%1$d Kontakt ausgewählt",
	"%1$d Kontakte ausgewählt"
],
	"\u0000%1$d contacts deleted\u0001": [
	"%1$d Kontakte gelöscht"
],
	"\u0000%1$d contacts moved\u0001": [
	"%1$d Kontakte verschoben"
],
	"\u0000%1$d day\u0001%1$d days": [
	"Ein Tag",
	"%1$d Tage"
],
	"\u0000%1$d emails archived\u0001": [
	"%1$d E-Mails archiviert"
],
	"\u0000%1$d emails copied to folder '%2$s'\u0001": [
	"%1$d E-Mails in Ordner '%2$s' kopiert"
],
	"\u0000%1$d emails deleted\u0001": [
	"%1$d E-Mails gelöscht"
],
	"\u0000%1$d emails moved to folder '%2$s'\u0001": [
	"%1$d E-Mails in Ordner '%2$s' verschoben"
],
	"\u0000%1$d entry\u0001%1$d entries": [
	"%1$d Eintrag",
	"%1$d Einträge"
],
	"\u0000%1$d files have been changed recently\u0001": [
	"%1$d Dateien wurden kürzlich geändert"
],
	"\u0000%1$d hour\u0001%1$d hours": [
	"Eine Stunde",
	"%1$d Stunden"
],
	"\u0000%1$d item\u0001%1$d items": [
	"Ein Objekt",
	"%1$d Objekte"
],
	"\u0000%1$d item selected\u0001%1$d items selected": [
	"Ein Objekt ausgewählt",
	"%1$d Objekte ausgewählt"
],
	"\u0000%1$d member\u0001%1$d members": [
	"Ein Mitglied",
	"%1$d Mitglieder"
],
	"\u0000%1$d message\u0001%1$d messages": [
	"%1$d Nachricht",
	"%1$d Nachrichten"
],
	"\u0000%1$d message selected\u0001%1$d messages selected": [
	"Eine Nachricht markiert",
	"%1$d Nachrichten markiert"
],
	"\u0000%1$d minute\u0001%1$d minutes": [
	"Eine Minute",
	"%1$d Minuten"
],
	"\u0000%1$d minutes\u0001": [
	"%1$d Minuten"
],
	"\u0000%1$d month\u0001%1$d months": [
	"Ein Monat",
	"%1$d Monate"
],
	"\u0000%1$d of %2$d used\u0001": [
	"%1$d von %2$d belegt"
],
	"\u0000%1$d of 10 points.\u0001": [
	"%1$d von 10 Punkten."
],
	"\u0000%1$d of 5 stars\u0001": [
	"%1$d von 5 Sternen"
],
	"\u0000%1$d second\u0001%1$d seconds": [
	"Eine Sekunde",
	"%1$d Sekunden"
],
	"\u0000%1$d selected\u0001": [
	"%1$d markiert"
],
	"\u0000%1$d task\u0001%1$d tasks": [
	"%1$d Aufgabe",
	"%1$d Aufgaben"
],
	"\u0000%1$d total\u0001": [
	"%1$d gesamt"
],
	"\u0000%1$d unread\u0001": [
	"%1$d ungelesen"
],
	"\u0000%1$d version\u0001%1$d versions": [
	"Eine Version",
	"%1$d Versionen"
],
	"\u0000%1$d week\u0001%1$d weeks": [
	"Eine Woche",
	"%1$d Wochen"
],
	"\u0000%1$d year\u0001%1$d years": [
	"Ein Jahr",
	"%1$d Jahre"
],
	"\u0000%1$d%% of mail count remaining\u0001": [
	"%1$d%% der E-Mail-Anzahl verbleibend"
],
	"\u0000%1$n member\u0001%1$n members": [
	"%1$n Mitglied",
	"%1$n Mitglieder"
],
	"\u0000%1$s\u0001": [
	"%1$s"
],
	"\u0000%1$s %\u0001": [
	"%1$s %"
],
	"mail address\u0000%1$s %2$s\u0001": [
	"%1$s %2$s"
],
	"\u0000%1$s %2$s - %3$s %4$s\u0001": [
	"%1$s %2$s - %3$s %4$s"
],
	"\u0000%1$s %2$s after end.\u0001": [
	"%1$s %2$s nach Ende."
],
	"\u0000%1$s %2$s after start.\u0001": [
	"%1$s %2$s nach Beginn."
],
	"\u0000%1$s %2$s before end.\u0001": [
	"%1$s %2$s vor Ende."
],
	"\u0000%1$s %2$s before start.\u0001": [
	"%1$s %2$s vor Beginn."
],
	"\u0000%1$s (%2$s)\u0001": [
	"%1$s (%2$s)"
],
	"\u0000%1$s - %2$s %3$s\u0001": [
	"%1$s - %2$s %3$s"
],
	"\u0000%1$s > %2$s\u0001": [
	"%1$s > %2$s"
],
	"\u0000%1$s Files left\u0001": [
	"%1$s Dateien übrig"
],
	"\u0000%1$s Help\u0001": [
	"%1$s-Hilfe"
],
	"\u0000%1$s appointments selected\u0001": [
	"%1$s Termine ausgewählt"
],
	"\u0000%1$s at %2$s.\u0001": [
	"%1$s um %2$s."
],
	"\u0000%1$s at end.\u0001": [
	"%1$s bei Ende."
],
	"\u0000%1$s at start.\u0001": [
	"%1$s bei Beginn."
],
	"\u0000%1$s autocomplete token field. Use left and right arrow keys to navigate between the tokens\u0001": [
	"Autovervollständigungsfeld %1$s. Verwenden Sie die linke und rechte Pfeiltaste zum Navigieren zwischen den Feldern."
],
	"\u0000%1$s completed\u0001": [
	"%1$s hochgeladen"
],
	"\u0000%1$s could not be added as the contact has no valid email field.\u0001": [
	"%1$s konnte nicht hinzugefügt werden, da der Kontakt kein gültiges E-Mail-Feld enthält."
],
	"\u0000%1$s for Windows\u0001": [
	"%1$s für Windows"
],
	"\u0000%1$s item selected\u0001%1$s items selected": [
	"Ein Objekt markiert",
	"%1$s Objekte markiert"
],
	"\u0000%1$s more …\u0001": [
	"%1$s weitere …"
],
	"\u0000%1$s moved to position %2$s of %3$s\u0001": [
	"%1$s an Position %2$s von %3$s verschoben"
],
	"\u0000%1$s must not be empty.\u0001": [
	"%1$s darf nicht leer sein."
],
	"\u0000%1$s of %2$s used\u0001": [
	"%1$s von %2$s belegt"
],
	"\u0000%1$s options\u0001": [
	"%1$s-Optionen"
],
	"\u0000%1$s shared a folder with you\u0001": [
	"%1$s hat einen Ordner für Sie freigegeben"
],
	"\u0000%1$s to %2$s\u0001": [
	"%1$s bis %2$s"
],
	"\u0000%1$s toolbar. Use cursor keys to navigate.\u0001": [
	"%1$s-Werkzeugleiste. Verwenden Sie die Pfeiltasten zum Navigieren."
],
	"\u0000%1$s, %2$s & %3$s\u0001": [
	"%1$s, %2$s & %3$s"
],
	"\u0000%1$s, dropped. Final position in list: %2$s of %3$s\u0001": [
	"%1$s, abgelegt. Endposition in Liste: %2$s of %3$s"
],
	"\u0000%1$s, dropped. Re-order canceled.\u0001": [
	"%1$s, abgelegt. Neusortierung abgebrochen."
],
	"\u0000%1$s, grabbed. Current position in list: %2$s of %3$s. Press up and down arrow to change position, Spacebar to drop, Escape to cancel.\u0001": [
	"%1$s, markiert. Aktuelle Position in der Liste: %2$s von %3$s. Verwenden Sie zum Ändern der Position die Pfeiltasten nach oben und unten, Die Leertaste zum Ablegen, Escape zum Abbrechen."
],
	"\u0000%1$s. New position in list: %2$s of %3$s\u0001": [
	"%1$s. Neue Position in der Liste: %2$s von %3$s"
],
	"\u0000%1$s: %2$s\u0001": [
	"%1$s: %2$s"
],
	"\u0000%2$s, %1$s\u0001": [
	"%2$s, %1$s"
],
	"\u0000%3$s %2$s, %1$s\u0001": [
	"%3$s %2$s, %1$s"
],
	"\u0000%d day\u0001%d days": [
	"Ein Tag",
	"%d Tage"
],
	"\u0000%s %s, create all-day appointment\u0001": [
	"%s %s, ganztägigen Termin erstellen"
],
	"\u0000%s Conference\u0001": [
	"%s-Konferenz"
],
	"\u0000%s actions\u0001": [
	"%s Aktionen"
],
	"\u0000%s conferences expire after 365 days. We recommend to limit the series to one year. Alternatively, you can update the series before the meeting expires.\u0001": [
	"%s-Konferenzen laufen nach 365 Tagen ab. Wir empfehlen, die Serie auf ein Jahr zu begrenzen. Alternativ können Sie die Serie aktualisieren, bevor das Meeting abläuft."
],
	"\u0000%s is also available for other platforms:\u0001": [
	"%s ist auch für andere Plattformen verfügbar:"
],
	"\u0000%s logged in on %s\u0001": [
	"%s angemeldet am %s"
],
	"\u0000%s meetings\u0001": [
	"%s-Meetings"
],
	"\u0000+\u0001": [
	"+"
],
	"\u0000+ %1$d other\u0001+ %1$d others": [
	"+ %1$d weiterer",
	"+ %1$d weitere"
],
	"\u0000, \u0001": [
	", "
],
	"\u0000---------- Original Message ----------\u0001": [
	"---------- Ursprüngliche Nachricht ----------"
],
	"\u000009.00 (24 hours)\u0001": [
	"09.00 (24 Stunden)"
],
	"\u000009:00 (24 hours)\u0001": [
	"09:00 (24 Stunden)"
],
	"\u000009:00 AM (12 hours)\u0001": [
	"09:00 AM (12 Stunden)"
],
	"\u00001 day\u0001": [
	"Ein Tag"
],
	"\u00001 file has been changed recently\u0001": [
	"Eine Datei wurde kürzlich geändert"
],
	"\u00001 minute before the appointment starts\u0001": [
	"1 Minute bis Terminbeginn"
],
	"\u00001 version\u0001": [
	"Eine Version"
],
	"\u00001 year\u0001": [
	"Ein Jahr"
],
	"\u000010 minutes\u0001": [
	"10 Minuten"
],
	"\u000010 minutes before the appointment starts\u0001": [
	"10 Minuten bis Terminbeginn"
],
	"\u000010 seconds\u0001": [
	"10 Sekunden"
],
	"\u000010 versions\u0001": [
	"10 Versionen"
],
	"\u0000100 versions\u0001": [
	"100 Versionen"
],
	"\u000015 minutes\u0001": [
	"15 Minuten"
],
	"\u000015 minutes before the appointment starts\u0001": [
	"15 Minuten bis Terminbeginn"
],
	"\u00002-Step Verification Options\u0001": [
	"Zwei-Faktor-Authentifizierungsoptionen"
],
	"\u00002-step verification\u0001": [
	"Zwei-Faktor-Authentifizierung"
],
	"\u000020 versions\u0001": [
	"20 Versionen"
],
	"\u000030 days\u0001": [
	"30 Tage"
],
	"\u000030 minutes\u0001": [
	"30 Minuten"
],
	"\u000030 minutes before the appointment starts\u0001": [
	"30 Minuten bis Terminbeginn"
],
	"\u000030 versions\u0001": [
	"30 Versionen"
],
	"\u000040 versions\u0001": [
	"40 Versionen"
],
	"\u00005 minutes\u0001": [
	"5 Minuten"
],
	"\u00005 minutes before the appointment starts\u0001": [
	"5 Minuten bis Terminbeginn"
],
	"\u00005 seconds\u0001": [
	"5 Sekunden"
],
	"\u00005 versions\u0001": [
	"5 Versionen"
],
	"\u000050 versions\u0001": [
	"50 Versionen"
],
	"\u000060 days\u0001": [
	"60 Tage"
],
	"\u000060 seconds\u0001": [
	"60 Sekunden"
],
	"\u000060 versions\u0001": [
	"60 Versionen"
],
	"\u00007 days\u0001": [
	"7 Tage"
],
	"\u000070 versions\u0001": [
	"70 Versionen"
],
	"\u000080 versions\u0001": [
	"80 Versionen"
],
	"\u00009.00 (24 hours)\u0001": [
	"9.00 (24 Stunden)"
],
	"\u000090 days\u0001": [
	"90 Tage"
],
	"\u000090 versions\u0001": [
	"90 Versionen"
],
	"\u00009:00 (24 hours)\u0001": [
	"9:00 (24 Stunden)"
],
	"\u00009:00 AM (12 hours)\u0001": [
	"9:00 AM (12 Stunden)"
],
	"\u0000A folder cannot be moved into itself\u0001": [
	"Ein Ordner kann nicht in sich selbst verschoben werden"
],
	"\u0000A folder cannot be moved to one of its subfolders\u0001": [
	"Der Ordner kann nicht in einen seiner Unterordner verschoben werden"
],
	"\u0000A new code was sent to your SMS device. Please enter the code.\u0001": [
	"Sie haben eine SMS mit einem neuen Code erhalten. Bitte geben Sie den Code ein."
],
	"\u0000A new version for \"%1$s\" has been added.\u0001": [
	"Eine neue Version für \"%1$s\" wurde hinzugefügt."
],
	"\u0000A password was created successfully.  Please use the following settings in the application:\u0001": [
	"Ein Passwort wurde erfolgreich erstellt.  Bitte verwenden Sie die folgenden Einstellungen in der Applikation:"
],
	"\u0000A problem occurred while loading the Zoom meeting. Maybe the Zoom meeting has expired.\u0001": [
	"Beim Laden des Zoom-Meetings ist ein Fehler aufgetreten. Möglicherweise ist das Zoom-Meeting abgelaufen."
],
	"\u0000A public folder is used for content that is of common interest to all users. To allow other users to read or edit the contents, you have to set the respective permissions for the public folder.\u0001": [
	"Ein öffentlicher Ordner ist für Inhalte vorgesehen, die für alle Benutzer von Interesse sind. Damit andere Benutzer die Inhalte lesen oder bearbeiten können, müssen Sie entsprechende Berechtigungen für den öffentlichen Ordner erteilen."
],
	"\u0000A read receipt has been sent\u0001": [
	"Lesebestätigung wurde gesendet"
],
	"\u0000A refresh takes some time, so please be patient, while the refresh runs in the background. Only one refresh per subscription and per session is allowed.\u0001": [
	"Eine Aktualisierung nimmt einige Zeit in Anspruch und läuft im Hintergrund ab. Pro Abonnement und Sitzung ist nur eine Aktualisierung zulässig."
],
	"\u0000A resource calendar group is used to collect specific resources such as rooms, hardware or others that can be booked by other users.\u0001": [
	"Eine Ressourcenkalendergruppe enthält bestimmte Ressourcen wie Räume, Hardware etc., die von anderen Benutzern gebucht werden können."
],
	"\u0000A resource group named \"%1$s\" already exists!\u0001": [
	"Eine Ressourcengruppe mit dem Namen \"%1$s\" ist bereits vorhanden."
],
	"\u0000A time saver if you live or work in more than one time zone\u0001": [
	"Eine Zeitersparnis, wenn Sie in mehr als einer Zeitzone leben oder arbeiten"
],
	"\u0000ADDED\u0001": [
	"HINZUGEFÜGT"
],
	"\u0000About\u0001": [
	"Über"
],
	"\u0000Accent colors\u0001": [
	"Akzentfarben"
],
	"\u0000Accept\u0001": [
	"Bestätigen"
],
	"appointment participation status\u0000Accept\u0001": [
	"Bestätigen"
],
	"\u0000Accept Proposal\u0001": [
	"Vorschlag übernehmen"
],
	"\u0000Accept changes\u0001": [
	"Änderungen übernehmen"
],
	"\u0000Accepted\u0001": [
	"Bestätigt"
],
	"\u0000Accepted the new participant\u0001": [
	"Der neue Teilnehmer wurde genehmigt"
],
	"\u0000Accepted: %d\u0001": [
	"Bestätigt: %d"
],
	"\u0000Access to your media devices has been denied. Please refer to your browser help pages for how to reset authorization.\u0001": [
	"Der Zugriff auf Ihre Mediengeräte wurde verweigert. Informationen zum Zurücksetzen der Autorisierung finden Sie in den Hilfeseiten Ihres Browsers."
],
	"\u0000Accessing global address book is not permitted\u0001": [
	"Der Zugriff auf das globale Adressbuch ist nicht zulässig"
],
	"\u0000Account\u0001": [
	"Konto"
],
	"\u0000Account Name\u0001": [
	"Kontoname"
],
	"\u0000Account added successfully\u0001": [
	"Konto erfolgreich hinzugefügt"
],
	"\u0000Account already exists\u0001": [
	"Konto ist bereits vorhanden"
],
	"\u0000Account could not be added\u0001": [
	"Konto konnte nicht hinzugefügt werden"
],
	"\u0000Account name\u0001": [
	"Kontoname"
],
	"\u0000Account settings\u0001": [
	"Konto-Einstellungen"
],
	"\u0000Account settings could not be saved. Please take a look at the annotations in the form. \u0001": [
	"Kontoeinstellungen konnten nicht gespeichert werden. Bitte lesen Sie die Anmerkungen im Formular. "
],
	"\u0000Account updated\u0001": [
	"Konto wurde aktualisiert"
],
	"\u0000Account updated successfully\u0001": [
	"Konto erfolgreich aktualisiert"
],
	"\u0000Accounts\u0001": [
	"Konten"
],
	"\u0000Actions\u0001": [
	"Aktionen"
],
	"\u0000Actions for %1$s\u0001": [
	"Aktionen für %1$s"
],
	"\u0000Actions of this rule are not allowed to be applied to existing emails.\u0001": [
	"Die Aktionen dieser Regel dürfen nicht auf bestehende E-Mails angewendet werden."
],
	"\u0000Actions. Use cursor keys to navigate.\u0001": [
	"Aktionen. Verwenden Sie die Pfeiltasten zum Navigieren."
],
	"\u0000Activate categories\u0001": [
	"Kategorien aktivieren"
],
	"\u0000Activate next floating window\u0001": [
	"Nächstes schwebendes Fenster aktivieren"
],
	"\u0000Activate previous floating window\u0001": [
	"Vorheriges schwebendes Fenster aktivieren"
],
	"\u0000Active calendars\u0001": [
	"Aktive Kalender"
],
	"\u0000Actual costs\u0001": [
	"Tatsächliche Kosten"
],
	"\u0000Actual duration in minutes\u0001": [
	"Tatsächliche Dauer in Minuten"
],
	"\u0000Add\u0001": [
	"Hinzufügen"
],
	"\u0000Add IMAP keyword\u0001": [
	"IMAP-Schlüsselwort hinzufügen"
],
	"\u0000Add Multifactor Device\u0001": [
	"Multifaktor-Gerät hinzufügen"
],
	"\u0000Add Recovery Option\u0001": [
	"Wiederherstellungsoption hinzufügen"
],
	"\u0000Add Verification Option\u0001": [
	"Verifizierungsoption hinzufügen"
],
	"\u0000Add a message to the invitation email for the new participants.\u0001": [
	"Fügen Sie der Einladungs-E-Mail eine Nachricht für die neuen Teilnehmer hinzu."
],
	"\u0000Add a message to the notification email for the other participants.\u0001": [
	"Fügen Sie der Benachrichtigungs-E-Mail eine Nachricht für die anderen Teilnehmer hinzu."
],
	"\u0000Add a message.\u0001": [
	"Eine Nachricht hinzufügen."
],
	"\u0000Add action\u0001": [
	"Aktion hinzufügen"
],
	"\u0000Add additional info\u0001": [
	"Zusätzliche Informationen hinzufügen"
],
	"\u0000Add all attachments\u0001": [
	"Alle Anhänge hinzufügen"
],
	"\u0000Add an extra layer of security to your account\u0001": [
	"Fügen Sie eine zusätzliche Sicherheitsebene für Ihr Konto hinzu"
],
	"\u0000Add as public calendar\u0001": [
	"Als öffentlichen Kalender hinzufügen"
],
	"\u0000Add as public folder\u0001": [
	"Als öffentlichen Ordner hinzufügen"
],
	"\u0000Add attachment\u0001": [
	"Anhang hinzufügen"
],
	"\u0000Add attachments\u0001": [
	"Anhänge hinzufügen"
],
	"\u0000Add attachments from another email\u0001": [
	"Anhänge aus einer anderen E-Mail hinzufügen"
],
	"\u0000Add business info\u0001": [
	"Geschäftsinformationen hinzufügen"
],
	"\u0000Add category\u0001": [
	"Kategorie hinzufügen"
],
	"\u0000Add comment\u0001": [
	"Kommentar hinzufügen"
],
	"\u0000Add condition\u0001": [
	"Bedingung hinzufügen"
],
	"\u0000Add contact\u0001": [
	"Kontakt hinzufügen"
],
	"\u0000Add contact/resource\u0001": [
	"Kontakt/Ressource hinzufügen"
],
	"\u0000Add delegates\u0001": [
	"Beauftragte hinzufügen"
],
	"\u0000Add details to appointment description\u0001": [
	"Details zur Terminbeschreibung hinzufügen"
],
	"\u0000Add email account\u0001": [
	"E-Mail-Konto hinzufügen"
],
	"\u0000Add email and document encryption\u0001": [
	"Verschlüsselung für E-Mail- und Dokumente hinzufügen"
],
	"\u0000Add email, phone, fax\u0001": [
	"E-Mail, Telefon und Fax hinzufügen"
],
	"\u0000Add file\u0001": [
	"Datei hinzufügen"
],
	"\u0000Add files\u0001": [
	"Dateien hinzufügen"
],
	"\u0000Add folder\u0001": [
	"Ordner hinzufügen"
],
	"\u0000Add frequent parts as templates to save time\u0001": [
	"Fügen Sie häufig genutzte Textteile als Vorlagen hinzu, um Zeit zu sparen"
],
	"\u0000Add from %1$s\u0001": [
	"Von %1$s hinzufügen"
],
	"\u0000Add local file\u0001": [
	"Lokale Datei hinzufügen"
],
	"\u0000Add login password\u0001": [
	"Anmeldepasswort hinzufügen"
],
	"\u0000Add new address book\u0001": [
	"Neues Adressbuch hinzufügen"
],
	"\u0000Add new calendar\u0001": [
	"Neuen Kalender hinzufügen"
],
	"\u0000Add new folder\u0001": [
	"Neuen Ordner hinzufügen"
],
	"\u0000Add new list\u0001": [
	"Neue Liste hinzufügen"
],
	"\u0000Add new password\u0001": [
	"Neues Passwort hinzufügen"
],
	"\u0000Add new resource calendar\u0001": [
	"Neuen Ressourcenkalender hinzufügen"
],
	"\u0000Add new resource calendar group\u0001": [
	"Neue Ressourcenkalendergruppe hinzufügen"
],
	"\u0000Add new rule\u0001": [
	"Neue Regel hinzufügen"
],
	"\u0000Add new signature\u0001": [
	"Neue Signatur hinzufügen"
],
	"\u0000Add new task list\u0001": [
	"Neue Aufgabenliste hinzufügen"
],
	"\u0000Add new template\u0001": [
	"Neue Vorlage hinzufügen"
],
	"\u0000Add new version\u0001": [
	"Neue Version hinzufügen"
],
	"\u0000Add new version and show notification\u0001": [
	"Neue Version hinzufügen und Benachrichtigung zeigen"
],
	"\u0000Add other email account\u0001": [
	"Weiteres E-Mail-Konto hinzufügen"
],
	"\u0000Add participant\u0001": [
	"Teilnehmer hinzufügen"
],
	"\u0000Add passwords\u0001": [
	"Passwörter hinzufügen"
],
	"\u0000Add people\u0001": [
	"Personen hinzufügen"
],
	"\u0000Add personal info\u0001": [
	"Persönliche Informationen hinzufügen"
],
	"\u0000Add postal address\u0001": [
	"Postanschrift hinzufügen"
],
	"\u0000Add recovery option\u0001": [
	"Wiederherstellungsoption hinzufügen"
],
	"\u0000Add reminder\u0001": [
	"Erinnerung hinzufügen"
],
	"\u0000Add signature\u0001": [
	"Signatur hinzufügen"
],
	"\u0000Add signature above quoted text\u0001": [
	"Signatur oberhalb des zitierten Textes einfügen"
],
	"\u0000Add signature below quoted text\u0001": [
	"Signatur unterhalb des zitierten Textes einfügen"
],
	"\u0000Add storage account\u0001": [
	"Speicherkonto hinzufügen"
],
	"\u0000Add subject\u0001": [
	"Betreff hinzufügen"
],
	"\u0000Add template\u0001": [
	"Vorlage hinzufügen"
],
	"\u0000Add time zone\u0001": [
	"Zeitzone hinzufügen"
],
	"\u0000Add to %1$s\u0001": [
	"Zu %1$s hinzufügen"
],
	"\u0000Add to Calendar\u0001": [
	"Zum Kalender hinzufügen"
],
	"\u0000Add to address book\u0001": [
	"Zum Adressbuch hinzufügen"
],
	"\u0000Add to calendar\u0001": [
	"Zum Kalender hinzufügen"
],
	"\u0000Add to favorites\u0001": [
	"Zu Favoriten hinzufügen"
],
	"\u0000Add to portal\u0001": [
	"Zum Portal hinzufügen"
],
	"\u0000Add user fields\u0001": [
	"Benutzerfelder hinzufügen"
],
	"\u0000Add verification option\u0001": [
	"Verifizierungsoption hinzufügen"
],
	"\u0000Add widget\u0001": [
	"Widget hinzufügen"
],
	"\u0000Add your %1$s account\u0001": [
	"Fügen Sie Ihr %1$s-Konto hinzu"
],
	"\u0000Add your contact details and important information automatically\u0001": [
	"Ihre Kontaktdaten und wichtige Informationen automatisch hinzufügen"
],
	"\u0000Add, remove, and reorder your portal widgets\u0001": [
	"Hier können Sie Portal-Widgets hinzufügen, entfernen und neu anordnen"
],
	"\u0000Added %1$s, %2$s.\u0001": [
	"%1$s, %2$s wurde hinzugefügt."
],
	"\u0000Added %1$s.\u0001": [
	"%1$s wurde hinzugefügt."
],
	"\u0000Added %s to attachments.\u0001": [
	"%s zu Anhängen hinzugefügt."
],
	"\u0000Added distribution list %s with %s member. The only member of the distribution list is %s.\u0001": [
	"Verteilerliste %s mit %s Mitglied hinzugefügt. Das einzige Mitglied der Verteilerliste ist %s."
],
	"\u0000Added distribution list %s with %s members. Members of the distribution list are %s.\u0001": [
	"Verteilerliste %s mit %s Mitgliedern hinzugefügt. Die Mitglieder der Verteilerliste sind %s."
],
	"\u0000Added group %s with %s member. The only member of the group is %s.\u0001": [
	"Gruppe %s mit %s Mitglied hinzugefügt. Das einzige Mitglied der Gruppe ist %s."
],
	"\u0000Added group %s with %s members. Members of the group are %s.\u0001": [
	"Gruppe %s mit %s Mitgliedern hinzugefügt. Die Mitglieder der Gruppe sind %s."
],
	"\u0000Adding files\u0001": [
	"Dateien hinzufügen"
],
	"\u0000Additional options\u0001": [
	"Zusätzliche Optionen"
],
	"\u0000Additional time zones\u0001": [
	"Zusätzliche Zeitzonen"
],
	"\u0000Additional time zones allow you to effortlessly keep track of multiple time zones in day, workweek, and week view, eliminating the need for manual time zone calculations and simplifying time management across different regions.\u0001": [
	"Zusätzliche Zeitzonen ermöglichen es Ihnen, mühelos den Überblick über mehrere Zeitzonen in der Tages-, Arbeitswochen- und Wochenansicht zu behalten. Dadurch entfällt die Notwendigkeit manueller Zeitzonen-Berechnungen und das Zeitmanagement über verschiedene Regionen hinweg wird vereinfacht."
],
	"\u0000Address\u0001": [
	"Anschrift"
],
	"\u0000Address Book\u0001": [
	"Adressbuch"
],
	"app\u0000Address Book\u0001": [
	"Adressbuch"
],
	"app\u0000Address Book (CardDav)\u0001": [
	"Adressbuch (CardDav)"
],
	"\u0000Address Business\u0001": [
	"Geschäftsanschrift"
],
	"\u0000Address Home\u0001": [
	"Privatanschrift"
],
	"\u0000Address Other\u0001": [
	"Weitere Anschrift"
],
	"\u0000Address book\u0001": [
	"Adressbuch"
],
	"\u0000Address book name\u0001": [
	"Name des Adressbuchs"
],
	"\u0000Address directory\u0001": [
	"Adressverzeichnis"
],
	"\u0000Address list\u0001": [
	"Adressliste"
],
	"\u0000Addresses can be separated by space, comma, or line breaks, e.g. \"example.org, alice@example.com\"\u0001": [
	"Adressen können durch Leerzeichen, Komma oder Zeilenumbrüche separiert werden, z. B. \"beispiel.org, alice@beispiel.de\""
],
	"\u0000Adjust\u0001": [
	"Anpassen"
],
	"\u0000Adjust how you read your emails\u0001": [
	"Passen Sie die Art und Weise an, wie Sie Ihre E-Mails lesen"
],
	"\u0000Adjust start and length if your workweek differs from the standard five-day week.\u0001": [
	"Passen Sie Beginn und Dauer an, wenn Ihre Arbeitswoche von der Standard-Fünftagewoche abweicht."
],
	"\u0000Adjust start date\u0001": [
	"Startdatum anpassen"
],
	"\u0000Administrative role\u0001": [
	"Adminrolle"
],
	"\u0000Administrator\u0001": [
	"Administrator"
],
	"\u0000Advanced settings\u0001": [
	"Erweiterte Einstellungen"
],
	"\u0000Africa\u0001": [
	"Afrika"
],
	"\u0000After\u0001": [
	"Nach"
],
	"\u0000After %1$d seconds\u0001": [
	"Nach %1$d Sekunden"
],
	"\u0000After a number of occurrences\u0001": [
	"Nach einer Anzahl von Ereignissen"
],
	"\u0000Age\u0001": [
	"Alter"
],
	"\u0000Age: %1$d\u0001": [
	"Alter: %1$d"
],
	"\u0000Alarm\u0001": [
	"Erinnerung"
],
	"\u0000All\u0001": [
	"Alle"
],
	"\u0000All Applications\u0001": [
	"Alle Applikationen"
],
	"\u0000All address books\u0001": [
	"Alle Adressbücher"
],
	"\u0000All attachments\u0001": [
	"Alle Anhänge"
],
	"\u0000All day\u0001": [
	"Ganztägig"
],
	"\u0000All distribution lists\u0001": [
	"Alle Verteilerlisten"
],
	"\u0000All files\u0001": [
	"Alle Dateien"
],
	"\u0000All files have been deleted\u0001": [
	"Alle Dateien wurden gelöscht"
],
	"\u0000All folders\u0001": [
	"Alle Ordner"
],
	"\u0000All future messages from the sender will be moved to the selected folder.\u0001": [
	"Alle zukünftigen Nachrichten des Absenders werden in den ausgewählten Ordner verschoben."
],
	"\u0000All future messages from the senders of the selected mails will be moved to the selected folder.\u0001": [
	"Alle zukünftigen Nachrichten von den Absendern der ausgewählten E-Mails werden in den ausgewählten Ordner verschoben."
],
	"\u0000All groups\u0001": [
	"Alle Gruppen"
],
	"\u0000All lists\u0001": [
	"Alle Listen"
],
	"\u0000All messages have been deleted\u0001": [
	"Alle Nachrichten wurden gelöscht"
],
	"\u0000All messages in this folder\u0001": [
	"Alle Nachrichten in diesem Ordner"
],
	"\u0000All messages older than %1$d days will be moved to the archive folder\u0001": [
	"Nachrichten, die älter als %1$d Tage sind, werden in den Archiv-Ordner verschoben"
],
	"\u0000All my public appointments\u0001": [
	"Alle meine öffentlichen Termine"
],
	"\u0000All resources\u0001": [
	"Alle Ressourcen"
],
	"\u0000All settings\u0001": [
	"Alle Einstellungen"
],
	"\u0000All types\u0001": [
	"Alle Typen"
],
	"\u0000All unseen messages\u0001": [
	"Alle ungesehenen Nachrichten"
],
	"\u0000Allow connections with untrusted certificates\u0001": [
	"Verbindungen mit nicht vertrauenswürdigen Zertifikaten zulassen"
],
	"\u0000Allow displaying HTML formatted emails\u0001": [
	"Anzeige von HTML-formatierten E-Mails zulassen"
],
	"\u0000Allowed to send emails on your behalf\u0001": [
	"Erlaubnis, in Ihrem Namen E-Mails zu versenden"
],
	"\u0000Alt\u0001": [
	"Alt"
],
	"\u0000Alternatively you can download the file.\u0001": [
	"Alternativ können Sie die Datei herunterladen."
],
	"\u0000Always\u0001": [
	"Immer"
],
	"\u0000Always add a random meeting password\u0001": [
	"Immer ein zufälliges Meeting-Passwort hinzufügen"
],
	"\u0000Always add to BCC\u0001": [
	"Immer zu BCC hinzufügen"
],
	"\u0000Always attach my detailed contact data as vCard\u0001": [
	"Meine detaillierten Kontaktdaten immer als vCard anhängen"
],
	"\u0000Always mark \"Participants can edit appointments\" when creating or editing appointments\u0001": [
	"Beim Erstellen oder Bearbeiten von Terminen immer \"Teilnehmer können Termine bearbeiten\" markieren"
],
	"\u0000Always show external images (excluding spam and untrustworthy senders)\u0001": [
	"Externe Bilder immer anzeigen (ausgenommen Spam und nicht vertrauenswürdige Absender)"
],
	"\u0000Always show external images for the following senders\u0001": [
	"Für folgende Absender externe Bilder immer anzeigen"
],
	"\u0000Always show full date and time\u0001": [
	"Immer das vollständige Datum und die Uhrzeit anzeigen"
],
	"\u0000Always show images from %s\u0001": [
	"Bilder von %s immer anzeigen"
],
	"\u0000America\u0001": [
	"Amerika"
],
	"\u0000An email is currently being sent. If you sign out now, mails might not be sent.\u0001": [
	"Es wird gerade eine E-Mail versendet. Wenn Sie sich jetzt abmelden, wird der E-Mail-Versand möglicherweise abgebrochen."
],
	"\u0000An error occurred loading the document so it cannot be displayed.\u0001": [
	"Beim Laden des Dokuments ist ein Fehler aufgetreten, sodass es nicht angezeigt werden kann."
],
	"\u0000An error occurred while converting the document so it cannot be displayed.\u0001": [
	"Beim Konvertieren des Dokuments ist ein Fehler aufgetreten, sodass es nicht angezeigt werden kann."
],
	"\u0000An error occurred while loading the document so it cannot be displayed.\u0001": [
	"Beim Laden des Dokuments ist ein Fehler aufgetreten, sodass es nicht angezeigt werden kann."
],
	"\u0000An error occurred.\u0001": [
	"Es trat ein Fehler auf."
],
	"\u0000An error occurred. Please refresh the page and try again.\u0001": [
	"Es ist ein Fehler aufgetreten. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut."
],
	"\u0000An error occurred. Please try again.\u0001": [
	"Es trat ein Fehler auf. Bitte versuchen Sie es später erneut."
],
	"\u0000An error occurred. There is no valid token available.\u0001": [
	"Es trat ein Fehler auf. Es ist kein gültiges Token verfügbar."
],
	"\u0000An unexpected error occurred while rendering the PDF file.\u0001": [
	"Beim Rendern der PDF-Datei ist ein unerwarteter Fehler aufgetreten."
],
	"\u0000An unknown error occurred\u0001": [
	"Es trat ein unbekannter Fehler auf"
],
	"\u0000Android\u0001": [
	"Android"
],
	"\u0000Android phone or tablet\u0001": [
	"Android-Smartphone oder -Tablet"
],
	"\u0000Anniversary\u0001": [
	"Jahrestag"
],
	"\u0000Antarctica\u0001": [
	"Antarktis"
],
	"\u0000Anti-virus warning\u0001": [
	"Anti-Virus-Warnung"
],
	"\u0000Any recipient\u0001": [
	"Irgendein Empfänger"
],
	"\u0000Anyone on the internet with the link can view the calendar.\u0001": [
	"Jeder im Internet mit dem Link kann den Kalender anzeigen."
],
	"\u0000Anyone on the internet with the link can view the file.\u0001": [
	"Jeder im Internet mit dem Link kann die Datei anzeigen."
],
	"\u0000Anyone on the internet with the link can view the folder.\u0001": [
	"Jeder im Internet mit dem Link kann den Ordner anzeigen."
],
	"\u0000Anyone with the public link and invited people\u0001": [
	"Jeder mit dem öffentlichen Link und eingeladene Personen"
],
	"\u0000Anyone with the public link and listed people\u0001": [
	"Jeder mit dem öffentlichen Link und aufgeführte Personen"
],
	"\u0000App\u0001": [
	"App"
],
	"\u0000App Launcher\u0001": [
	"App Launcher"
],
	"\u0000App Store\u0001": [
	"App Store"
],
	"\u0000Apple Mail\u0001": [
	"Apple Mail"
],
	"\u0000Apple Maps\u0001": [
	"Apple Maps"
],
	"\u0000Application\u0001": [
	"Applikation"
],
	"\u0000Application Passwords\u0001": [
	"Applikationspasswörter"
],
	"\u0000Application may not work as expected until this problem is solved.\u0001": [
	"Die Applikation wird möglicherweise nicht erwartungsgemäß funktionieren, bevor dieses Problem nicht behoben ist."
],
	"\u0000Apply\u0001": [
	"Anwenden"
],
	"\u0000Apply changes\u0001": [
	"Änderungen übernehmen"
],
	"\u0000Apply filter\u0001": [
	"Filter anwenden"
],
	"\u0000Apply rule\u0001": [
	"Regel anwenden"
],
	"\u0000Apply rule if all conditions are met\u0001": [
	"Regel anwenden, wenn alle Bedingungen erfüllt sind"
],
	"\u0000Apply rule if any condition is met\u0001": [
	"Regel anwenden, wenn irgendeine Bedingung erfüllt ist"
],
	"\u0000Apply to all subfolders\u0001": [
	"Auf alle Unterordner anwenden"
],
	"\u0000Appointment\u0001": [
	"Termin"
],
	"\u0000Appointment Details\u0001": [
	"Termin-Details"
],
	"\u0000Appointment color\u0001": [
	"Terminfarbe"
],
	"\u0000Appointment details now have an indicator when the appointment is about to begin\u0001": [
	"Bei den Termindetails wird nun die Zeit bis zum Start des Termins angezeigt"
],
	"\u0000Appointment has attachments\u0001": [
	"Termin enthält Anhänge"
],
	"\u0000Appointment has participants\u0001": [
	"Termin enthält Teilnehmer"
],
	"\u0000Appointment has resources\u0001": [
	"Termin enthält Ressourcen"
],
	"\u0000Appointment invitation\u0001": [
	"Termineinladung"
],
	"\u0000Appointment invitations, changes or deletions\u0001": [
	"Termineinladung, -änderung oder -löschung"
],
	"\u0000Appointment is confidential\u0001": [
	"Termin ist vertraulich"
],
	"\u0000Appointment is declined\u0001": [
	"Der Termin wurde abgelehnt"
],
	"\u0000Appointment is part of a series\u0001": [
	"Termin ist Teil einer Serie"
],
	"\u0000Appointment is private\u0001": [
	"Termin ist privat"
],
	"\u0000Appointment options\u0001": [
	"Terminoptionen"
],
	"\u0000Appointment participants are now sorted by their confirmation status\u0001": [
	"Terminteilnehmer werden jetzt nach ihrem Bestätigungsstatus sortiert"
],
	"\u0000Appointment reminder\u0001": [
	"Terminerinnerung"
],
	"\u0000Appointment reminders\u0001": [
	"Terminerinnerungen"
],
	"\u0000Appointment title\u0001": [
	"Termintitel"
],
	"\u0000Appointment types\u0001": [
	"Terminarten"
],
	"\u0000Appointment was changed in the meantime and was updated accordingly.\u0001": [
	"Der Termin wurde zwischenzeitlich geändert und entsprechend aktualisiert."
],
	"\u0000Appointments\u0001": [
	"Termine"
],
	"\u0000Appointments in public calendars\u0001": [
	"Termine in öffentlichen Kalendern"
],
	"\u0000Appointments in shared calendars\u0001": [
	"Termine in freigegebenen Kalendern"
],
	"\u0000Approved: %1$s\u0001": [
	"Genehmigt: %1$s"
],
	"\u0000Apps\u0001": [
	"Apps"
],
	"folder\u0000Archive\u0001": [
	"Archiv"
],
	"verb\u0000Archive\u0001": [
	"Archivieren"
],
	"\u0000Archive email\u0001": [
	"E-Mail archivieren"
],
	"\u0000Archive messages\u0001": [
	"Nachrichten archivieren"
],
	"\u0000Archive old messages\u0001": [
	"Alte Nachrichten archivieren"
],
	"\u0000Archives\u0001": [
	"Archive"
],
	"\u0000Archives larger than the selected size will be split into multiple files.\u0001": [
	"Überschreitet die Archivgröße die gewählte Größe, dann wird das Archiv in mehrere Dateien aufgeteilt."
],
	"\u0000Archiving messages…\u0001": [
	"Nachrichten werden archiviert…"
],
	"\u0000Are you sure you want to sign out from all related browser tabs?\u0001": [
	"Sind Sie sicher, dass Sie sich von allen damit verbundenen Browser-Tabs abmelden möchten?"
],
	"\u0000Are you sure?\u0001": [
	"Sind Sie sich sicher?"
],
	"\u0000As incoming mail server\u0001": [
	"Wie eingehender Mailserver"
],
	"\u0000Ascending\u0001": [
	"Aufsteigend"
],
	"\u0000Asia\u0001": [
	"Asien"
],
	"\u0000Ask before replying to a mailing list\u0001": [
	"Vor dem Antworten an eine Mailingliste fragen"
],
	"\u0000Ask before showing external images\u0001": [
	"Vor dem Anzeigen externer Bilder fragen"
],
	"\u0000Ask for mailto link registration\u0001": [
	"Mailto-Link-Registrierung anfordern"
],
	"\u0000Assistant\u0001": [
	"Assistent"
],
	"\u0000Atlantic\u0001": [
	"Atlantik"
],
	"\u0000Attach Vcard\u0001": [
	"Visitenkarte anhängen"
],
	"\u0000Attached file\u0001": [
	"Angehängte Datei"
],
	"\u0000Attachment\u0001": [
	"Anhang"
],
	"\u0000Attachment file size too large. You have to use %1$s or reduce the attachment file size.\u0001": [
	"Der Anhang ist zu groß. Sie müssen %1$s verwenden oder die Dateigröße des Anhangs reduzieren."
],
	"\u0000Attachment has been saved\u0001": [
	"Anhang wurde gespeichert"
],
	"\u0000Attachment name\u0001": [
	"Name des Anhangs"
],
	"\u0000Attachments\u0001": [
	"Anhänge"
],
	"\u0000Attachments have been saved\u0001": [
	"Anhänge wurden gespeichert"
],
	"\u0000Audio\u0001": [
	"Audio"
],
	"\u0000Audio files\u0001": [
	"Audiodateien"
],
	"\u0000Australia\u0001": [
	"Australien"
],
	"\u0000Authentication\u0001": [
	"Authentifizierung"
],
	"\u0000Authentication Code\u0001": [
	"Authentifizierungscode"
],
	"\u0000Authentication code\u0001": [
	"Authentifizierungscode"
],
	"\u0000Authentication details\u0001": [
	"Authentifizierungsdetails"
],
	"\u0000Authentication failure. Please try reloading the page.\u0001": [
	"Authentifizierung gescheitert. Bitte versuchen Sie, die Seite neu zu laden."
],
	"\u0000Authenticator Registration\u0001": [
	"Authenticator-Registrierung"
],
	"\u0000Author\u0001": [
	"Autor"
],
	"\u0000Author (create/edit/delete appointments)\u0001": [
	"Autor (Termine anlegen/bearbeiten/löschen)"
],
	"\u0000Author (create/edit/delete emails)\u0001": [
	"Autor (E-Mails erstellen/bearbeiten/löschen)"
],
	"\u0000Auto dark mode\u0001": [
	"Automatischer Dunkelmodus"
],
	"\u0000Auto forward\u0001": [
	"Automatische Weiterleitung"
],
	"\u0000Auto forwarding is active\u0001": [
	"Automatische Weiterleitung ist aktiv"
],
	"\u0000Auto-configuration failed. Do you want to configure your account manually?\u0001": [
	"Automatische Konfiguration fehlgeschlagen. Wollen Sie Ihr Konto manuell konfigurieren?"
],
	"\u0000Automatic Configuration\u0001": [
	"Automatische Konfiguration"
],
	"\u0000Automatic Configuration (via SMS)\u0001": [
	"Automatische Konfiguration (über SMS)"
],
	"\u0000Automatic configuration\u0001": [
	"Automatische Konfiguration"
],
	"\u0000Automatic email address collection\u0001": [
	"Automatisches Sammeln von E-Mail-Adressen"
],
	"\u0000Automatic sign out\u0001": [
	"Automatisch abmelden"
],
	"\u0000Automatically apply appointment changes received via email to your calendar\u0001": [
	"Automatische Übernahme von per E-Mail empfangenen Terminänderungen in Ihren Kalender"
],
	"\u0000Automatically copy comprehensive dial-in information to the appointment description field\u0001": [
	"Umfassende Einwahlinformationen automatisch in das Terminbeschreibungsfeld kopieren"
],
	"\u0000Automatically copy the meeting join link to the appointment location field\u0001": [
	"Den Link zum Beitritt zur Besprechung automatisch in das Feld für den Terminort kopieren"
],
	"\u0000Automatically creates a \"Collected addresses\" folder for email addresses you interact with.\u0001": [
	"Erstellt automatisch den Ordner \"Gesammelte Adressen\" für E-Mail-Adressen, mit denen Sie interagieren."
],
	"\u0000Automatically delete the invitation email after the appointment has been accepted or declined\u0001": [
	"Die E-Mail-Benachrichtigung nach Bestätigen oder Ablehnen des Termins automatisch löschen"
],
	"\u0000Automatically mark all day appointments as \"free\" when creating or editing appointments\u0001": [
	"Beim Erstellen oder Bearbeiten von Terminen automatisch alle Tagestermine als \"Frei\" markieren"
],
	"\u0000Automatically open the notification area for new reminders\u0001": [
	"Infobereich bei neuen Erinnerungen automatisch öffnen"
],
	"\u0000Automatically switch to dark mode if this computer uses dark mode\u0001": [
	"Automatisch in den Dunkelmodus wechseln, wenn dieser Computer den Dunkelmodus verwendet"
],
	"\u0000B\u0001": [
	"B"
],
	"\u0000BCC\u0001": [
	"BCC"
],
	"\u0000Back\u0001": [
	"Zurück"
],
	"\u0000Back to list\u0001": [
	"Zurück zur Liste"
],
	"\u0000Back to sign in\u0001": [
	"Zurück zum Anmelden"
],
	"\u0000Backgrounds\u0001": [
	"Hintergründe"
],
	"\u0000Backup code to access your account.\u0001": [
	"Backup-Code zum Zugriff auf Ihr Konto."
],
	"\u0000Bad input or server error. Please try again.\u0001": [
	"Falsche Eingabe oder Serverfehler. Bitte erneut versuchen."
],
	"\u0000Bad parameters for authenticating with this key. Possibly wrong URL domain for this key.\u0001": [
	"Falsche Parameter für die Authentifizierung mit diesem Schlüssel. Möglicherweise falsche URL-Domain für diesen Schlüssel."
],
	"\u0000Bad verification code. Please try again\u0001": [
	"Falscher Bestätigungscode. Bitte erneut versuchen."
],
	"\u0000Bcc\u0001": [
	"BCC"
],
	"\u0000Be careful with this message. It might be spam or a phishing mail.\u0001": [
	"Seien Sie vorsichtig mit dieser Nachricht. Es kann sich um Spam oder eine Phishing-Mail handeln."
],
	"\u0000Beach\u0001": [
	"Strand"
],
	"\u0000Before\u0001": [
	"Vor"
],
	"\u0000Before you can continue using the product, you have to enter some basic information. It will take less than a minute.\u0001": [
	"Bevor Sie mit der Verwendung des Produkts fortfahren, müssen Sie einige grundlegende Informationen eingeben. Dies wird weniger als eine Minute in Anspruch nehmen."
],
	"\u0000Behavior\u0001": [
	"Verhalten"
],
	"\u0000Bell\u0001": [
	"Klingel"
],
	"\u0000Big mobile UI makeover\u0001": [
	"Neugestaltung der Benutzeroberfläche für Mobilgeräte"
],
	"\u0000Big settings makeover\u0001": [
	"Umfangreiche Umgestaltung der Einstellungen"
],
	"\u0000Billing information\u0001": [
	"Rechnungsinformation"
],
	"\u0000Birthday\u0001": [
	"Geburtstag"
],
	"\u0000Birthdays\u0001": [
	"Geburtstage"
],
	"\u0000Black\u0001": [
	"Schwarz"
],
	"\u0000Blind copy\u0001": [
	"Blindkopie"
],
	"BCC\u0000Blind copy\u0001": [
	"Blindkopie"
],
	"\u0000Blocked time frame\u0001": [
	"Blockierter Zeitrahmen"
],
	"\u0000Blue\u0001": [
	"Blau"
],
	"\u0000Body\u0001": [
	"Textteil"
],
	"\u0000Bold\u0001": [
	"Fett"
],
	"\u0000Booking behavior\u0001": [
	"Buchungsverhalten"
],
	"\u0000Booking requests are automatically accepted if the resource is free.\u0001": [
	"Buchungsanfragen werden automatisch bestätigt, wenn die Ressource frei ist."
],
	"\u0000Booking requests for this resource need manual approval. Notifications will be sent automatically to resource delegates who will then take care of booking requests.\u0001": [
	"Buchungsanfragen für diese Ressource müssen manuell genehmigt werden. Benachrichtigungen werden automatisch an Ressourcenbeauftragte gesendet, die sich dann um die Buchungsanfragen kümmern."
],
	"\u0000Branches\u0001": [
	"Branchen"
],
	"\u0000Brown\u0001": [
	"Braun"
],
	"\u0000Browse categories\u0001": [
	"Kategorien durchsuchen"
],
	"\u0000Browse in categories: In our latest update, we're excited to unveil the new category browser. This innovative feature allows users to effortlessly search and navigate through items tagged under any category in a single place, regardless of their type - be it emails, contacts, appointments, or tasks.\u0001": [
	"Kategorien durchsuchen: Wir freuen uns, Ihnen mit unserem aktuellen Update den neuen Kategorie-Browser vorstellen zu dürfen. Diese innovative Funktion ermöglicht Benutzern eine mühelose Suche und Navigation durch Elemente, die anhand ihrer Kennzeichnung unter einer beliebigen Kategorie an einem einzigen Ort eingeordnet sind, seien es E-Mails, Kontakte, Termine oder Aufgaben."
],
	"\u0000Browser back/forward navigation\u0001": [
	"Zurück/Vor-Browsernavigation"
],
	"\u0000Business\u0001": [
	"Geschäftlich"
],
	"\u0000Business (Company, Department, Position)\u0001": [
	"Geschäftlich (Firma, Abteilung, Position)"
],
	"\u0000Business Address\u0001": [
	"Geschäftsanschrift"
],
	"\u0000Business address\u0001": [
	"Geschäftsanschrift"
],
	"\u0000Business category\u0001": [
	"Geschäftskategorie"
],
	"\u0000CC\u0001": [
	"CC"
],
	"\u0000CSV\u0001": [
	"CSV"
],
	"\u0000CW\u0001": [
	"KW"
],
	"\u0000CW %1$d\u0001": [
	"KW %1$d"
],
	"\u0000CalDAV\u0001": [
	"CalDAV"
],
	"\u0000CalDAV URL\u0001": [
	"CalDAV URL"
],
	"\u0000Calendar\u0001": [
	"Kalender"
],
	"app\u0000Calendar\u0001": [
	"Kalender"
],
	"app\u0000Calendar (CalDav)\u0001": [
	"Kalender (CalDav)"
],
	"\u0000Calendar account error\u0001": [
	"Kalender-Kontofehler"
],
	"\u0000Calendar name\u0001": [
	"Kalendername"
],
	"\u0000Calendar options\u0001": [
	"Kalenderoptionen"
],
	"\u0000Calendar view\u0001": [
	"Kalenderansicht"
],
	"\u0000Calendar was not imported. Only .ics and .ical files are supported.\u0001": [
	"Der Kalender wurde nicht importiert. Es werden nur .ics- und .ical-Dateien unterstützt."
],
	"\u0000Calendars\u0001": [
	"Kalender"
],
	"\u0000Call\u0001": [
	"Anruf"
],
	"verb\u0000Call\u0001": [
	"Anrufen"
],
	"\u0000Call via %s\u0001": [
	"Über %s anrufen"
],
	"\u0000Call via Zoom\u0001": [
	"Über Zoom anrufen"
],
	"\u0000Camera %1$s\u0001": [
	"Kamera %1$s"
],
	"\u0000Cancel\u0001": [
	"Abbrechen"
],
	"\u0000Cancel download request\u0001": [
	"Download-Anfrage abbrechen"
],
	"\u0000Cancel search\u0001": [
	"Suche abbrechen"
],
	"\u0000Cancel send\u0001": [
	"Senden abbrechen"
],
	"\u0000Canceled\u0001": [
	"Verworfen"
],
	"\u0000Cannot add contact with an invalid email address: %1$s\u0001": [
	"Kontakt mit einer ungültigen E-Mail-Adresse kann nicht hinzugefügt werden: %1$s"
],
	"\u0000Cannot connect to server. Please check your connection.\u0001": [
	"Keine Verbindung zum Server. Bitte prüfen Sie Ihre Verbindung."
],
	"\u0000Cannot establish secure connection. Do you want to proceed anyway?\u0001": [
	"Es kann keine sichere Verbindung hergestellt werden. Wollen Sie trotzdem fortfahren?"
],
	"\u0000Cannot find any messages this contact sent to you.\u0001": [
	"Es wurden keine Nachrichten von diesem Kontakt an Sie gefunden."
],
	"\u0000Cannot find any messages you sent to this contact.\u0001": [
	"Es wurden keine Nachrichten von Ihnen an diesen Kontakt gefunden."
],
	"\u0000Cannot find user with given name.\u0001": [
	"Es wurde kein Benutzer mit dem angegebenen Namen gefunden."
],
	"\u0000Cannot print these items\u0001": [
	"Diese Objekte können nicht gedruckt werden"
],
	"\u0000Cannot print this item\u0001": [
	"Dieses Objekt kann nicht gedruckt werden"
],
	"\u0000Cannot require a view type for %1$s\u0001": [
	"Ein Ansichtstyp für %1$s kann nicht angefordert werden"
],
	"\u0000Capture\u0001": [
	"Aufnahmedetails"
],
	"\u0000CardDAV\u0001": [
	"CardDAV"
],
	"\u0000CardDAV URL\u0001": [
	"CardDAV-URL"
],
	"\u0000Categories\u0001": [
	"Kategorien"
],
	"\u0000Categories for emails\u0001": [
	"Kategorien für E-Mails"
],
	"\u0000Category\u0001": [
	"Kategorie"
],
	"\u0000Category browser\u0001": [
	"Kategorie-Browser"
],
	"\u0000Category name\u0001": [
	"Kategorienname"
],
	"\u0000Cc\u0001": [
	"CC"
],
	"\u0000Cc: %1$s\u0001": [
	"CC: %1$s"
],
	"\u0000Cell phone\u0001": [
	"Mobiltelefon"
],
	"\u0000Cell phone (alt)\u0001": [
	"Mobiltelefon (2)"
],
	"\u0000Certificate details\u0001": [
	"Zertifikatsdetails"
],
	"\u0000Certificates\u0001": [
	"Zertifikate"
],
	"\u0000Change\u0001": [
	"Ändern"
],
	"\u0000Change IMAP subscriptions\u0001": [
	"IMAP-Abonnements ändern"
],
	"\u0000Change appointment\u0001": [
	"Termin ändern"
],
	"\u0000Change appointment confirmation\u0001": [
	"Terminbestätigung ändern"
],
	"\u0000Change appointment reminders\u0001": [
	"Terminerinnerungen ändern"
],
	"\u0000Change confirmation\u0001": [
	"Bestätigung ändern"
],
	"\u0000Change confirmation for resource %1$s\u0001": [
	"Bestätigungsstatus für Ressource %1$s ändern"
],
	"\u0000Change contact photo\u0001": [
	"Kontaktfoto ändern"
],
	"\u0000Change due date\u0001": [
	"Fälligkeitsdatum ändern"
],
	"\u0000Change login password\u0001": [
	"Anmeldepasswort ändern"
],
	"\u0000Change organizer\u0001": [
	"Organisator ändern"
],
	"\u0000Change participation\u0001": [
	"Teilnahme ändern"
],
	"\u0000Change password\u0001": [
	"Passwort ändern"
],
	"\u0000Change password and sign out\u0001": [
	"Passwort ändern und abmelden"
],
	"\u0000Change photo\u0001": [
	"Foto ändern"
],
	"\u0000Change quick launch bar\u0001": [
	"Schnellstartleiste ändern"
],
	"\u0000Change reminders\u0001": [
	"Erinnerungen ändern"
],
	"\u0000Change series\u0001": [
	"Serie ändern"
],
	"\u0000Change time zone\u0001": [
	"Zeitzone ändern"
],
	"\u0000Change user photo\u0001": [
	"Benutzerfoto ändern"
],
	"\u0000Change who has access?\u0001": [
	"Ändern, wer Zugriff hat?"
],
	"\u0000Changed due date\u0001": [
	"Fälligkeitsdatum wurde geändert"
],
	"\u0000Changes have been saved\u0001": [
	"Änderungen wurden gespeichert"
],
	"\u0000Changing language or timezone requires a page reload or relogin to take effect.\u0001": [
	"Das Ändern der Sprache oder Zeitzone erfordert ein erneutes Laden der Seite oder ein erneutes Anmelden, damit die Änderungen wirksam werden."
],
	"\u0000Checkboxes\u0001": [
	"Kontrollfelder"
],
	"\u0000Children\u0001": [
	"Kinder"
],
	"\u0000Chimes\u0001": [
	"Glockenspiel"
],
	"\u0000Choose a device\u0001": [
	"Wählen Sie ein Gerät"
],
	"\u0000Choose a sending date and time for your email.\u0001": [
	"Wählen Sie Datum und Uhrzeit für das Senden Ihrer E-Mail."
],
	"\u0000Choose a theme\u0001": [
	"Theme wählen"
],
	"\u0000Choose an application\u0001": [
	"Wählen Sie eine Applikation"
],
	"\u0000Choose folder\u0001": [
	"Ordner wählen"
],
	"\u0000City\u0001": [
	"Stadt"
],
	"\u0000Clean up\u0001": [
	"Aufräumen"
],
	"\u0000Cleaning up…\u0001": [
	"Aufräumen…"
],
	"\u0000Clear\u0001": [
	"Löschen"
],
	"\u0000Clear selection\u0001": [
	"Auswahl zurücksetzen"
],
	"\u0000Click <b>Install</b> in the popup.\u0001": [
	"Klicken Sie im Popup auf <b>Installieren</b>."
],
	"\u0000Click on <b>Install</b> in the popup.\u0001": [
	"Klicken Sie im Popup auf <b>Installieren</b>."
],
	"\u0000Click on the application that you would like to use.\u0001": [
	"Klicken Sie auf die Applikation, die Sie verwenden möchten."
],
	"\u0000Click on the install icon\u0001": [
	"Klicken Sie auf das Installationssymbol"
],
	"\u0000Click on the sharing icon\u0001": [
	"Klicken Sie auf das Freigabesymbol"
],
	"\u0000Click the More button\u0001": [
	"Klicken Sie auf die Schaltfläche Weitere Aktionen"
],
	"\u0000Click the install icon\u0001": [
	"Klicken Sie auf das Installationssymbol"
],
	"\u0000Click to copy URL to clipboard\u0001": [
	"Zum Kopieren der URL in die Zwischenablage bitte hier klicken"
],
	"\u0000Click to merge all folders into one column\u0001": [
	"Zum Zusammenführen aller Ordner in einer Spalte bitte hier klicken"
],
	"\u0000Click to split all folders into separate columns\u0001": [
	"Zum Aufteilen aller Ordner in separate Spalten bitte hier klicken"
],
	"\u0000Client onboarding\u0001": [
	"Client-Onboarding"
],
	"\u0000Close\u0001": [
	"Schließen"
],
	"\u0000Close description panel\u0001": [
	"Beschreibungspanel schließen"
],
	"\u0000Close folder view\u0001": [
	"Ordneransicht schließen"
],
	"\u0000Close menu\u0001": [
	"Menü schließen"
],
	"\u0000Close settings\u0001": [
	"Einstellungen schließen"
],
	"\u0000Close slideshow\u0001": [
	"Diashow schließen"
],
	"\u0000Close this notification\u0001": [
	"Diese Benachrichtigung schließen"
],
	"\u0000Close viewer\u0001": [
	"Viewer schließen"
],
	"\u0000Close window\u0001": [
	"Fenster schließen"
],
	"\u0000Code via text message\u0001": [
	"Code per SMS"
],
	"\u0000Collapse form\u0001": [
	"Formular ausblenden"
],
	"\u0000Color\u0001": [
	"Farbe"
],
	"\u0000Color %1$s\u0001": [
	"%1$s einfärben"
],
	"\u0000Comma is not allowed.\u0001": [
	"Kommas sind nicht erlaubt."
],
	"\u0000Comments and suggestions\u0001": [
	"Kommentare und Anregungen"
],
	"\u0000Commercial Register\u0001": [
	"Handelsregister"
],
	"\u0000Common name\u0001": [
	"Allgemeiner Name"
],
	"\u0000Compact\u0001": [
	"Kompakt"
],
	"\u0000Companies\u0001": [
	"Firmen"
],
	"\u0000Company\u0001": [
	"Firma"
],
	"\u0000Compose & Reply\u0001": [
	"Verfassen & Antworten"
],
	"\u0000Compose & reply\u0001": [
	"Verfassen & antworten"
],
	"\u0000Compose email with external images\u0001": [
	"E-Mail mit externen Bildern verfassen"
],
	"\u0000Compose email without external images\u0001": [
	"E-Mail ohne externe Bilder verfassen"
],
	"\u0000Conditions\u0001": [
	"Bedingungen"
],
	"\u0000Conference\u0001": [
	"Konferenz"
],
	"\u0000Configuration Email\u0001": [
	"Konfigurations-E-Mail"
],
	"\u0000Configuration not supported\u0001": [
	"Konfiguration nicht unterstützt"
],
	"\u0000Configure %s\u0001": [
	"%s konfigurieren"
],
	"\u0000Configure a specific device or application\u0001": [
	"Konfigurieren Sie ein bestimmtes Gerät oder eine Applikation"
],
	"\u0000Configure categories\u0001": [
	"Kategorien konfigurieren"
],
	"\u0000Configure inbox categories\u0001": [
	"Posteingangskategorien konfigurieren"
],
	"\u0000Configure manually\u0001": [
	"Manuell konfigurieren"
],
	"\u0000Configure quick launch bar\u0001": [
	"Schnellstartleiste konfigurieren"
],
	"\u0000Configure the notification area\u0001": [
	"Konfigurieren Sie den Infobereich"
],
	"\u0000Configure your keyboard shortcut profile\u0001": [
	"Konfigurieren Sie Ihr Profil für Tastaturkürzel"
],
	"\u0000Confirm Code\u0001": [
	"Code bestätigen"
],
	"\u0000Confirm new password\u0001": [
	"Neues Passwort bestätigen"
],
	"\u0000Confirm recipient(s)\u0001": [
	"Empfänger bestätigen"
],
	"\u0000Confirmation\u0001": [
	"Bestätigung"
],
	"\u0000Conflicts\u0001": [
	"Konflikte"
],
	"\u0000Conflicts detected\u0001": [
	"Konflikt aufgetreten"
],
	"\u0000Conflicts with resources cannot be ignored\u0001": [
	"Ressourcen-Konflikte können nicht ignoriert werden"
],
	"\u0000Conflicts:\u0001": [
	"Konflikt:"
],
	"\u0000Connect\u0001": [
	"Verbinden"
],
	"\u0000Connect this device\u0001": [
	"Dieses Gerät verbinden"
],
	"\u0000Connect with Zoom\u0001": [
	"Mit Zoom verbinden"
],
	"\u0000Connect your device\u0001": [
	"Ihr Gerät verbinden"
],
	"\u0000Connect your device to your account in seconds\u0001": [
	"Verbinden Sie Ihr Gerät in Sekundenschnelle mit Ihrem Konto"
],
	"\u0000Connecting to Zoom…\u0001": [
	"Verbinden mit Zoom…"
],
	"\u0000Connection\u0001": [
	"Verbindung"
],
	"\u0000Connection error\u0001": [
	"Verbindungsfehler"
],
	"\u0000Connection security\u0001": [
	"Verbindungssicherheit"
],
	"\u0000Connection timed out. Please try reloading the page.\u0001": [
	"Zeitüberschreitung bei der Verbindung. Bittte versuchen Sie, die Seite neu zu laden."
],
	"\u0000Contact\u0001": [
	"Kontakt"
],
	"\u0000Contact \"%1$s\" deleted\u0001": [
	"Kontakt \"%1$s\" wurde gelöscht"
],
	"\u0000Contact \"%1$s\" moved\u0001": [
	"Kontakt \"%1$s\" wurde verschoben"
],
	"\u0000Contact Details\u0001": [
	"Kontakt-Details"
],
	"\u0000Contact has been copied\u0001": [
	"Kontakt wurde kopiert"
],
	"\u0000Contact has been moved\u0001": [
	"Kontakt wurde verschoben"
],
	"\u0000Contact list\u0001": [
	"Kontaktliste"
],
	"\u0000Contact list. Select a contact to view details.\u0001": [
	"Kontaktliste. Wählen Sie einen Kontakt, um Details anzuzeigen."
],
	"\u0000Contact pictures\u0001": [
	"Kontaktbilder"
],
	"\u0000Contacts\u0001": [
	"Kontakte"
],
	"\u0000Contacts account error\u0001": [
	"Kontaktkontofehler"
],
	"\u0000Contacts have been copied\u0001": [
	"Kontakte wurden kopiert"
],
	"\u0000Contacts have been moved\u0001": [
	"Kontakte wurden verschoben"
],
	"\u0000Contacts in address books\u0001": [
	"Kontakte in Adressbüchern"
],
	"\u0000Contacts in public address books\u0001": [
	"Kontakte in öffentlichen Adressbüchern"
],
	"\u0000Contacts in shared address books\u0001": [
	"Kontakte in freigegebenen Adressbüchern"
],
	"\u0000Contacts toolbar\u0001": [
	"Kontakte-Werkzeugleiste"
],
	"\u0000Contains\u0001": [
	"Enthält"
],
	"\u0000Contains not\u0001": [
	"Enthält nicht"
],
	"\u0000Contains words\u0001": [
	"Enthält Wörter"
],
	"\u0000Content\u0001": [
	"Inhalt"
],
	"\u0000Continue\u0001": [
	"Fortfahren"
],
	"\u0000Continue sign out\u0001": [
	"Abmeldung fortsetzen"
],
	"\u0000Continuous improvements\u0001": [
	"Kontinuierliche Verbesserungen"
],
	"\u0000Conversation\u0001": [
	"Konversation"
],
	"\u0000Conversations\u0001": [
	"Konversationen"
],
	"\u0000Copied to clipboard\u0001": [
	"In die Zwischenablage kopiert"
],
	"\u0000Copy\u0001": [
	"Kopieren"
],
	"CC\u0000Copy\u0001": [
	"Kopie"
],
	"\u0000Copy dial-in information to description\u0001": [
	"Einwahlinformationen in die Beschreibung kopieren"
],
	"\u0000Copy into\u0001": [
	"Kopieren nach"
],
	"\u0000Copy link\u0001": [
	"Link kopieren"
],
	"\u0000Copy link to clipboard\u0001": [
	"Link in Zwischenablage kopieren"
],
	"\u0000Copy link to location\u0001": [
	"Link in \"Ort\" kopieren"
],
	"\u0000Copy to clipboard\u0001": [
	"In die Zwischenablage kopieren"
],
	"\u0000Copy to location field\u0001": [
	"In Feld \"Ort\" kopieren"
],
	"\u0000Costs must be between -%1$d and %1$d.\u0001": [
	"Die Kosten müssen zwischen -%1$d und %1$d liegen."
],
	"\u0000Costs must only have two decimal places.\u0001": [
	"Die Kosten dürfen nur zwei Dezimalstellen haben."
],
	"\u0000Could not create PDF file.\u0001": [
	"PDF-Datei konnte nicht erstellt werden."
],
	"\u0000Could not create deputy.\u0001": [
	"Der Stellvertreter konnte nicht angelegt werden."
],
	"\u0000Could not delete folder. This can be due to insufficient permissions in your trash folder or this might be a special folder that cannot be deleted.\u0001": [
	"Der Ordner konnte nicht gelöscht werden. Dies kann an unzureichenden Berechtigungen für Ihren Papierkorb liegen oder es handelt sich um einen speziellen Ordner, der nicht gelöscht werden kann."
],
	"\u0000Could not find the requested appointment\u0001": [
	"Der gewünschte Termin konnte nicht gefunden werden"
],
	"\u0000Could not get a default folder for this application.\u0001": [
	"Für diese Applikation konnte kein Standardordner gefunden werden."
],
	"\u0000Could not get appointment information\u0001": [
	"Termininformationen konnten nicht abgerufen werden"
],
	"\u0000Could not load address book.\u0001": [
	"Das Adressbuch konnte nicht geladen werden."
],
	"\u0000Could not load attachments for this contact.\u0001": [
	"Die Anhänge zu diesem Kontakt konnten nicht geladen werden."
],
	"\u0000Could not load attachments for this task.\u0001": [
	"Die Anhänge zu dieser Aufgabe konnten nicht geladen werden."
],
	"\u0000Could not load contacts\u0001": [
	"Kontakte konnten nicht geladen werden"
],
	"\u0000Could not load data\u0001": [
	"Daten konnten nicht geladen werden"
],
	"\u0000Could not load deputy data.\u0001": [
	"Stellvertreterdaten konnten nicht geladen werden."
],
	"\u0000Could not load this list\u0001": [
	"Diese Liste konnte nicht geladen werden"
],
	"\u0000Could not remove deputy.\u0001": [
	"Der Stellvertreter konnte nicht entfernt werden."
],
	"\u0000Could not save settings\u0001": [
	"Einstellungen konnten nicht gespeichert werden"
],
	"\u0000Could not save settings.\u0001": [
	"Einstellungen konnten nicht gespeichert werden."
],
	"\u0000Could not save settings. There has to be at least one user with administration rights.\u0001": [
	"Einstellungen konnten nicht gespeichert werden. Es muss mindestens einen Benutzer mit administrativen Rechten geben."
],
	"\u0000Could not update deputy permissions.\u0001": [
	"Die Berechtigungen für den Stellvertreter konnten nicht aktualisiert werden."
],
	"\u0000Couldn't load appointment data.\u0001": [
	"Termindaten konnten nicht geladen werden."
],
	"\u0000Couldn't load contact data.\u0001": [
	"Kontaktdaten konnten nicht geladen werden."
],
	"\u0000Couldn't load editor\u0001": [
	"Editor konnte nicht geladen werden"
],
	"\u0000Couldn't load that task.\u0001": [
	"Die Aufgabe konnte nicht geladen werden."
],
	"\u0000Couldn't load your mail rules.\u0001": [
	"Ihre E-Mailfilterregeln konnten nicht geladen werden."
],
	"\u0000Countdown\u0001": [
	"Countdown"
],
	"\u0000Country\u0001": [
	"Land"
],
	"\u0000Create\u0001": [
	"Anlegen"
],
	"\u0000Create Flickr photo stream\u0001": [
	"Flickr-Fotostream erstellen"
],
	"\u0000Create additional passwords with limited access\u0001": [
	"Erstellen Sie zusätzliche Passwörter mit eingeschränktem Zugriff"
],
	"\u0000Create all-day appointment\u0001": [
	"Ganztägigen Termin anlegen"
],
	"\u0000Create appointment\u0001": [
	"Termin anlegen"
],
	"\u0000Create category\u0001": [
	"Kategorie erstellen"
],
	"\u0000Create distribution list\u0001": [
	"Verteilerliste erstellen"
],
	"\u0000Create folder\u0001": [
	"Ordner anlegen"
],
	"\u0000Create in public calendar\u0001": [
	"In öffentlichem Kalender anlegen"
],
	"\u0000Create list\u0001": [
	"Liste erstellen"
],
	"\u0000Create new Zoom meeting\u0001": [
	"Neues Zoom-Meeting erstellen"
],
	"\u0000Create new group\u0001": [
	"Neue Gruppe erstellen"
],
	"\u0000Create new resource\u0001": [
	"Neue Ressource erstellen"
],
	"\u0000Create new rule\u0001": [
	"Neue Regel erstellen"
],
	"\u0000Create objects\u0001": [
	"Objekte anlegen"
],
	"\u0000Create objects and subfolders\u0001": [
	"Objekte und Unterordner anlegen"
],
	"\u0000Create reminder\u0001": [
	"Erinnerung erstellen"
],
	"\u0000Create sharing link\u0001": [
	"Freigabelink erstellen"
],
	"\u0000Create task\u0001": [
	"Aufgabe erstellen"
],
	"\u0000Created\u0001": [
	"Erstellt"
],
	"\u0000Created by: %1$s\u0001": [
	"Erstellt von: %1$s"
],
	"\u0000Creating %s conference…\u0001": [
	"%s-Konferenz wird erstellt…"
],
	"\u0000Ctrl\u0001": [
	"Strg"
],
	"\u0000Currency\u0001": [
	"Währung"
],
	"\u0000Current date\u0001": [
	"Aktuelles Datum"
],
	"\u0000Current folder\u0001": [
	"Aktueller Ordner"
],
	"\u0000Current list\u0001": [
	"Aktuelle Liste"
],
	"\u0000Current organizer\u0001": [
	"Aktueller Organisator"
],
	"\u0000Current page\u0001": [
	"Aktuelle Seite"
],
	"\u0000Current role\u0001": [
	"Aktuelle Rolle"
],
	"\u0000Currently refreshing\u0001": [
	"Es wird aktualisiert"
],
	"\u0000Currently there are no compatible webcams available on your device.\u0001": [
	"Derzeit sind keine kompatiblen Webcams auf Ihrem Gerät verfügbar."
],
	"\u0000Custom font size when reading unformatted mails\u0001": [
	"Benutzerdefinierte Schriftgröße beim Lesen unformatierter E-Mails"
],
	"\u0000Custom name\u0001": [
	"Benutzerdefinierter Name"
],
	"\u0000Customize date and time formats\u0001": [
	"Datums- und Uhrzeitformate anpassen"
],
	"\u0000Customize the font, size and color styles of emails you compose.\u0001": [
	"Passen Sie Schriftart, -größe und -farbe der von Ihnen verfassten E-Mails an."
],
	"\u0000Customized\u0001": [
	"Benutzerdefiniert"
],
	"\u0000Cyan\u0001": [
	"Cyan"
],
	"\u0000Daily\u0001": [
	"Täglich"
],
	"\u0000Daily on workdays\u0001": [
	"Täglich an Werktagen"
],
	"\u0000Dark\u0001": [
	"Dunkel"
],
	"\u0000Dark Blue\u0001": [
	"Dunkelblau"
],
	"\u0000Dark Gray\u0001": [
	"Dunkelgrau"
],
	"\u0000Dark Purple\u0001": [
	"Dunkelviolett"
],
	"\u0000Dark Red\u0001": [
	"Dunkelrot"
],
	"\u0000Dark Turquoise\u0001": [
	"Dunkeltürkis"
],
	"\u0000Dark mode\u0001": [
	"Dunkelmodus"
],
	"\u0000Dark mode is now also available on mobile devices\u0001": [
	"Der Dunkelmodus ist jetzt auch auf mobilen Geräten verfügbar"
],
	"\u0000Dark theme\u0001": [
	"Dunkles Theme"
],
	"\u0000Data imported successfully\u0001": [
	"Daten wurden erfolgreich importiert"
],
	"\u0000Data only partially imported (%1$s of %2$s records)\u0001": [
	"Daten nur teilweise importiert (%1$s von %2$s Einträgen)"
],
	"\u0000Date\u0001": [
	"Datum"
],
	"\u0000Date completed\u0001": [
	"Datum der Fertigstellung"
],
	"\u0000Date format\u0001": [
	"Datumsformat"
],
	"\u0000Date must be in the future.\u0001": [
	"Das Datum muss in der Zukunft liegen."
],
	"\u0000Date of birth\u0001": [
	"Geburtstag"
],
	"\u0000Date range\u0001": [
	"Datumsbereich"
],
	"\u0000Date: %1$s\u0001": [
	"Datum: %1$s"
],
	"\u0000Day\u0001": [
	"Tag"
],
	"\u0000Day view\u0001": [
	"Tagesansicht"
],
	"\u0000Days between notices to the same sender\u0001": [
	"Anzahl Tage zwischen einer Benachrichtigung an denselben Absender"
],
	"\u0000Decline\u0001": [
	"Ablehnen"
],
	"appointment participation status\u0000Decline\u0001": [
	"Ablehnen"
],
	"\u0000Declined\u0001": [
	"Abgelehnt"
],
	"\u0000Declined the new participant\u0001": [
	"Der neue Teilnehmer wurde abgelehnt"
],
	"\u0000Declined: %d\u0001": [
	"Abgelehnt: %d"
],
	"\u0000Default\u0001": [
	"Standard"
],
	"\u0000Default address\u0001": [
	"Standardadresse"
],
	"\u0000Default calendar\u0001": [
	"Standardkalender"
],
	"\u0000Default reminder\u0001": [
	"Standarderinnerung"
],
	"\u0000Default reminder for all day appointments\u0001": [
	"Standarderinnerung für ganztägige Termine"
],
	"\u0000Default reminder for all-day appointments\u0001": [
	"Standarderinnerung für ganztägige Termine"
],
	"\u0000Default reminder for appointments in birthday calendar\u0001": [
	"Standarderinnerung für Termine im Geburtstagskalender"
],
	"\u0000Default reminder for birthdays\u0001": [
	"Standarderinnerung für Geburtstage"
],
	"\u0000Default sender\u0001": [
	"Standardabsender"
],
	"\u0000Default sender address\u0001": [
	"Standard-Absenderadresse"
],
	"\u0000Default signature\u0001": [
	"Standardsignatur"
],
	"\u0000Default signature for new mails\u0001": [
	"Standardsignatur für neue E-Mails"
],
	"\u0000Default signature on reply or forward\u0001": [
	"Standardsignatur bei Antwort oder Weiterleitung"
],
	"\u0000Default text style\u0001": [
	"Standard-Textstil"
],
	"\u0000Deferred\u0001": [
	"Verschoben"
],
	"\u0000Define message format, default text style, undo send\u0001": [
	"Definieren Sie das Nachrichtenformat und den Standardtextstil sowie die Funktion \"Senden zurücknehmen\""
],
	"\u0000Define name format and map service\u0001": [
	"Definieren Sie das Namensformat und den Kartendienst"
],
	"\u0000Define rules for handling incoming emails\u0001": [
	"Definieren Sie Regeln für den Umgang mit eingehenden E-Mails"
],
	"\u0000Define the calendar time scale\u0001": [
	"Legen Sie die Kalenderzeitskala fest"
],
	"\u0000Define your favorite apps\u0001": [
	"Legen Sie Ihre bevorzugten Anwendungen fest"
],
	"\u0000Delete\u0001": [
	"Löschen"
],
	"\u0000Delete %1$s\u0001": [
	"%1$s löschen"
],
	"\u0000Delete Multifactor Device\u0001": [
	"Multifaktor-Gerät löschen"
],
	"\u0000Delete account\u0001": [
	"Konto löschen"
],
	"\u0000Delete all appointments\u0001": [
	"Alle Termine löschen"
],
	"\u0000Delete all future appointments\u0001": [
	"Alle zukünftigen Termine löschen"
],
	"\u0000Delete all messages\u0001": [
	"Alle Nachrichten löschen"
],
	"\u0000Delete all objects\u0001": [
	"Alle Objekte löschen"
],
	"\u0000Delete all previous versions\u0001": [
	"Alle vorherigen Versionen löschen"
],
	"\u0000Delete appointment\u0001": [
	"Termin löschen"
],
	"\u0000Delete calendar\u0001": [
	"Kalender löschen"
],
	"\u0000Delete category\u0001": [
	"Kategorie löschen"
],
	"\u0000Delete category %1$s\u0001": [
	"Kategorie %1$s löschen"
],
	"\u0000Delete contact\u0001": [
	"Kontakt löschen"
],
	"\u0000Delete contacts\u0001": [
	"Kontakte löschen"
],
	"\u0000Delete distribution list\u0001": [
	"Verteilerliste löschen"
],
	"\u0000Delete draft\u0001": [
	"Entwurf löschen"
],
	"\u0000Delete email\u0001": [
	"E-Mail löschen"
],
	"\u0000Delete files after expiration\u0001": [
	"Dateien nach Ablauf löschen"
],
	"\u0000Delete folder\u0001": [
	"Ordner löschen"
],
	"\u0000Delete forever\u0001": [
	"Dauerhaft löschen"
],
	"\u0000Delete group\u0001": [
	"Gruppe löschen"
],
	"\u0000Delete item\u0001": [
	"Objekt löschen"
],
	"\u0000Delete items\u0001": [
	"Objekte löschen"
],
	"\u0000Delete own objects\u0001": [
	"Eigene Objekte löschen"
],
	"\u0000Delete password\u0001": [
	"Passwort löschen"
],
	"\u0000Delete permissions\u0001": [
	"Löschberechtigungen"
],
	"\u0000Delete previous versions\u0001": [
	"Vorherige Versionen löschen"
],
	"\u0000Delete resource\u0001": [
	"Ressource löschen"
],
	"\u0000Delete resource calendar\u0001": [
	"Ressourcenkalender löschen"
],
	"\u0000Delete resource calendar group\u0001": [
	"Ressourcenkalendergruppe löschen"
],
	"\u0000Delete resource group\u0001": [
	"Ressourcengruppe löschen"
],
	"\u0000Delete rule\u0001": [
	"Regel löschen"
],
	"\u0000Delete signature\u0001": [
	"Signatur löschen"
],
	"\u0000Delete task\u0001": [
	"Aufgabe löschen"
],
	"tooltip\u0000Delete task\u0001": [
	"Aufgabe löschen"
],
	"\u0000Delete tasks\u0001": [
	"Aufgaben löschen"
],
	"\u0000Delete template\u0001": [
	"Vorlage löschen"
],
	"\u0000Delete this appointment\u0001": [
	"Diesen Termin löschen"
],
	"\u0000Delete version\u0001": [
	"Version löschen"
],
	"\u0000Delete widget\u0001": [
	"Widget löschen"
],
	"\u0000Deleted a Contact? Restore It!\u0001": [
	"Kontakt gelöscht? Wiederherstellen!"
],
	"folder\u0000Deleted messages\u0001": [
	"Gelöschte Nachrichten"
],
	"\u0000Deleting messages on local storage also deletes them on server\u0001": [
	"Beim Löschen von Nachrichten aus dem lokalen Speicher werden diese auch auf dem Server gelöscht"
],
	"\u0000Deletion in progress…\u0001": [
	"Löschvorgang läuft…"
],
	"\u0000Department\u0001": [
	"Abteilung"
],
	"\u0000Departments\u0001": [
	"Abteilungen"
],
	"\u0000Deputies can get access to your Inbox and Calendar.\u0001": [
	"Stellvertreter können Zugriff auf Ihren Posteingang und Kalender erhalten."
],
	"\u0000Deputy\u0001": [
	"Stellvertreter"
],
	"\u0000Deputy can send emails on your behalf\u0001": [
	"Der Stellvertreter kann in Ihrem Auftrag E-Mails versenden"
],
	"\u0000Deputy: %1$s\u0001": [
	"Stellvertreter: %1$s"
],
	"\u0000Descending\u0001": [
	"Absteigend"
],
	"\u0000Description\u0001": [
	"Beschreibung"
],
	"\u0000Description (optional)\u0001": [
	"Beschreibung (optional)"
],
	"\u0000Description has been copied\u0001": [
	"Die Beschreibung wurde kopiert"
],
	"\u0000Description text\u0001": [
	"Beschreibungstext"
],
	"\u0000Deselect all\u0001": [
	"Auswahl aufheben"
],
	"\u0000Desktop notifications\u0001": [
	"Desktop-Benachrichtigungen"
],
	"\u0000Desktop notifications are a convenient feature as they can still notify you even if you have multiple tabs open in your browser. You don't necessarily have to keep %1$s as the active tab or constantly check it to stay updated.\u0001": [
	"Desktop-Benachrichtigungen informieren Sie auch dann über neue Ereignisse, wenn Sie mehrere Tabs in Ihrem Browser geöffnet haben. So bleiben Sie immer auf dem neuesten Stand, auch wenn %1$s nicht im aktiven Tab läuft."
],
	"\u0000Desktop only\u0001": [
	"Nur Desktop"
],
	"\u0000Detail\u0001": [
	"Detail"
],
	"\u0000Detailed\u0001": [
	"Detailliert"
],
	"\u0000Detailed access rights\u0001": [
	"Detaillierte Zugriffsrechte"
],
	"\u0000Details\u0001": [
	"Details"
],
	"contact-print-dialog\u0000Details\u0001": [
	"Details"
],
	"\u0000Determine when and if an email is marked as read upon opening.\u0001": [
	"Bestimmen Sie, ob und wann eine E-Mail beim Öffnen als gelesen markiert wird."
],
	"\u0000Determine which folders are shown\u0001": [
	"Legen sie fest, welche Ordner angezeigt werden"
],
	"\u0000Device\u0001": [
	"Gerät"
],
	"\u0000Device is already registered\u0001": [
	"Gerät ist bereits registriert"
],
	"\u0000Device: %s\u0001": [
	"Gerät: %s"
],
	"\u0000Dial by your location\u0001": [
	"Einwahl nach aktuellem Standort"
],
	"\u0000Dial-in numbers\u0001": [
	"Einwahlnummern"
],
	"\u0000Dial-in passcode: %1$d\u0001": [
	"Einwahl-Passcode: %1$d"
],
	"\u0000Did you know that you can take %1$s with you? Just click this icon and choose 'Connect your device' from the menu.\u0001": [
	"Wussten Sie, dass Sie %1$s mitnehmen können? Klicken Sie einfach auf dieses Symbol und wählen Sie im Menü 'Ihr Gerät verbinden'."
],
	"\u0000Did you know?\u0001": [
	"Schon gewusst?"
],
	"\u0000Direct link\u0001": [
	"Direkter Link"
],
	"\u0000Disable\u0001": [
	"Deaktivieren"
],
	"\u0000Disable %1$s\u0001": [
	"%1$s deaktivieren"
],
	"\u0000Disable categories\u0001": [
	"Kategorien deaktivieren"
],
	"\u0000Disable keyboard shortcuts\u0001": [
	"Tastaturkürzel deaktivieren"
],
	"\u0000Disable widget\u0001": [
	"Widget deaktivieren"
],
	"\u0000Disabled\u0001": [
	"Deaktiviert"
],
	"\u0000Discard\u0001": [
	"Verwerfen"
],
	"\u0000Discard changes\u0001": [
	"Änderungen verwerfen"
],
	"dialog\u0000Discard changes\u0001": [
	"Änderungen verwerfen"
],
	"\u0000Discard mails from %1$s\u0001": [
	"E-Mails von %1$s verwerfen"
],
	"\u0000Discard mails to %1$s\u0001": [
	"E-Mails an %1$s verwerfen"
],
	"\u0000Discard mails with subject %1$s\u0001": [
	"E-Mails mit dem Betreff %1$s verwerfen"
],
	"\u0000Display name\u0001": [
	"Angezeigter Name"
],
	"\u0000Displaying file: %1$s\u0001": [
	"Anzeige der Datei: %1$s"
],
	"\u0000Distance\u0001": [
	"Entfernung"
],
	"\u0000Distribution List\u0001": [
	"Verteilerliste"
],
	"\u0000Distribution List Details\u0001": [
	"Details für Verteilerliste"
],
	"\u0000Distribution list\u0001": [
	"Verteilerliste"
],
	"\u0000Distribution list has been saved\u0001": [
	"Die Verteilerliste wurde gespeichert"
],
	"\u0000Distribution list with %1$d entry\u0001Distribution list with %1$d entries": [
	"Verteilerliste mit einem Eintrag",
	"Verteilerliste mit %1$d Einträgen"
],
	"\u0000Do not show\u0001": [
	"Nicht anzeigen"
],
	"\u0000Do not show again.\u0001": [
	"Nicht wieder anzeigen."
],
	"\u0000Do you really want to cancel the current download request?\u0001": [
	"Möchten Sie die aktuelle Download-Anfrage wirklich abbrechen?"
],
	"\u0000Do you really want to change the file extension from  \".%1$s\" to \".%2$s\" ?\u0001": [
	"Wollen Sie die Dateiendung wirklich von \".%1$s\" nach \".%2$s\" ändern?"
],
	"\u0000Do you really want to create an appointment <b>on behalf of the folder owner</b> or do you want to create an appointment <b>with the folder owner</b> in your own calendar?\u0001": [
	"Wollen Sie wirklich einen Termin <b>im Auftrag des Ordner-Eigentümers</b> anlegen oder wollen Sie einen Termin <b>mit dem Ordner-Eigentümer</b> in Ihrem eigenen Kalender anlegen?"
],
	"\u0000Do you really want to delete all previous versions except the current version?\u0001": [
	"Wollen Sie wirklich alle bisherigen Versionen außer der aktuellen Version löschen?"
],
	"\u0000Do you really want to delete calendar \"%s\"?\u0001": [
	"Wollen Sie Kalender %s wirklich löschen?"
],
	"\u0000Do you really want to delete folder \"%s\"?\u0001": [
	"Wollen Sie den Ordner \"%s\" wirklich löschen?"
],
	"\u0000Do you really want to delete resource calendar group \"%s\"?\u0001": [
	"Möchten Sie die Ressourcenkalendergruppe \"%s\" wirklich löschen?"
],
	"\u0000Do you really want to delete the category \"%s\"?\u0001": [
	"Wollen Sie die Kategorie \"%s\" wirklich löschen?"
],
	"\u0000Do you really want to delete the group \"%1$s\"? This action cannot be undone!\u0001": [
	"Wollen Sie die Gruppe \"%1$s\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!"
],
	"\u0000Do you really want to delete the resource \"%1$s\"? This action cannot be undone!\u0001": [
	"Wollen Sie die Ressource \"%1$s\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!"
],
	"\u0000Do you really want to delete the signature \"%1$s\"?\u0001": [
	"Möchten Sie die Signatur \"%1$s\" wirklich löschen?"
],
	"\u0000Do you really want to delete the template \"%1$s\"?\u0001": [
	"Möchten Sie die Vorlage \"%1$s\" wirklich löschen?"
],
	"\u0000Do you really want to delete these contacts?\u0001": [
	"Möchten Sie diese Kontakte wirklich löschen?"
],
	"\u0000Do you really want to delete these items?\u0001": [
	"Wollen Sie diese Objekte wirklich löschen?"
],
	"\u0000Do you really want to delete these tasks?\u0001": [
	"Wollen Sie diese Aufgaben wirklich löschen?"
],
	"\u0000Do you really want to delete this account?\u0001": [
	"Wollen Sie dieses Konto wirklich löschen?"
],
	"\u0000Do you really want to delete this appointment?\u0001": [
	"Wollen Sie diesen Termin wirklich löschen?"
],
	"\u0000Do you really want to delete this contact?\u0001": [
	"Wollen Sie diesen Kontakt wirklich löschen?"
],
	"\u0000Do you really want to delete this distribution list?\u0001": [
	"Wollen Sie diese Verteilerliste wirklich löschen?"
],
	"\u0000Do you really want to delete this item?\u0001": [
	"Wollen Sie dieses Objekt wirklich löschen?"
],
	"\u0000Do you really want to delete this password?\u0001": [
	"Möchten Sie dieses Passwort wirklich löschen?"
],
	"\u0000Do you really want to delete this rule?\u0001": [
	"Wollen Sie diese Regel wirklich löschen?"
],
	"\u0000Do you really want to delete this task?\u0001": [
	"Wollen Sie diese Aufgabe wirklich löschen?"
],
	"One file only\u0000Do you really want to delete this version?\u0001": [
	"Wollen Sie diese Version wirklich löschen?"
],
	"\u0000Do you really want to delete this widget?\u0001": [
	"Wollen Sie dieses Widget wirklich löschen?"
],
	"\u0000Do you really want to delete this widget? If you disable it, you can enable it again in the settings.\u0001": [
	"Möchten Sie dieses Widget wirklich löschen? Wenn Sie es deaktivieren, können Sie es in den Einstellungen wieder aktivieren."
],
	"\u0000Do you really want to discard all changes?\u0001": [
	"Möchten Sie wirklich alle Änderungen verwerfen?"
],
	"\u0000Do you really want to discard your changes?\u0001": [
	"Wollen Sie Ihre Änderungen wirklich verwerfen?"
],
	"\u0000Do you really want to empty folder \"%s\"?\u0001": [
	"Wollen Sie den Inhalt des Ordners \"%s\" wirklich löschen?"
],
	"\u0000Do you really want to remove all shares?\u0001": [
	"Möchten Sie wirklich alle Freigaben entfernen?"
],
	"\u0000Do you really want to remove the extension \".%1$s\" from your filename?\u0001": [
	"Wollen Sie die Namenserweiterung \".%1$s\" wirklich aus dem Dateinamen entfernen?"
],
	"\u0000Do you really want to remove this certificate?\u0001": [
	"Wollen Sie dieses Zertifikat wirklich entfernen?"
],
	"\u0000Do you really want to sign out from all clients except the current one?\u0001": [
	"Wollen Sie sich wirklich von allen Clients mit Ausnahme des aktuellen abmelden?"
],
	"\u0000Do you really want to sign out from all devices except the current one?\u0001": [
	"Möchten Sie sich wirklich von allen Geräten außer dem aktuellen abmelden?"
],
	"\u0000Do you really want to sign out from that device?\u0001": [
	"Wollen Sie sich wirklich von diesem Gerät abmelden?"
],
	"\u0000Do you want the appointments printed in detail or as a compact list?\u0001": [
	"Wollen Sie die Termine im Detail oder als kompakte Liste drucken?"
],
	"\u0000Do you want to edit the whole series or just this appointment within the series?\u0001": [
	"Wollen Sie die gesamte Serie oder nur diesen Termin aus der Serie bearbeiten?"
],
	"\u0000Do you want to edit this and all future appointments or just this appointment within the series?\u0001": [
	"Wollen Sie diesen Termin und alle zukünftigen Termine oder nur diesen Termin aus der Serie bearbeiten?"
],
	"\u0000Do you want to edit this and all future appointments or the whole series?\u0001": [
	"Wollen Sie diesen Termin und alle zukünftigen Termine oder die gesamte Serie bearbeiten?"
],
	"\u0000Do you want to forward for the whole series or just this appointment within the series?\u0001": [
	"Möchten Sie für die gesamte Serie oder nur für diesen Termin innerhalb der Serie weiterleiten?"
],
	"\u0000Do you want to move all messages from %1$s to that category?\u0001": [
	"Wollen Sie alle Nachrichten von %1$s in diese Kategorie verschieben?"
],
	"\u0000Do you want to move all messages from selected senders to that category?\u0001": [
	"Wollen Sie alle Nachrichten der ausgewählten Absender in diese Kategorie verschieben?"
],
	"\u0000Do you want to permanently delete these mails?\u0001": [
	"Wollen Sie diese E-Mails unwiderruflich löschen?"
],
	"\u0000Do you want to permanently delete this email?\u0001": [
	"Wollen Sie diese E-Mail unwiderruflich löschen?"
],
	"\u0000Do you want to remove %1$s from your deputy list?\u0001": [
	"Möchten Sie %1$s aus Ihrer Stellvertreterliste entfernen?"
],
	"\u0000Do you want to reply all or just %1$s?\u0001": [
	"Möchten Sie allen oder nur %1$s antworten?"
],
	"\u0000Do you want to revoke the access of this application?\u0001": [
	"Wollen Sie den Zugriff dieser Applikation widerrufen?"
],
	"\u0000Document\u0001": [
	"Dokument"
],
	"\u0000Does not exist\u0001": [
	"Existiert nicht"
],
	"\u0000Domain\u0001": [
	"Domain"
],
	"\u0000Don't process subsequent rules of %1$s\u0001": [
	"Nachfolgende Regeln von %1$s nicht verarbeiten"
],
	"\u0000Don't remind me again\u0001": [
	"Nicht wieder erinnern"
],
	"\u0000Done\u0001": [
	"Erledigt"
],
	"\u0000Download\u0001": [
	"Herunterladen"
],
	"\u0000Download %1$s\u0001": [
	"%1$s herunterladen"
],
	"\u0000Download %1$s for %2$s now\u0001": [
	"%1$s für %2$s jetzt herunterladen"
],
	"\u0000Download %1$s for Windows\u0001": [
	"%1$s für Windows herunterladen"
],
	"\u0000Download %1$s.\u0001": [
	"%1$s herunterladen."
],
	"\u0000Download %s\u0001": [
	"%s herunterladen"
],
	"\u0000Download and Install\u0001": [
	"Herunterladen und Installieren"
],
	"\u0000Download configuration\u0001": [
	"Konfiguration herunterladen"
],
	"\u0000Download entire folder\u0001": [
	"Gesamten Ordner herunterladen"
],
	"\u0000Download infected file\u0001": [
	"Infizierte Datei herunterladen"
],
	"\u0000Download personal data\u0001": [
	"Persönliche Daten herunterladen"
],
	"\u0000Download profile\u0001": [
	"Profil herunterladen"
],
	"\u0000Download requested\u0001": [
	"Download angefordert"
],
	"\u0000Download the %1$s client for %2$s\u0001": [
	"%1$s-Client für %2$s herunterladen"
],
	"\u0000Download the application.\u0001": [
	"Laden Sie die Applikation herunter."
],
	"\u0000Download unscanned file\u0001": [
	"Datei ungeprüft herunterladen"
],
	"\u0000Download your personal data\u0001": [
	"Ihre persönlichen Daten herunterladen"
],
	"\u0000Drafts\u0001": [
	"Entwürfe"
],
	"folder\u0000Drafts\u0001": [
	"Entwürfe"
],
	"\u0000Drag to reorder items\u0001": [
	"Zum Neusortieren der Objekte ziehen"
],
	"\u0000Drag to reorder rules\u0001": [
	"Zum Neusortieren der Regeln ziehen"
],
	"\u0000Drag to reorder widget\u0001": [
	"Zum Ändern der Widget-Reihenfolge ziehen"
],
	"app\u0000Drive\u0001": [
	"Drive"
],
	"\u0000Drive Client\u0001": [
	"Drive-Client"
],
	"\u0000Drop EML file here for import\u0001": [
	"Zum Importieren EML-Datei hier ablegen"
],
	"\u0000Drop ICS or ICAL files here to import\u0001": [
	"Zum Importieren ICS- oder ICAL-Dateien hier ablegen"
],
	"\u0000Drop attachments here\u0001": [
	"Anhänge hier ablegen"
],
	"\u0000Drop files or folders here to upload\u0001": [
	"Zum Hochladen Dateien oder Ordner hier ablegen"
],
	"\u0000Drop here\u0001": [
	"Hier ablegen"
],
	"\u0000Drop here to import this email\u0001": [
	"Zum Importieren der E-Mail hier ablegen"
],
	"\u0000Drop here to upload a <b class=\"dndignore\">new attachment</b>\u0001": [
	"Zum Hochladen eines <b class=\"dndignore\">neuen Anhangs</b> hier ablegen"
],
	"\u0000Drop here to upload a <b class=\"dndignore\">new file</b>\u0001": [
	"Zum Hochladen einer <b class=\"dndignore\">neuen Datei</b> hier ablegen"
],
	"\u0000Drop here to upload a <b class=\"dndignore\">new version</b>\u0001": [
	"Zum Hochladen einer <b class=\"dndignore\">neuen Version</b> hier ablegen"
],
	"\u0000Drop here to upload a <b class=\"dndignore\">new version</b> of \"%1$s\"\u0001": [
	"Zum Hochladen einer <b class=\"dndignore\">neuen Version</b> von \"%1$s\" hier ablegen"
],
	"\u0000Drop inline images here\u0001": [
	"Inline-Bilder hier ablegen"
],
	"\u0000Drop new version of \"%1$s\" here\u0001": [
	"Neue Version von \"%1$s\" hier ablegen"
],
	"\u0000Drop only a single file as new version.\u0001": [
	"Nur eine einzelne Datei als neue Version ablegen."
],
	"\u0000Due\u0001": [
	"Fällig"
],
	"\u0000Due Date | %1$s\u0001": [
	"Fälligkeitsdatum | %1$s"
],
	"\u0000Due date\u0001": [
	"Fälligkeitstermin"
],
	"\u0000Due on %1$s\u0001": [
	"Fällig am %1$s"
],
	"\u0000Duration per image\u0001": [
	"Dauer pro Bild"
],
	"\u0000E-Mails will appear in a new window. These windows can be maximized, minimized and closed.\u0001": [
	"E-Mails erscheinen in einem neuen Fenster. Diese Fenster können maximiert, minimiert und geschlossen werden."
],
	"\u0000EAS\u0001": [
	"EAS"
],
	"\u0000EB\u0001": [
	"EB"
],
	"\u0000Easily undo actions like delete, archive, move or copy with a single click – no stress, no hassle, just instant control.\u0001": [
	"Machen Sie Aktionen wie Löschen, Archivieren, Verschieben oder Kopieren mit einem einzigen Klick rückgängig - ohne Stress, ohne Aufwand, einfach mit sofortiger Kontrolle."
],
	"\u0000Edit\u0001": [
	"Bearbeiten"
],
	"\u0000Edit %1$s\u0001": [
	"%1$s bearbeiten"
],
	"\u0000Edit Appointment\u0001": [
	"Termin bearbeiten"
],
	"\u0000Edit Contact\u0001": [
	"Kontakt bearbeiten"
],
	"\u0000Edit Flickr photo stream\u0001": [
	"Flickr Fotostream bearbeiten"
],
	"\u0000Edit Multifactor Device\u0001": [
	"Multifaktor-Gerät bearbeiten"
],
	"\u0000Edit accounts\u0001": [
	"Konten bearbeiten"
],
	"\u0000Edit all future appointments\u0001": [
	"Alle zukünftigen Termine bearbeiten"
],
	"\u0000Edit all objects\u0001": [
	"Alle Objekte bearbeiten"
],
	"\u0000Edit all reminders for calendar: %1$s\u0001": [
	"Alle Erinnerungen für folgenden Kalender bearbeiten: %1$s"
],
	"\u0000Edit appointment\u0001": [
	"Termin bearbeiten"
],
	"\u0000Edit category\u0001": [
	"Kategorie bearbeiten"
],
	"\u0000Edit category %1$s\u0001": [
	"Kategorie %1$s bearbeiten"
],
	"\u0000Edit contact\u0001": [
	"Kontakt bearbeiten"
],
	"\u0000Edit copy\u0001": [
	"Kopie bearbeiten"
],
	"\u0000Edit description\u0001": [
	"Beschreibung bearbeiten"
],
	"\u0000Edit distribution list\u0001": [
	"Verteilerliste bearbeiten"
],
	"\u0000Edit draft\u0001": [
	"Entwurf bearbeiten"
],
	"\u0000Edit email account\u0001": [
	"E-Mail-Konto bearbeiten"
],
	"\u0000Edit group\u0001": [
	"Gruppe bearbeiten"
],
	"\u0000Edit names\u0001": [
	"Namen bearbeiten"
],
	"\u0000Edit own objects\u0001": [
	"Eigene Objekte bearbeiten"
],
	"\u0000Edit personal data\u0001": [
	"Persönliche Daten bearbeiten"
],
	"\u0000Edit real names\u0001": [
	"Realnamen bearbeiten"
],
	"\u0000Edit recurrence\u0001": [
	"Wiederholung bearbeiten"
],
	"\u0000Edit reminders\u0001": [
	"Erinnerungen bearbeiten"
],
	"\u0000Edit resource\u0001": [
	"Ressource bearbeiten"
],
	"\u0000Edit rule\u0001": [
	"Regel bearbeiten"
],
	"\u0000Edit series\u0001": [
	"Serie bearbeiten"
],
	"\u0000Edit share\u0001": [
	"Freigabe bearbeiten"
],
	"\u0000Edit signature\u0001": [
	"Signatur bearbeiten"
],
	"\u0000Edit signatures\u0001": [
	"Signatur bearbeiten"
],
	"\u0000Edit subscription\u0001": [
	"Abonnement bearbeiten"
],
	"\u0000Edit task\u0001": [
	"Aufgabe bearbeiten"
],
	"\u0000Edit template\u0001": [
	"Vorlage bearbeiten"
],
	"\u0000Edit templates\u0001": [
	"Vorlage bearbeiten"
],
	"\u0000Edit this appointment\u0001": [
	"Diesen Termin bearbeiten"
],
	"\u0000Edit to set a name.\u0001": [
	"Bearbeiten, um einen Namen hinzuzufügen."
],
	"\u0000Editing this email will discard the sending schedule.\u0001": [
	"Wenn Sie diese E-Mail bearbeiten, wird der geplante Versand verworfen."
],
	"\u0000Editor\u0001": [
	"Editor"
],
	"\u0000Editor (create/edit appointments)\u0001": [
	"Editor (Termine erstellen/bearbeiten)"
],
	"\u0000Editor (create/edit emails)\u0001": [
	"Editor (E-Mails erstellen/bearbeiten)"
],
	"\u0000Email\u0001": [
	"E-Mail"
],
	"\u0000Email %1$n of %2$n has been imported\u0001": [
	"E-Mail %1$n von %2$n wurde importiert"
],
	"\u0000Email '%1$s' archived\u0001": [
	"E-Mail '%1$s' archiviert"
],
	"\u0000Email '%1$s' deleted\u0001": [
	"E-Mail '%1$s' gelöscht"
],
	"\u0000Email 1\u0001": [
	"E-Mail 1"
],
	"\u0000Email 2\u0001": [
	"E-Mail 2"
],
	"\u0000Email 3\u0001": [
	"E-Mail 3"
],
	"\u0000Email account\u0001": [
	"E-Mail-Konto"
],
	"\u0000Email actions\u0001": [
	"E-Mail-Aktionen"
],
	"\u0000Email address\u0001": [
	"E-Mail-Adresse"
],
	"\u0000Email aliases\u0001": [
	"E-Mail-Aliase"
],
	"\u0000Email contains external images\u0001": [
	"E-Mail enthält externe Bilder"
],
	"\u0000Email content\u0001": [
	"E-Mail-Inhalt"
],
	"\u0000Email copied to folder '%1$s'\u0001": [
	"E-Mail in Ordner '%1$s' kopiert"
],
	"\u0000Email display name\u0001": [
	"E-Mail-Anzeigename"
],
	"\u0000Email from %1$s: %2$s\u0001": [
	"E-Mail von %1$s: %2$s"
],
	"\u0000Email has an attachment\u0001": [
	"E-Mail enthält einen Anhang"
],
	"\u0000Email has been copied\u0001": [
	"E-Mail wurde kopiert"
],
	"\u0000Email has been forwarded\u0001": [
	"E-Mail wurde weitergeleitet"
],
	"\u0000Email has been imported\u0001": [
	"E-Mail wurde importiert"
],
	"\u0000Email has been moved\u0001": [
	"E-Mail wurde verschoben"
],
	"\u0000Email has been replied\u0001": [
	"E-Mail wurde beantwortet"
],
	"\u0000Email has no recipient.\u0001": [
	"Die E-Mail hat keinen Empfänger."
],
	"\u0000Email list and reading pane arrangement\u0001": [
	"Anordnung der E-Mail-Liste und des Lesebereichs"
],
	"\u0000Email list item\u0001": [
	"Element der E-Mail-Liste"
],
	"\u0000Email may contain external images\u0001": [
	"E-Mail kann externe Bilder enthalten"
],
	"\u0000Email moved to folder '%1$s'\u0001": [
	"E-Mail in Ordner '%1$s' verschoben"
],
	"\u0000Email notifications\u0001": [
	"E-Mail-Benachrichtigungen"
],
	"\u0000Email reminder\u0001": [
	"E-Mail-Erinnerung"
],
	"\u0000Email reminder for\u0001": [
	"E-Mail-Erinnerung für"
],
	"\u0000Email size: %1$s\u0001": [
	"E-Mail-Größe: %1$s"
],
	"\u0000Email source\u0001": [
	"E-Mail-Quelldaten"
],
	"\u0000Email subject\u0001": [
	"E-Mail-Betreff"
],
	"\u0000Email was not imported. Only .eml files are supported.\u0001": [
	"Die E-Mail wurde nicht importiert. Es werden nur .eml-Dateien unterstützt."
],
	"\u0000Email with %1$s\u0001": [
	"E-Mails über %1$s"
],
	"\u0000Email with Android Mail\u0001": [
	"E-Mails über Android Mail"
],
	"\u0000Emails\u0001": [
	"E-Mails"
],
	"\u0000Emails (%1$s)\u0001": [
	"E-Mails (%1$s)"
],
	"\u0000Emails cannot be put into trash folder while your mail quota is exceeded.\u0001": [
	"E-Mails können nicht in den Papierkorb verschoben werden, solange das E-Mail-Speicherlimit überschritten ist."
],
	"\u0000Emails have been copied\u0001": [
	"E-Mails wurden kopiert"
],
	"\u0000Emails have been moved\u0001": [
	"E-Mails wurden verschoben"
],
	"\u0000Emoticons\u0001": [
	"Emoticons"
],
	"\u0000Employee ID\u0001": [
	"Mitarbeiter-ID"
],
	"\u0000Employee type\u0001": [
	"Mitarbeiter-Typ"
],
	"\u0000Empty\u0001": [
	"Leer"
],
	"vgrid\u0000Empty\u0001": [
	"Leer"
],
	"\u0000Empty file attachment\u0001": [
	"Leerer Dateianhang"
],
	"\u0000Empty folder\u0001": [
	"Ordner leeren"
],
	"\u0000Empty name and description found.\u0001": [
	"Leeres Namens- und Beschreibungsfeld"
],
	"\u0000Empty subject\u0001": [
	"Kein Betreff"
],
	"\u0000Empty trash\u0001": [
	"Papierkorb leeren"
],
	"\u0000Enable\u0001": [
	"Aktivieren"
],
	"\u0000Enable %1$s\u0001": [
	"%1$s aktivieren"
],
	"\u0000Enable Links\u0001": [
	"Links aktivieren"
],
	"\u0000Enable or disable auto forward\u0001": [
	"Automatische Weiterleitung aktivieren / deaktivieren"
],
	"\u0000Enable or disable vacation notice\u0001": [
	"Abwesenheitsbenachrichtigung aktivieren / deaktivieren"
],
	"\u0000Enable this feature\u0001": [
	"Dieses Feature nutzen"
],
	"\u0000Encrypt the email\u0001": [
	"E-Mail verschlüsseln"
],
	"\u0000Encrypted\u0001": [
	"Verschlüsselt"
],
	"\u0000End\u0001": [
	"Ende"
],
	"\u0000End date time zone\u0001": [
	"Zeitzone für Enddatum"
],
	"\u0000End time\u0001": [
	"Endet um"
],
	"\u0000Ends\u0001": [
	"Endet"
],
	"\u0000Ends not with\u0001": [
	"Endet nicht auf"
],
	"\u0000Ends on\u0001": [
	"Endet am"
],
	"\u0000Ends with\u0001": [
	"Endet auf"
],
	"\u0000Enhance your email reading experience. %1$s now allows you to set custom font sizes for most emails, giving you more control and comfort.\u0001": [
	"Verbessern Sie Ihr E-Mail-Leseerlebnis. Mit %1$s können Sie jetzt für die meisten E-Mails benutzerdefinierte Schriftgrößen festlegen, was Ihnen mehr Kontrolle und Komfort bietet."
],
	"\u0000Enter Password\u0001": [
	"Passwort eingeben"
],
	"\u0000Enter document title here\u0001": [
	"Geben Sie hier den Dokumententitel ein"
],
	"\u0000Envelope\u0001": [
	"Envelope"
],
	"\u0000Error\u0001": [
	"Fehler"
],
	"\u0000Error authenticating. Please reload browser and try again.\u0001": [
	"Fehler bei der Authentifizierung. Laden Sie den Browser neu und versuchen Sie es erneut."
],
	"\u0000Error creating meeting\u0001": [
	"Fehler beim Erstellen des Meetings"
],
	"\u0000Error while playing the audio file. Either your browser does not support the format or you have connection problems.\u0001": [
	"Fehler beim Abspielen der Audiodatei. Entweder unterstützt Ihr Browser das Format nicht oder Sie haben Verbindungsprobleme."
],
	"\u0000Error while playing the video. Either your browser does not support the format or you have connection problems.\u0001": [
	"Fehler beim Abspielen des Videos. Entweder Ihr Browser unterstützt das Format nicht oder Sie haben Probleme mit der Verbindung."
],
	"\u0000Error while resolving email addresses. Please try again.\u0001": [
	"Fehler beim Auflösen der E-Mail-Adressen. Bitte versuchen Sie es erneut."
],
	"\u0000Error while uploading your image\u0001": [
	"Fehler beim Hochladen Ihres Bildes"
],
	"\u0000Error:\u0001": [
	"Fehler:"
],
	"\u0000Error: Failed to load appointments\u0001": [
	"Fehler: Termine konnten nicht geladen werden"
],
	"\u0000Error: Failed to load files\u0001": [
	"Fehler: Dateien konnten nicht geladen werden"
],
	"\u0000Error: Failed to load message content\u0001": [
	"Fehler: Inhalt der Nachricht konnte nicht geladen werden"
],
	"\u0000Error: Failed to load messages\u0001": [
	"Fehler: Nachrichten konnten nicht geladen werden"
],
	"\u0000Especially when organizing larger meetings, it is helpful to be able to designate certain participants as optional, as not everyone's attendance might be required.\u0001": [
	"Besonders bei der Organisation größerer Meetings ist es hilfreich, einzelne Teilnehmer als optional zu kennzeichnen, da nicht jeder teilnehmen muss."
],
	"\u0000Estimated costs\u0001": [
	"Geschätzte Kosten"
],
	"\u0000Estimated duration in minutes\u0001": [
	"Geschätzte Dauer in Minuten"
],
	"\u0000Europe\u0001": [
	"Europa"
],
	"daily\u0000Every %1$d day.\u0001Every %1$d days.": [
	"Alle %1$d Tage.",
	"Alle %1$d Tage."
],
	"monthly\u0000Every %1$d month on day %2$d.\u0001Every %1$d months on day %2$d.": [
	"Alle %1$d Monate am %2$d.",
	"Alle %1$d Monate am %2$d."
],
	"monthly\u0000Every %1$d month on the %2$s %3$s.\u0001Every %1$d months on the %2$s %3$s.": [
	"Alle %1$d Monate am %2$s %3$s.",
	"Alle %1$d Monate am %2$s %3$s."
],
	"weekly\u0000Every %1$d week on %2$s.\u0001Every %1$d weeks on %2$s.": [
	"Alle %1$d Wochen am %2$s.",
	"Alle %1$d Wochen am %2$s."
],
	"weekly\u0000Every %1$d week on all days.\u0001Every %1$d weeks on all days.": [
	"Täglich.",
	"Täglich alle %1$d Wochen."
],
	"weekly\u0000Every %1$d week on weekends.\u0001Every %1$d weeks on weekends.": [
	"Alle %1$d Wochen am Wochenende.",
	"Alle %1$d Wochen am Wochenende."
],
	"weekly\u0000Every %1$d week on workdays.\u0001Every %1$d weeks on workdays.": [
	"Alle %1$d Wochen an Werktagen.",
	"Alle %1$d Wochen an Werktagen."
],
	"weekly\u0000Every %1$s.\u0001": [
	"Jeden %1$s."
],
	"daily\u0000Every day.\u0001": [
	"Täglich."
],
	"monthly\u0000Every month on day %1$d.\u0001": [
	"Monatlich am %1$d."
],
	"monthly\u0000Every month on the %1$s %2$s.\u0001": [
	"Monatlich am %1$s %2$s."
],
	"weekly\u0000Every weekend.\u0001": [
	"Jedes Wochenende."
],
	"\u0000Every year in %1$s on day %2$d.\u0001": [
	"Jährlich am %2$d. %1$s."
],
	"\u0000Every year on the %1$s %2$s in %3$d.\u0001": [
	"Jährlich am %1$s %2$s im %3$d."
],
	"\u0000Everybody\u0001": [
	"Alle"
],
	"\u0000Exchange Active Sync\u0001": [
	"Exchange Active Sync"
],
	"\u0000Exchange Active Sync (EAS)\u0001": [
	"Exchange Active Sync (EAS)"
],
	"\u0000Existing passwords\u0001": [
	"Vorhandene Passwörter"
],
	"\u0000Exists\u0001": [
	"Existiert"
],
	"\u0000Expand form\u0001": [
	"Formular erweitern"
],
	"\u0000Expanded mobile feature set\u0001": [
	"Mehr Funktionen auf Mobilgeräten"
],
	"\u0000Expiration\u0001": [
	"Ablaufdatum"
],
	"\u0000Expired\u0001": [
	"Abgelaufen"
],
	"\u0000Expires on\u0001": [
	"Läuft ab am"
],
	"\u0000Export\u0001": [
	"Exportieren"
],
	"\u0000Export folder\u0001": [
	"Ordner exportieren"
],
	"\u0000Export selected\u0001": [
	"Auswahl exportieren"
],
	"\u0000External Apps\u0001": [
	"Externe Apps"
],
	"\u0000External contact\u0001": [
	"Externer Kontakt"
],
	"\u0000External email accounts are read-only\u0001": [
	"Externe E-Mail-Konten sind schreibgeschützt"
],
	"\u0000External images are not shown to avoid potential tracking\u0001": [
	"Externe Bilder werden nicht angezeigt, um eine mögliche Nachverfolgung zu verhindern"
],
	"\u0000External images in emails\u0001": [
	"Externe Bilder in E-Mails"
],
	"\u0000External images in this email use an insecure connection. Those images were automatically adjusted to enforce a secure connection (https). Some images might not be shown.\u0001": [
	"Die externen Bilder in dieser E-Mail verwenden eine unsichere Verbindung. Diese Bilder wurden automatisch angepasst, um eine sichere Verbindung (https) zu erzwingen. Einige Bilder werden möglicherweise nicht angezeigt."
],
	"\u0000External participants\u0001": [
	"Externe Teilnehmer"
],
	"\u0000Failed to add. Maybe the vCard attachment is invalid.\u0001": [
	"Hinzufügen ist fehlgeschlagen. Möglicherweise ist der vCard-Anhang ungültig."
],
	"\u0000Failed to automatically save current stage of work. Please save your work to avoid data loss in case the browser closes unexpectedly.\u0001": [
	"Das automatische Speichern der aktuellen Daten ist fehlgeschlagen. Bitte sichern Sie Ihre Änderungen, um einen Datenverlust bei einem Browser-Absturz zu verhindern."
],
	"\u0000Failed to connect.\u0001": [
	"Die Verbindung ist fehlgeschlagen."
],
	"\u0000Failed to import any data\u0001": [
	"Der Datenimport ist fehlgeschlagen"
],
	"\u0000Failed to recover accounts\u0001": [
	"Das Wiederherstellen der Konten ist fehlgeschlagen"
],
	"\u0000Failed to register device\u0001": [
	"Gerät konnte nicht registriert werden"
],
	"\u0000Failed to register device.\u0001": [
	"Gerät konnte nicht registriert werden."
],
	"\u0000Failed to save distribution list.\u0001": [
	"Die Verteilerliste konnte nicht gespeichert werden."
],
	"\u0000Failed to sign in\u0001": [
	"Das Anmelden ist fehlgeschlagen"
],
	"\u0000Failed to start application. Maybe you have connection problems. Please try again.\u0001": [
	"Die Applikation konnte nicht gestartet werden. Vielleicht haben Sie Verbindungsprobleme. Bitte versuchen Sie es erneut."
],
	"\u0000Failed to update confirmation status; most probably the appointment has been deleted.\u0001": [
	"Der Bestätigungsstatus konnte nicht aktualisiert werden. Der Termin wurde wahrscheinlich gelöscht."
],
	"\u0000Failed to update confirmation status; most probably the task has been deleted.\u0001": [
	"Der Bestätigungsstatus konnte nicht aktualisiert werden. Die Aufgabe wurde wahrscheinlich gelöscht."
],
	"\u0000Failure reason\u0001": [
	"Fehlerursache"
],
	"\u0000Favorite\u0001": [
	"Favoriten"
],
	"\u0000Favorites\u0001": [
	"Favoriten"
],
	"\u0000Fax\u0001": [
	"Fax"
],
	"\u0000Fax (Home)\u0001": [
	"Fax (privat)"
],
	"\u0000Fax (alt)\u0001": [
	"Fax (2)"
],
	"\u0000Feedback\u0001": [
	"Feedback"
],
	"\u0000Feedback could not be sent\u0001": [
	"Feedback konnte nicht gesendet werden"
],
	"\u0000File\u0001": [
	"Datei"
],
	"\u0000File %1$d of %2$d\u0001": [
	"Datei %1$d von %2$d"
],
	"\u0000File Details\u0001": [
	"Datei-Infos"
],
	"\u0000File description can only be %1$d characters long.\u0001": [
	"Die Dateibeschreibung darf nur %1$d Zeichen enthalten."
],
	"\u0000File details\u0001": [
	"Dateidetails"
],
	"\u0000File has been copied\u0001": [
	"Datei wurde kopiert"
],
	"\u0000File has been moved\u0001": [
	"Datei wurde verschoben"
],
	"\u0000File into\u0001": [
	"Speichern unter"
],
	"\u0000File names must not be empty\u0001": [
	"Dateinamen dürfen nicht leer sein."
],
	"\u0000File names must not contain colons\u0001": [
	"Dateinamen dürfen keine Doppelpunkte enthalten"
],
	"\u0000File names must not contain slashes\u0001": [
	"Dateinamen dürfen keine Schrägstriche enthalten."
],
	"\u0000File or folder name\u0001": [
	"Datei- oder Ordnername"
],
	"\u0000File storage\u0001": [
	"Dateispeicher"
],
	"\u0000File version history\u0001": [
	"Dateiversionshistorie"
],
	"\u0000File version limit\u0001": [
	"Dateiversionsbegrenzung"
],
	"\u0000File version table, the first row represents the current version.\u0001": [
	"Dateiversionstabelle. Die erste Zeile enthält die aktuelle Version."
],
	"\u0000Files\u0001": [
	"Dateien"
],
	"\u0000Files can not be uploaded, because upload limit of %1$s is exceeded.\u0001": [
	"Dateien können nicht hochgeladen werden, weil das Upload-Limit von%1$s überschritten wurde."
],
	"\u0000Files from selected email\u0001": [
	"Dateien von gewählter E-Mail"
],
	"\u0000Files have been copied\u0001": [
	"Dateien wurden kopiert"
],
	"\u0000Files have been moved\u0001": [
	"Dateien wurden verschoben"
],
	"\u0000Files options\u0001": [
	"Dateien-Optionen"
],
	"verb\u0000Filter\u0001": [
	"Filtern"
],
	"\u0000Filter address lists\u0001": [
	"Adresslisten filtern"
],
	"\u0000Find a free time\u0001": [
	"Verfügbaren Zeitraum finden"
],
	"\u0000Fingerprint\u0001": [
	"Fingerabdruck"
],
	"tour\u0000Finish\u0001": [
	"Beenden"
],
	"\u0000Finished moving\u0001": [
	"Verschieben abgeschlossen"
],
	"\u0000First category color is used for this appointment.\u0001": [
	"Für diesen Termin wird die erste Kategoriefarbe verwendet."
],
	"\u0000First day\u0001": [
	"Erster Tag"
],
	"\u0000First day of the week\u0001": [
	"Erster Tag der Woche"
],
	"\u0000First name\u0001": [
	"Vorname"
],
	"\u0000First name Last name\u0001": [
	"Vorname Nachname"
],
	"\u0000First name must not be empty for internal users\u0001": [
	"Vorname für interne Benutzer darf nicht leer sein"
],
	"\u0000First start wizard\u0001": [
	"Einrichtungsassistent"
],
	"\u0000First week of the year\u0001": [
	"Erste Woche des Jahres"
],
	"\u0000Fit to screen size\u0001": [
	"An Bildschirmgröße anpassen"
],
	"\u0000Fit to screen width\u0001": [
	"An Bildschirmbreite anpassen"
],
	"\u0000Flag\u0001": [
	"Markierung"
],
	"verb\u0000Flag\u0001": [
	"Markieren"
],
	"\u0000Flag mails from %1$s with a color\u0001": [
	"E-Mails von %1$s farbig kennzeichnen"
],
	"\u0000Flag mails to %1$s with a color\u0001": [
	"E-Mails an %1$s farbig kennzeichnen"
],
	"\u0000Flag mails with subject %1$s with a color\u0001": [
	"E-Mails mit dem Betreff %1$s farbig kennzeichnen"
],
	"\u0000Flagged\u0001": [
	"Markiert"
],
	"\u0000Flagged folder that contains flagged emails\u0001": [
	"Ordner \"Markiert\", der markierte E-Mails enthält"
],
	"\u0000Flagged messages\u0001": [
	"Markierte Nachrichten"
],
	"\u0000Flickr\u0001": [
	"Flickr"
],
	"\u0000Flowers\u0001": [
	"Blumen"
],
	"\u0000Focus search\u0001": [
	"Fokus auf Suchfeld"
],
	"\u0000Folder\u0001": [
	"Ordner"
],
	"\u0000Folder has been moved\u0001": [
	"Ordner wurde verschoben"
],
	"\u0000Folder name\u0001": [
	"Ordnername"
],
	"\u0000Folder names must not be empty\u0001": [
	"Verzeichnisnamen dürfen nicht leer sein."
],
	"\u0000Folder names must not contain colons\u0001": [
	"Ordnernamen dürfen keine Doppelpunkte enthalten"
],
	"\u0000Folder names must not contain slashes\u0001": [
	"Ordnernamen dürfen keine Schrägstriche enthalten."
],
	"\u0000Folder options\u0001": [
	"Ordneroptionen"
],
	"\u0000Folder view\u0001": [
	"Ordneransicht"
],
	"\u0000Folder with name \"%1$s\" will be hidden. Enable setting \"Show hidden files and folders\" to access this folder again.\u0001": [
	"Der Ordner namens \"%1$s\" wird ausgeblendet. Zum Zugreifen auf diesen Ordner müssen Sie die Einstellung \"Versteckte Dateien und Ordner anzeigen\" aktivieren."
],
	"\u0000Folder-specific actions\u0001": [
	"Ordnerspezifische Aktionen"
],
	"\u0000Folders\u0001": [
	"Ordner"
],
	"\u0000Folders have been moved\u0001": [
	"Ordner wurden verschoben"
],
	"\u0000Follow-up\u0001": [
	"Folgetermin"
],
	"\u0000Font\u0001": [
	"Schriftart"
],
	"\u0000Font size\u0001": [
	"Schriftgröße"
],
	"\u0000Font size can be configured in %1$s\u0001": [
	"Die Schriftgröße kann in %1$s konfiguriert werden"
],
	"\u0000For best results we recommend using Google Chrome for Android.\u0001": [
	"Für beste Ergebnisse empfehlen wir Google Chrome für Android."
],
	"\u0000For new messages\u0001": [
	"Für neue Nachrichten"
],
	"\u0000For security reasons, you will be signed out from all devices after enabling multifactor.\u0001": [
	"Aus Sicherheitsgründen werden Sie nach der Aktivierung der Multifaktor-Authentifizierung auf allen Geräten abgemeldet"
],
	"\u0000Force sign-out\u0001": [
	"Abmelden erzwingen"
],
	"\u0000Forcing sign-out may cause data loss.\u0001": [
	"Ein erzwungenes Abmelden kann zu Datenverlust führen."
],
	"\u0000Forgot attachment?\u0001": [
	"Anhang vergessen?"
],
	"\u0000Forgot your password?\u0001": [
	"Passwort vergessen?"
],
	"\u0000Format\u0001": [
	"Format"
],
	"\u0000Format: %1$s\u0001": [
	"Format: %1$s"
],
	"\u0000Formatting mails\u0001": [
	"E-Mails formatieren"
],
	"\u0000Forward\u0001": [
	"Weiterleiten"
],
	"\u0000Forward all incoming emails to this address\u0001": [
	"Alle eingehenden E-Mails an diese Adresse weiterleiten"
],
	"\u0000Forward appointment\u0001": [
	"Termin weiterleiten"
],
	"\u0000Forward email\u0001": [
	"E-Mail weiterleiten"
],
	"\u0000Forward emails as\u0001": [
	"E-Mails weiterleiten als"
],
	"\u0000Forward meeting invitations\u0001": [
	"Meeting-Einladungen weiterleiten"
],
	"\u0000Free\u0001": [
	"Frei"
],
	"superessive\u0000Friday\u0001": [
	"Freitag"
],
	"\u0000From\u0001": [
	"Von"
],
	"\u0000From:\u0001": [
	"Von:"
],
	"\u0000From: %1$s\u0001": [
	"Von: %1$s"
],
	"\u0000Furigana for company\u0001": [
	"Furigana für Firmennamen"
],
	"\u0000Furigana for first name\u0001": [
	"Furigana für Vornamen"
],
	"\u0000Furigana for last name\u0001": [
	"Furigana für Nachnamen"
],
	"\u0000GB\u0001": [
	"GB"
],
	"\u0000GPT/AI integration\u0001": [
	"GPT/KI-Integration"
],
	"\u0000General\u0001": [
	"Allgemein"
],
	"\u0000General shortcuts\u0001": [
	"Allgemeine Tastaturkürzel"
],
	"\u0000Get %s\u0001": [
	"Laden Sie sich %s"
],
	"\u0000Get started\u0001": [
	"Starten"
],
	"\u0000Get started here\u0001": [
	"Schnelleinstieg"
],
	"\u0000Get the App from %1$s\u0001": [
	"Laden Sie die App aus dem %1$s"
],
	"\u0000Get the App from %1$s.\u0001": [
	"Laden Sie die App aus dem %1$s."
],
	"\u0000Get the latest version from the \u0001": [
	"Laden Sie die aktuelle Version aus dem "
],
	"\u0000Get your device configured by email.\u0001": [
	"Lassen Sie Ihr Gerät per E-Mail konfigurieren."
],
	"\u0000Give feedback\u0001": [
	"Feedback geben"
],
	"\u0000Global address list\u0001": [
	"Globale Adressliste"
],
	"\u0000Gmail\u0001": [
	"Gmail"
],
	"\u0000Go to next decade\u0001": [
	"Weiter zum nächsten Jahrzehnt"
],
	"\u0000Go to next month\u0001": [
	"Weiter zum nächsten Monat"
],
	"\u0000Go to next year\u0001": [
	"Weiter zum nächsten Jahr"
],
	"\u0000Go to previous decade\u0001": [
	"Weiter zum vorherigen Jahrzehnt"
],
	"\u0000Go to previous month\u0001": [
	"Weiter zum vorherigen Monat"
],
	"\u0000Go to previous year\u0001": [
	"Weiter zum vorherigen Jahr"
],
	"\u0000Good evening, %s\u0001": [
	"Guten Abend, %s"
],
	"\u0000Good morning, %s\u0001": [
	"Guten Morgen, %s"
],
	"\u0000Google Authenticator\u0001": [
	"Google Authenticator"
],
	"\u0000Google Authenticator or compatible\u0001": [
	"Google Authenticator oder kompatibel"
],
	"\u0000Google Maps\u0001": [
	"Google Maps"
],
	"\u0000Google Play\u0001": [
	"Google Play Store"
],
	"\u0000Google subscription\u0001": [
	"Google-Abonnement"
],
	"\u0000Gray\u0001": [
	"Grau"
],
	"\u0000Greater\u0001": [
	"Größer"
],
	"\u0000Greater equals\u0001": [
	"Größer als oder gleich"
],
	"\u0000Green\u0001": [
	"Grün"
],
	"\u0000Group\u0001": [
	"Gruppe"
],
	"\u0000Group by\u0001": [
	"Gruppieren nach"
],
	"\u0000Group members\u0001": [
	"Gruppenmitglieder"
],
	"\u0000Group name\u0001": [
	"Gruppenname"
],
	"\u0000Group: %1$s\u0001": [
	"Gruppe: %1$s"
],
	"\u0000Groups\u0001": [
	"Gruppen"
],
	"\u0000Guest\u0001": [
	"Gast"
],
	"\u0000Guests are only allowed to have viewer rights.\u0001": [
	"Gäste dürfen nur Betrachter-Rechte haben."
],
	"\u0000Guided tour for this app\u0001": [
	"Guided Tour für diese App"
],
	"\u0000Guides new users through the initial setup, ensuring a seamless onboarding experience.\u0001": [
	"Führt neue Benutzer durch die Ersteinrichtung und sorgt so für einen reibungslosen Start."
],
	"\u0000HTML\u0001": [
	"HTML"
],
	"\u0000HTML and plain text\u0001": [
	"HTML und Text"
],
	"\u0000HTML formatted emails, like newsletters, will keep their original font size.\u0001": [
	"HTML-formatierte E-Mails, wie Newsletter, behalten ihre ursprüngliche Schriftgröße."
],
	"\u0000Has attachments\u0001": [
	"Enthält Anhänge"
],
	"\u0000Has color flag\u0001": [
	"Ist farbig markiert"
],
	"\u0000Have you heard about ChatGPT? With our brand-new AI integration, you can now take advantage of its exceptional abilities to read and respond to emails faster, more efficiently, and with more finesse. Say goodbye to the hassle of drafting emails, and let GPT make your life easier.\u0001": [
	"Haben Sie schon von ChatGPT gehört? Mit unserer brandneuen KI-Integration können Sie jetzt die außergewöhnlichen Fähigkeiten von ChatGPT nutzen, um E-Mails schneller, effizienter und mit mehr Finesse zu lesen und zu beantworten. Verabschieden Sie sich vom mühsamen Verfassen von E-Mails und lassen Sie GPT Ihr Leben einfacher machen."
],
	"\u0000Header\u0001": [
	"Header"
],
	"\u0000Hello %s\u0001": [
	"Hallo %s"
],
	"\u0000Hello World\u0001": [
	"Hallo Welt"
],
	"\u0000Help\u0001": [
	"Hilfe"
],
	"\u0000Hidden\u0001": [
	"Ausgeblendet"
],
	"\u0000Hidden address books\u0001": [
	"Ausgeblendete Adressbücher"
],
	"\u0000Hidden calendars\u0001": [
	"Ausgeblendete Kalender"
],
	"\u0000Hidden lists\u0001": [
	"Ausgeblendete Listen"
],
	"\u0000Hidden tasks folders\u0001": [
	"Ausgeblendete Aufgabenordner"
],
	"\u0000Hide\u0001": [
	"Ausblenden"
],
	"\u0000Hide blind carbon copy input field\u0001": [
	"Bcc-Eingabefeld ausblenden"
],
	"\u0000Hide carbon copy input field\u0001": [
	"Cc-Eingabefeld ausblenden"
],
	"\u0000Hide details\u0001": [
	"Details ausblenden"
],
	"\u0000Hide editor toolbar\u0001": [
	"Editor-Werkzeugleiste ausblenden"
],
	"\u0000Hide folder\u0001": [
	"Ordner ausblenden"
],
	"\u0000Hide non-working time\u0001": [
	"Nichtarbeitszeiten ausblenden"
],
	"\u0000Hide reply-to input field\u0001": [
	"Eingabefeld \"Antwort an\" ausblenden"
],
	"\u0000Hide toolbar\u0001": [
	"Werkzeugleiste ausblenden"
],
	"\u0000High\u0001": [
	"Hoch"
],
	"E-Mail priority\u0000High\u0001": [
	"Hoch"
],
	"Tasks priority\u0000High\u0001": [
	"Hoch"
],
	"\u0000High Priority\u0001": [
	"Hohe Priorität"
],
	"E-Mail\u0000High priority\u0001": [
	"Wichtigkeit: hoch"
],
	"\u0000Home\u0001": [
	"Privat"
],
	"\u0000Home Address\u0001": [
	"Privatanschrift"
],
	"\u0000Home address\u0001": [
	"Privatanschrift"
],
	"\u0000Horizontal\u0001": [
	"Horizontal"
],
	"\u0000Hostname\u0001": [
	"Hostname"
],
	"\u0000How can we improve your experience?\u0001": [
	"Wie können wir Ihr Nutzungserlebnis verbessern?"
],
	"\u0000How likely are you to recommend %1$s to a friend or colleague?\u0001": [
	"Wie wahrscheinlich ist es, dass Sie %1$s einem Freund oder Kollegen weiterempfehlen?"
],
	"\u0000How to resolve name conflicts\u0001": [
	"Bestimmen Sie, wie Namenskonflikte aufgelöst werden sollen"
],
	"rating\u0000I don't like it\u0001": [
	"Gefällt mir nicht"
],
	"rating\u0000I like it\u0001": [
	"Gefällt mir"
],
	"\u0000I lost my device\u0001": [
	"Ich habe mein Gerät verloren"
],
	"\u0000IMAP\u0001": [
	"IMAP"
],
	"\u0000IP phone\u0001": [
	"IP-Telefon"
],
	"\u0000IP: %s\u0001": [
	"IP: %s"
],
	"\u0000Icon\u0001": [
	"Symbol"
],
	"\u0000Icons\u0001": [
	"Symbole"
],
	"\u0000If a device is unfamiliar to you or you cannot explain where a session comes from, it is recommended to stop that session by clicking on \"Sign out\" in the corresponding row.\u0001": [
	"Wenn Ihnen ein Gerät unbekannt ist oder Sie sich nicht erklären können, woher eine Sitzung stammt, sollten Sie diese Sitzung beenden, indem Sie in der entsprechenden Zeile auf \"Abmelden\" klicken."
],
	"\u0000If an automatic configuration is not possible, please use manual configuration to set up your email account:\u0001": [
	"Wenn eine automatische Konfiguration nicht möglich ist, verwenden Sie bitte die manuelle Konfiguration, um Ihr E-Mail-Konto einzurichten:"
],
	"\u0000If scanning does not work, you may be able to enter the following setup code.\u0001": [
	"Wenn das Scannen nicht funktioniert, können Sie evtl. den folgenden Konfigurationscode eingeben."
],
	"\u0000If you change the password, you will be signed out. Please ensure that everything is closed and saved.\u0001": [
	"Wenn Sie das Passwort ändern, werden Sie abgemeldet. Bitte stellen Sie sicher, dass alles geschlossen und gesichert ist."
],
	"\u0000If you do not wish to keep an item, please click on the trash icon.\u0001": [
	"Wenn Sie ein Objekt nicht behalten wollen, klicken Sie bitte auf das Mülleimer-Symbol."
],
	"\u0000If you do not wish to keep the item, please click on the trash icon.\u0001": [
	"Wenn Sie das Objekt nicht behalten wollen, klicken Sie bitte auf das Mülleimer-Symbol."
],
	"\u0000If you have a busy day with many meetings, it is easy to overlook a meeting. To help you stay on top of your schedule, we have added a countdown that reminds you of your upcoming meetings with color, sound, and desktop notifications.\u0001": [
	"Wenn Sie einen vollen Tag mit vielen Terminen haben, kann es leicht passieren, dass Sie einen Termin übersehen. Damit Sie den Überblick über Ihren Terminplan behalten, haben wir einen Countdown hinzugefügt, der Sie mit Farbe, Ton und Desktop-Benachrichtigungen an Ihre bevorstehenden Besprechungen erinnert."
],
	"\u0000If you have a professional Zoom account, Zoom offers dial-in numbers per country and lets you choose which countries appear in meeting invitations.\u0001": [
	"Wenn Sie mindestens über ein Zoom Pro-Konto verfügen, bietet Zoom Einwahlnummern pro Land und lässt Sie auswählen, welche Länder in Meeting-Einladungen angezeigt werden."
],
	"\u0000If you use multiple email accounts, you can now assign individual signatures to each account.\u0001": [
	"Wenn Sie mehrere E-Mail-Konten verwenden, können Sie jetzt jedem Konto eigene Signaturen zuweisen."
],
	"\u0000Ignore\u0001": [
	"Ignorieren"
],
	"\u0000Ignore Warnings\u0001": [
	"Warnhinweise ignorieren"
],
	"\u0000Ignore conflicts\u0001": [
	"Konflikte ignorieren"
],
	"\u0000Ignore existing appointments\u0001": [
	"Vorhandene Termine ignorieren"
],
	"\u0000Ignore existing events\u0001": [
	"Vorhandene Ereignisse ignorieren"
],
	"\u0000Ignoring existing appointments is helpful to import public holiday calendars, for example.\u0001": [
	"Das Ignorieren vorhandener Termine ist z.B. beim Importieren von Feiertagskalendern hilfreich."
],
	"\u0000Image 1\u0001": [
	"Bild 1"
],
	"\u0000Image size\u0001": [
	"Bildgröße"
],
	"\u0000Image upload denied. Its resolution exceeds maximum allowed value of %1$s megapixels.\u0001": [
	"Das Hochladen des Bilds wurde verweigert. Seine Auflösung überschreitet den maximal zulässigen Wert von %1$s Megapixeln."
],
	"\u0000Image was reset to previous image.\u0001": [
	"Das Bild wurde auf das vorherige Bild zurückgesetzt."
],
	"\u0000Images\u0001": [
	"Bilder"
],
	"\u0000Immediately\u0001": [
	"Sofort"
],
	"\u0000Import\u0001": [
	"Importieren"
],
	"\u0000Import file\u0001": [
	"Datei importieren"
],
	"\u0000Import from URL (iCal)\u0001": [
	"Von URL (iCal) importieren"
],
	"\u0000Import from file\u0001": [
	"Aus Datei importieren"
],
	"\u0000Important\u0001": [
	"Wichtig"
],
	"\u0000Imported calendar\u0001": [
	"Importierter Kalender"
],
	"\u0000Imprint\u0001": [
	"Impressum"
],
	"\u0000In %1$d minutes\u0001": [
	"In %1$d Minuten"
],
	"\u0000In one hour\u0001": [
	"In einer Stunde"
],
	"\u0000In progress\u0001": [
	"In Bearbeitung"
],
	"\u0000In the event you lose or are unable to use your authentication device, your account will be locked out unless you set up a recovery method. We strongly recommend that you do so now.\u0001": [
	"Falls Sie Ihr Authentifizierungsgerät verlieren oder nicht verwenden können, wird Ihr Konto gesperrt. Es sei denn, Sie haben eine Wiederherstellungsmethode eingerichtet. Wir empfehlen Ihnen dringend, dies jetzt zu tun."
],
	"\u0000In the next few days\u0001": [
	"In den nächsten Tagen"
],
	"\u0000In the upcoming weeks\u0001": [
	"In den kommenden Wochen"
],
	"\u0000Inbox\u0001": [
	"Posteingang"
],
	"\u0000Inbox categories\u0001": [
	"Posteingangskategorien"
],
	"\u0000Inbox categories now have a cleaner appearance\u0001": [
	"Posteingangskategorien sind jetzt übersichtlicher gestaltet"
],
	"\u0000Include all file versions\u0001": [
	"Alle Dateiversionen einschließen"
],
	"\u0000Include distribution lists\u0001": [
	"Mit Verteilerlisten"
],
	"\u0000Included address books\u0001": [
	"Enthaltene Adressbücher"
],
	"\u0000Included calendars\u0001": [
	"Enthaltene Kalender"
],
	"\u0000Included folders\u0001": [
	"Enthaltene Ordner"
],
	"\u0000Includes all appointments from your calendars as ical files.\u0001": [
	"Enthält alle Termine aus Ihren Kalendern als ical-Dateien."
],
	"\u0000Includes all contact data from your address books as vcard files.\u0001": [
	"Enthält alle Kontaktdaten aus Ihren Adressbüchern als vcard-Dateien."
],
	"\u0000Includes all emails from your primary mail account as eml files.\u0001": [
	"Enthält alle E-Mails aus Ihrem primären E-Mail-Konto als eml-Dateien."
],
	"\u0000Includes all files from %1$s.\u0001": [
	"Enthält alle Dateien von %1$s."
],
	"\u0000Includes all tasks as ical files.\u0001": [
	"Enthält alle Aufgaben als ical-Dateien."
],
	"\u0000Incoming Server Settings (IMAP)\u0001": [
	"Einstellungen für eingehenden Server (IMAP)"
],
	"\u0000Incoming calls\u0001": [
	"Eingehende Anrufe"
],
	"\u0000Incoming server\u0001": [
	"Eingehender Server"
],
	"\u0000Incomplete configuration.\u0001": [
	"Unvollständige Konfiguration."
],
	"\u0000Inconsistent dates\u0001": [
	"Inkonsistente Datumsangaben"
],
	"\u0000Indian Ocean\u0001": [
	"Indischer Ozean"
],
	"\u0000Indigo\u0001": [
	"Indigo"
],
	"\u0000Info\u0001": [
	"Info"
],
	"\u0000Inline\u0001": [
	"Inliegend"
],
	"\u0000Insert\u0001": [
	"Einfügen"
],
	"\u0000Insert image\u0001": [
	"Bild einfügen"
],
	"\u0000Insert inline image\u0001": [
	"Bild-URL einfügen"
],
	"\u0000Insert link\u0001": [
	"Link einfügen"
],
	"\u0000Insert the original email text to a reply\u0001": [
	"Ursprünglichen E-Mail-Text in Antwort zitieren"
],
	"\u0000Inspect certificate\u0001": [
	"Zertifikat prüfen"
],
	"\u0000Install\u0001": [
	"Installieren"
],
	"\u0000Install %1$s\u0001": [
	"%1$s installieren"
],
	"\u0000Install %1$s like an app\u0001": [
	"Installieren Sie %1$s wie eine App"
],
	"\u0000Installation\u0001": [
	"Installation"
],
	"\u0000Instant Messenger 1\u0001": [
	"Instant Messenger 1"
],
	"\u0000Instant Messenger 2\u0001": [
	"Instant Messenger 2"
],
	"\u0000Instructions for installing %1$s like an app\u0001": [
	"Anleitungen für die Installation von %1$s wie eine App"
],
	"\u0000Internal user\u0001": [
	"Interner Benutzer"
],
	"\u0000Internal users only\u0001": [
	"Nur interne Benutzer"
],
	"\u0000Interval\u0001": [
	"Intervall"
],
	"\u0000Introducing keyboard shortcuts for a more efficient experience. With selectable presets, easily switch between Gmail and Outlook styles, streamlining your navigation and actions.\u0001": [
	"Einführung von Tastaturkürzeln für eine effizientere Nutzung. Mit auswählbaren Voreinstellungen können Sie ganz einfach zwischen Gmail- und Outlook-Stilen wechseln und so Ihre Navigation und Aktionen optimieren."
],
	"\u0000Invitation for: %1$s\u0001": [
	"Einladung zu: %1$s"
],
	"\u0000Invitation message (optional)\u0001": [
	"Einladungsnachricht (optional)"
],
	"\u0000Invitations\u0001": [
	"Einladungen"
],
	"\u0000Invitations sent.\u0001": [
	"Einladungen gesendet."
],
	"\u0000Invite\u0001": [
	"Einladen"
],
	"\u0000Invite as: \u0001": [
	"Einladen als: "
],
	"\u0000Invite options\u0001": [
	"Einladungsoptionen"
],
	"\u0000Invite owner\u0001": [
	"Eigentümer einladen"
],
	"\u0000Invite participant\u0001": [
	"Teilnehmer einladen"
],
	"\u0000Invite people\u0001": [
	"Personen einladen"
],
	"\u0000Invite to appointment\u0001": [
	"Zu Termin einladen"
],
	"\u0000Invite to new appointment\u0001": [
	"Zu neuem Termin einladen"
],
	"\u0000Invite to series?\u0001": [
	"Zur Serie einladen?"
],
	"\u0000Invited people only\u0001": [
	"Nur eingeladene Personen"
],
	"\u0000Is bigger than\u0001": [
	"ist größer als"
],
	"\u0000Is exactly\u0001": [
	"Stimmt exakt überein mit"
],
	"\u0000Is not exactly\u0001": [
	"Stimmt nicht exakt überein mit"
],
	"\u0000Is smaller than\u0001": [
	"ist kleiner als"
],
	"\u0000Issued by\u0001": [
	"Ausgestellt von"
],
	"\u0000Issued on\u0001": [
	"Ausgestellt am"
],
	"\u0000It appears as if you forgot to attach a file.\u0001": [
	"Sie haben möglicherweise vergessen, eine Datei anzuhängen."
],
	"\u0000It is now possible to set how quickly an email will be marked as read. You can choose to have it marked as read immediately, after 5 seconds, after 20 seconds, or never.\u0001": [
	"Es ist nun möglich, genau einzustellen, ob und wie schnell eine E-Mail als gelesen markiert wird. Sie können wählen, ob diese sofort, nach 5 Sekunden, nach 20 Sekunden oder nie als gelesen markiert werden soll."
],
	"\u0000It looks like your current browser doesn't support the features needed to install %1$s. To use %1$s like an app, please switch to a supported browser.\u0001": [
	"Es sieht so aus, als würde Ihr aktueller Browser die für die Installation von %1$s erforderlichen Funktionen nicht unterstützen. Um %1$s wie eine App zu verwenden, wechseln Sie bitte zu einem unterstützten Browser."
],
	"\u0000It may take some time until mails are assigned to the default categories.\u0001": [
	"Es kann etwas dauern, bis E-Mails den Standardkategorien zugeordnet sind."
],
	"rating\u0000It's OK\u0001": [
	"Ist OK"
],
	"rating\u0000It's awesome\u0001": [
	"Ist super"
],
	"rating\u0000It's really bad\u0001": [
	"Ist richtig schlecht"
],
	"\u0000Italic\u0001": [
	"Kursiv"
],
	"\u0000Item list\u0001": [
	"Objektliste"
],
	"\u0000Item list options\u0001": [
	"Optionen für Objektliste"
],
	"\u0000Items without a file can not be downloaded.\u0001": [
	"Objekte ohne Datei können nicht heruntergeladen werden."
],
	"\u0000Join %s conference\u0001": [
	"%s-Konferenz beitreten"
],
	"\u0000Join Skype meeting\u0001": [
	"Skype-Meeting beitreten"
],
	"\u0000Join Teams Meeting\u0001": [
	"Teams-Meeting beitreten"
],
	"\u0000Join Zoom meeting\u0001": [
	"Zoom-Meeting beitreten"
],
	"\u0000Join conference call\u0001": [
	"Telefonkonferenz beitreten"
],
	"\u0000Join with Apple Facetime\u0001": [
	"Mit Apple Facetime beitreten"
],
	"\u0000Join with Google Meet\u0001": [
	"Mit Google Meet beitreten"
],
	"\u0000Just disable widget\u0001": [
	"Widget nur deaktivieren"
],
	"\u0000Keep\u0001": [
	"Behalten"
],
	"\u0000Keep a copy of the message\u0001": [
	"Kopie der Nachricht behalten"
],
	"\u0000Keep mails from %1$s\u0001": [
	"E-Mails von %1$s behalten"
],
	"\u0000Keep mails to %1$s\u0001": [
	"E-Mails an %1$s behalten"
],
	"\u0000Keep mails with subject %1$s\u0001": [
	"E-Mails mit dem Betreff %1$s behalten"
],
	"\u0000Keyboard Shortcuts\u0001": [
	"Tastaturkürzel"
],
	"\u0000Keyboard shortcuts\u0001": [
	"Tastaturkürzel"
],
	"\u0000Landscape\u0001": [
	"Landschaft"
],
	"\u0000Language\u0001": [
	"Sprache"
],
	"\u0000Language & Time zone\u0001": [
	"Sprache und Zeitzone"
],
	"\u0000Language, regional formats and time zone\u0001": [
	"Sprache, regionale Formate und Zeitzone"
],
	"\u0000Language-specific default (%s)\u0001": [
	"Sprachspezifischer Standard (%s)"
],
	"\u0000Language:\u0001": [
	"Sprache:"
],
	"\u0000Languages\u0001": [
	"Sprachen"
],
	"\u0000Large\u0001": [
	"Groß"
],
	"\u0000Large (%1$s px)\u0001": [
	"Groß (%1$s px)"
],
	"\u0000Last Login: %s\u0001": [
	"Letzte Anmeldung: %s"
],
	"\u0000Last chosen date\u0001": [
	"Zuletzt gewähltes Datum"
],
	"\u0000Last name\u0001": [
	"Nachname"
],
	"\u0000Last name must not be empty for internal users\u0001": [
	"Nachname für interne Benutzer darf nicht leer sein"
],
	"\u0000Last name, First name\u0001": [
	"Nachname, Vorname"
],
	"\u0000Last searched for\u0001": [
	"Zuletzt gesucht nach"
],
	"\u0000Last updated\u0001": [
	"Zuletzt aktualisiert"
],
	"\u0000Late in the evening\u0001": [
	"Spät am Abend"
],
	"\u0000Later today\u0001": [
	"Später"
],
	"\u0000Layout\u0001": [
	"Layout"
],
	"\u0000Learn more\u0001": [
	"Weitere Infos"
],
	"\u0000Learning\u0001": [
	"Lernen"
],
	"\u0000Leave a comment for other participants\u0001": [
	"Hinterlassen Sie einen Kommentar für andere Teilnehmer"
],
	"\u0000Length\u0001": [
	"Länge"
],
	"\u0000Let reminders help you not to miss appointments\u0001": [
	"Erinnerungen helfen Ihnen, Termine nicht zu verpassen"
],
	"\u0000Let there be darkness! You can now select Dark Mode which uses bright text on a dark background as opposed to the usual black text on a bright white screen. Apart from personal preference, Dark Mode has significant benefits. A device or application using Dark Mode emits less light which improves readability in low light environments thus reducing eye strain.\u0001": [
	"Es werde dunkel! Im neuen Dunkelmodus wird statt der üblichen schwarzen Schrift auf weißem Grund, heller Text auf dunklem Grund dargestellt. Neben persönlicher Präferenz hat der Dunkelmodus Vorteile: es wird generell weniger Licht benötigt, was in dunklen Umgebungen die Lesbarkeit verbessert und die Augen entlastet."
],
	"\u0000Light\u0001": [
	"Hell"
],
	"\u0000Light Blue\u0001": [
	"Hellblau"
],
	"\u0000Light Gray\u0001": [
	"Hellgrau"
],
	"\u0000Light Green\u0001": [
	"Hellgrün"
],
	"\u0000Light Purple\u0001": [
	"Hellviolett"
],
	"\u0000Light Red\u0001": [
	"Hellrot"
],
	"\u0000Light Yellow\u0001": [
	"Hellgelb"
],
	"\u0000Light blue\u0001": [
	"Hellblau"
],
	"\u0000Light green\u0001": [
	"Hellgrün"
],
	"\u0000Light theme\u0001": [
	"Helles Theme"
],
	"\u0000Link\u0001": [
	"Link"
],
	"\u0000Link expired\u0001": [
	"Link abgelaufen"
],
	"\u0000Link postal addresses with map service\u0001": [
	"Postanschriften mit Kartendienst verknüpfen"
],
	"\u0000Link will be sent to %1$s\u0001": [
	"Link wird gesendet an %1$s"
],
	"\u0000Link:\u0001": [
	"Link:"
],
	"\u0000Link: \u0001": [
	"Link: "
],
	"\u0000Links\u0001": [
	"Verlinkungen"
],
	"\u0000Links have been disabled to protect you against potential spam\u0001": [
	"Links wurden deaktiviert, um Sie vor potenziellem Spam zu schützen"
],
	"\u0000List\u0001": [
	"Liste"
],
	"\u0000List name\u0001": [
	"Listenname"
],
	"\u0000List of Groups\u0001": [
	"Liste der Gruppen"
],
	"\u0000List options\u0001": [
	"Optionen für Liste"
],
	"\u0000List view\u0001": [
	"Listenansicht"
],
	"\u0000Listed people only\u0001": [
	"Nur aufgeführte Personen"
],
	"\u0000Load appointments until %1$s\u0001": [
	"Termine laden bis %1$s"
],
	"\u0000Loading…\u0001": [
	"Laden…"
],
	"\u0000Local system timezone\u0001": [
	"Zeitzone des lokalen Systems"
],
	"\u0000Local-part\u0001": [
	"Lokaler Teil"
],
	"\u0000Location\u0001": [
	"Ort"
],
	"\u0000Location: %s\u0001": [
	"Ort: %1$s"
],
	"\u0000Lock\u0001": [
	"Sperren"
],
	"\u0000Locked\u0001": [
	"Gesperrt"
],
	"\u0000Login\u0001": [
	"Anmelden"
],
	"\u0000Logout failed.\u0001": [
	"Abmelden fehlgeschlagen."
],
	"\u0000Look for new data every\u0001": [
	"Nach neuen Daten suchen alle"
],
	"\u0000Low\u0001": [
	"Niedrig"
],
	"E-Mail priority\u0000Low\u0001": [
	"Niedrig"
],
	"Tasks priority\u0000Low\u0001": [
	"Niedrig"
],
	"\u0000Low Priority\u0001": [
	"Niedrige Priorität"
],
	"E-Mail\u0000Low priority\u0001": [
	"Wichtigkeit: niedrig"
],
	"\u0000Lower\u0001": [
	"Kleiner"
],
	"\u0000Lower equals\u0001": [
	"Kleiner als oder gleich"
],
	"\u0000MB\u0001": [
	"MB"
],
	"\u0000Mac App Store\u0001": [
	"Mac App Store"
],
	"\u0000Magenta\u0001": [
	"Magenta"
],
	"\u0000Mail\u0001": [
	"E-Mail"
],
	"app\u0000Mail\u0001": [
	"Mail"
],
	"\u0000Mail compose actions\u0001": [
	"Aktionen zum Verfassen von E-Mails"
],
	"\u0000Mail count quota\u0001": [
	"E-Mail-Anzahl"
],
	"\u0000Mail layout\u0001": [
	"Mail-Layout"
],
	"\u0000Mail quota\u0001": [
	"E-Mail-Speicherplatz"
],
	"\u0000Mail quota exceeded\u0001": [
	"E-Mail-Speicherplatz überschritten"
],
	"\u0000Mail quota limit reached. You have to use %1$s or reduce the mail size in some other way.\u0001": [
	"Der maximale E-Mail-Speicherplatz wurde erreicht. Sie müssen %1$s verwenden oder die E-Mailgröße auf andere Weise reduzieren."
],
	"\u0000Mail storage\u0001": [
	"E-Mail-Speicherplatz"
],
	"\u0000Mail subject\u0001": [
	"E-Mail-Betreff"
],
	"\u0000Mailing list\u0001": [
	"Mailingliste"
],
	"\u0000Mails per hour (%)\u0001": [
	"E-Mails pro Stunde (%)"
],
	"\u0000Mails per week-day (%)\u0001": [
	"E-Mails pro Wochentag (%)"
],
	"\u0000Make this the current version\u0001": [
	"Diese als aktuelle Version markieren"
],
	"\u0000Malicious file detected\u0001": [
	"Schädliche Datei erkannt"
],
	"\u0000Manage Shares\u0001": [
	"Freigaben verwalten"
],
	"\u0000Manage additional passwords for use with other devices.\u0001": [
	"Verwalten Sie zusätzliche Passwörter für die Verwendung mit anderen Geräten."
],
	"\u0000Manage applications that can access your data\u0001": [
	"Verwalten Sie Anwendungen, die auf Ihre Daten zugreifen können"
],
	"\u0000Manage browser permissions now\u0001": [
	"Browser-Berechtigungen jetzt verwalten"
],
	"\u0000Manage categories\u0001": [
	"Kategorien verwalten"
],
	"\u0000Manage deputies\u0001": [
	"Stellvertreter verwalten"
],
	"\u0000Manage favorites\u0001": [
	"Favoriten verwalten"
],
	"\u0000Manage signatures\u0001": [
	"Signaturen verwalten"
],
	"\u0000Manage subscriptions of external data\u0001": [
	"Abonnements für externe Daten verwalten"
],
	"\u0000Manage your accounts\u0001": [
	"Verwalten Sie Ihre Konten"
],
	"\u0000Managed Resources\u0001": [
	"Verwaltete Ressourcen"
],
	"\u0000Managed resources is a feature that allows organizations to efficiently manage and schedule shared resources such as conference rooms and equipment. This feature helps ensure that resources are utilized effectively and efficiently, improving productivity and reducing scheduling conflicts.\u0001": [
	"Die Funktion \"Verwaltete Ressourcen\" ermöglicht es Unternehmen, gemeinsam genutzte Ressourcen wie Konferenzräume und Geräte effizient zu verwalten und einzuplanen. Mit dieser Funktion wird sichergestellt, dass die Ressourcen effektiv und effizient genutzt werden, was die Produktivität erhöht und Planungskonflikte reduziert."
],
	"\u0000Manager\u0001": [
	"Manager"
],
	"\u0000Manual input\u0001": [
	"Manuelle Eingabe"
],
	"\u0000Marimba\u0001": [
	"Marimba"
],
	"\u0000Marital status\u0001": [
	"Familienstand"
],
	"\u0000Mark all messages as read\u0001": [
	"Alle Nachrichten als gelesen markieren"
],
	"\u0000Mark as distribution list\u0001": [
	"Als Verteilerliste markieren"
],
	"\u0000Mark as done\u0001": [
	"Als erledigt markieren"
],
	"\u0000Mark as optional\u0001": [
	"Als optional markieren"
],
	"\u0000Mark as read\u0001": [
	"Als gelesen markieren"
],
	"\u0000Mark as required\u0001": [
	"Als erforderlich markieren"
],
	"\u0000Mark as spam\u0001": [
	"Als Spam markieren"
],
	"\u0000Mark as undone\u0001": [
	"Als unerledigt markieren"
],
	"\u0000Mark as unread\u0001": [
	"Als ungelesen markieren"
],
	"\u0000Mark email as\u0001": [
	"E-Mail als Spam markieren"
],
	"\u0000Mark email as not spam\u0001": [
	"E-Mail als \"kein Spam\" markieren"
],
	"\u0000Mark email as spam\u0001": [
	"E-Mail als Spam markieren"
],
	"\u0000Mark mails from %1$s as deleted\u0001": [
	"E-Mails von %1$s als gelöscht markieren"
],
	"\u0000Mark mails from %1$s as seen\u0001": [
	"E-Mails von %1$s als gesehen markieren"
],
	"\u0000Mark mails to %1$s as deleted\u0001": [
	"E-Mails an %1$s als gelöscht markieren"
],
	"\u0000Mark mails to %1$s as seen\u0001": [
	"E-Mails an %1$s als gesehen markieren"
],
	"\u0000Mark mails with subject %1$s as deleted\u0001": [
	"E-Mails mit dem Betreff %1$s als gelöscht markieren"
],
	"\u0000Mark mails with subject %1$s as seen\u0001": [
	"E-Mails mit dem Betreff %1$s als gesehen markieren"
],
	"\u0000Mark participants as optional\u0001": [
	"Teilnehmer als optional markieren"
],
	"\u0000Mark read\u0001": [
	"Als gelesen markieren"
],
	"\u0000Mark unread\u0001": [
	"Als ungelesen markieren"
],
	"\u0000Marked as favorite\u0001": [
	"Als Favorit markiert"
],
	"\u0000Marked as read\u0001": [
	"Als gelesen markiert"
],
	"\u0000Marked as unread\u0001": [
	"Als ungelesen markiert"
],
	"\u0000Matches\u0001": [
	"Stimmt überein mit"
],
	"\u0000Matches not\u0001": [
	"Stimmt nicht überein mit"
],
	"\u0000Maximize\u0001": [
	"Maximieren"
],
	"\u0000Maximum file size\u0001": [
	"Maximale Dateigröße"
],
	"\u0000Maximum version count\u0001": [
	"Maximale Anzahl an Versionen"
],
	"\u0000Maybe\u0001": [
	"Vielleicht"
],
	"appointment participation status\u0000Maybe\u0001": [
	"Vielleicht"
],
	"\u0000Maybe: %d\u0001": [
	"Vielleicht: %d"
],
	"\u0000Medium\u0001": [
	"Mittel"
],
	"Tasks priority\u0000Medium\u0001": [
	"Mittel"
],
	"\u0000Medium (%1$s px)\u0001": [
	"Mittel (%1$s px)"
],
	"\u0000Medium Gray\u0001": [
	"Mittelgrau"
],
	"\u0000Medium Priority\u0001": [
	"Mittlere Priorität"
],
	"\u0000Meeting\u0001": [
	"Meeting"
],
	"\u0000Meeting password: %1$s\u0001": [
	"Meeting-Passwort: %1$s"
],
	"\u0000Meeting starts now\u0001": [
	"Das Meeting beginnt jetzt"
],
	"\u0000Meeting-ID: %1$s\u0001": [
	"Meeting-ID: %1$s"
],
	"\u0000Members\u0001": [
	"Mitglieder"
],
	"\u0000Members (%1$d)\u0001": [
	"Mitglieder (%1$d)"
],
	"\u0000Menu\u0001": [
	"Menü"
],
	"\u0000Merge\u0001": [
	"Zusammenfügen"
],
	"\u0000Message\u0001": [
	"Nachricht"
],
	"\u0000Message format\u0001": [
	"Nachrichtenformat"
],
	"\u0000Message moved to category \"%1$s\".\u0001": [
	"Nachricht in Kategorie \"%1$s\" verschoben."
],
	"\u0000Message will be sent to all newly invited people\u0001": [
	"Nachricht wird an alle neu eingeladenen Personen gesendet"
],
	"\u0000Messages\u0001": [
	"Nachrichten"
],
	"\u0000Messages moved to category \"%1$s\".\u0001": [
	"Nachricht in Kategorie \"%1$s\" verschoben."
],
	"\u0000Messages options\u0001": [
	"Nachrichten-Optionen"
],
	"\u0000Messenger\u0001": [
	"Messenger"
],
	"\u0000Microphone %1$s\u0001": [
	"Mikrofon %1$s"
],
	"\u0000Middle name\u0001": [
	"Zweiter Vorname"
],
	"\u0000Middleware version\u0001": [
	"Middleware-Version"
],
	"\u0000Minimize\u0001": [
	"Minimieren"
],
	"\u0000Minimized windows\u0001": [
	"Minimierte Fenster"
],
	"\u0000Minimum password length is %1$d.\u0001": [
	"Minimale Passwortlänge ist %1$d."
],
	"\u0000Minus\u0001": [
	"Minus"
],
	"\u0000Mobile\u0001": [
	"Mobiltelefon"
],
	"\u0000Mobile Mail\u0001": [
	"Mobile Mail"
],
	"\u0000Mobile calendar redesign\u0001": [
	"Neugestaltung des mobilen Kalenders"
],
	"\u0000Model is incomplete.\u0001": [
	"Unvollständige Angaben"
],
	"\u0000Modified\u0001": [
	"Geändert"
],
	"superessive\u0000Monday\u0001": [
	"Montag"
],
	"\u0000Monday in %1$d weeks\u0001": [
	"Montag in %1$d Wochen"
],
	"\u0000Month\u0001": [
	"Monat"
],
	"\u0000Month view\u0001": [
	"Monatsansicht"
],
	"\u0000Monthly\u0001": [
	"Monatlich"
],
	"\u0000More actions\u0001": [
	"Weitere Aktionen"
],
	"\u0000More colors! You like purple? Prefer orange? You now have the choice! We added a set of themes that covers the most common color preferences. And you can combine different background and accent colors.\u0001": [
	"Es werde bunt! Sie mögen Violett? Oder doch lieber Orange? Jetzt haben Sie die Wahl! Wir haben mehrere Themes mit beliebten Farben hinzugefügt, die Sie mit verschiedenen Hintergründen kombinieren können."
],
	"\u0000More contact options\u0001": [
	"Weitere Optionen für Kontakte"
],
	"\u0000More message options\u0001": [
	"Weitere Optionen für Nachrichten"
],
	"\u0000More options\u0001": [
	"Weitere Optionen"
],
	"\u0000More search options\u0001": [
	"Weitere Suchoptionen"
],
	"\u0000Most recent attachments\u0001": [
	"Neueste Anhänge"
],
	"\u0000Most recent mails (%1$d)\u0001": [
	"Neueste E-Mails (%1$d)"
],
	"\u0000Mountains\u0001": [
	"Gebirge"
],
	"\u0000Move\u0001": [
	"Verschieben"
],
	"\u0000Move all\u0001": [
	"Alle verschieben"
],
	"\u0000Move all messages\u0001": [
	"Alle Nachrichten verschieben"
],
	"\u0000Move folder\u0001": [
	"Ordner verschieben"
],
	"\u0000Move mails from %1$s into folder %2$s\u0001": [
	"E-Mails von %1$s in den Ordner %2$s verschieben"
],
	"\u0000Move mails to %1$s into folder %2$s\u0001": [
	"E-Mails an %1$s in den Ordner %2$s verschieben"
],
	"\u0000Move mails with subject %1$s into folder %2$s\u0001": [
	"E-Mails mit dem Betreff %1$s in den Ordner %2$s verschieben"
],
	"\u0000Move operation takes longer to finish\u0001": [
	"Verschiebevorgang dauert länger"
],
	"\u0000Move to category\u0001": [
	"In Kategorie verschieben"
],
	"\u0000Move to folder\u0001": [
	"In Ordner verschieben"
],
	"\u0000Multiselect\u0001": [
	"Mehrfachauswahl"
],
	"\u0000Music\u0001": [
	"Musik"
],
	"\u0000My %1$s\u0001": [
	"Mein %1$s"
],
	"\u0000My %1$s account\u0001": [
	"Mein %1$s-Konto"
],
	"\u0000My %1$s account (%2$d)\u0001": [
	"Mein %1$s-Konto (%2$d)"
],
	"\u0000My %1$s calendar\u0001": [
	"Mein %1$s-Kalender"
],
	"\u0000My %1$s contacts\u0001": [
	"Meine %1$s-Kontakte"
],
	"\u0000My Google Calendar\u0001": [
	"Mein Google-Kalender"
],
	"\u0000My Phone\u0001": [
	"Mein Telefon"
],
	"\u0000My account\u0001": [
	"Mein Konto"
],
	"\u0000My address books\u0001": [
	"Meine Adressbücher"
],
	"\u0000My address lists\u0001": [
	"Meine Adresslisten"
],
	"\u0000My calendars\u0001": [
	"Meine Kalender"
],
	"\u0000My contact data\u0001": [
	"Meine Kontaktdaten"
],
	"\u0000My files\u0001": [
	"Meine Dateien"
],
	"\u0000My folders\u0001": [
	"Meine Ordner"
],
	"\u0000My latest files\u0001": [
	"Meine neuesten Dateien"
],
	"\u0000My lists\u0001": [
	"Meine Listen"
],
	"\u0000My password\u0001": [
	"Mein Passwort"
],
	"\u0000My shares\u0001": [
	"Meine Freigaben"
],
	"\u0000My tasks\u0001": [
	"Meine Aufgaben"
],
	"\u0000Name\u0001": [
	"Name"
],
	"\u0000Name Lastname\u0001": [
	"Name Nachname"
],
	"\u0000Name is already taken.\u0001": [
	"Der Name ist bereits vergeben."
],
	"\u0000Name or email address\u0001": [
	"Name oder E-Mail-Adresse"
],
	"\u0000Names\u0001": [
	"Namen"
],
	"\u0000Names & Addresses\u0001": [
	"Namen & Adressen"
],
	"\u0000Nature\u0001": [
	"Natur"
],
	"\u0000Navigate to:\u0001": [
	"Navigieren zu:"
],
	"\u0000Navigation\u0001": [
	"Navigation"
],
	"\u0000Navy Blue\u0001": [
	"Marineblau"
],
	"\u0000Need more space?\u0001": [
	"Sie brauchen mehr Speicher?"
],
	"\u0000Nested condition\u0001": [
	"Verschachtelte Bedingung"
],
	"\u0000Never\u0001": [
	"Nie"
],
	"\u0000Never miss a meeting\u0001": [
	"Verpassen Sie kein Meeting"
],
	"\u0000Never show again\u0001": [
	"Nicht mehr anzeigen"
],
	"\u0000Never used\u0001": [
	"Nie verwendet"
],
	"\u0000New\u0001": [
	"Neu"
],
	"\u0000New Folder\u0001": [
	"Neuer Ordner"
],
	"\u0000New Windows\u0001": [
	"Neue Fenster"
],
	"\u0000New address book\u0001": [
	"Neues Adressbuch"
],
	"\u0000New appointment\u0001": [
	"Neuer Termin"
],
	"\u0000New calendar\u0001": [
	"Neuer Kalender"
],
	"\u0000New calendar name\u0001": [
	"Neuer Kalendername"
],
	"\u0000New category\u0001": [
	"Neue Kategorie"
],
	"\u0000New contact\u0001": [
	"Neuer Kontakt"
],
	"\u0000New design\u0001": [
	"Neues Design"
],
	"\u0000New distribution list\u0001": [
	"Neue Verteilerliste"
],
	"\u0000New email\u0001": [
	"Neue E-Mail"
],
	"\u0000New email with attachment\u0001": [
	"Neue E-Mail mit Anhang"
],
	"\u0000New emails\u0001": [
	"Neue E-Mails"
],
	"\u0000New folder\u0001": [
	"Neuer Ordner"
],
	"\u0000New list\u0001": [
	"Neue Liste"
],
	"\u0000New meeting\u0001": [
	"Neues Meeting"
],
	"\u0000New note\u0001": [
	"Neue Notiz"
],
	"\u0000New notification center\u0001": [
	"Neue Mitteilungszentrale"
],
	"\u0000New organizer\u0001": [
	"Neuer Organisator"
],
	"\u0000New password\u0001": [
	"Neues Passwort"
],
	"\u0000New resource group\u0001": [
	"Neue Ressourcengruppe"
],
	"\u0000New rule\u0001": [
	"Neue Regel"
],
	"\u0000New search\u0001": [
	"Neue Suche"
],
	"\u0000New task\u0001": [
	"Neue Aufgabe"
],
	"\u0000Next\u0001": [
	"Weiter"
],
	"\u0000Next day\u0001": [
	"Nächster Tag"
],
	"\u0000Next file\u0001": [
	"Nächste Datei"
],
	"\u0000Next message\u0001": [
	"Nächste Nachricht"
],
	"\u0000Next month\u0001": [
	"Nächster Monat"
],
	"\u0000Next page\u0001": [
	"Nächste Seite"
],
	"\u0000Next week\u0001": [
	"Nächste Woche"
],
	"\u0000Next year\u0001": [
	"Nächstes Jahr"
],
	"\u0000Nickname\u0001": [
	"Nickname"
],
	"\u0000No 2-step verification options configured yet.\u0001": [
	"Es wurden noch keine Zwei-Faktor-Authentifizierungsoptionen konfiguriert."
],
	"\u0000No Priority\u0001": [
	"Keine Priorität"
],
	"\u0000No RSS feeds found.\u0001": [
	"Kein RSS-Feed gefunden."
],
	"\u0000No appointment selected\u0001": [
	"Kein Termin ausgewählt"
],
	"\u0000No appointments\u0001": [
	"Keine Termine"
],
	"\u0000No appointments found until %s\u0001": [
	"Keine Termine gefunden bis %s"
],
	"\u0000No autocomplete entries found\u0001": [
	"Keine Autovervollständigungseinträge gefunden"
],
	"\u0000No birthdays within the next %1$d weeks\u0001": [
	"Keine Geburtstage in den nächsten %1$d Wochen"
],
	"\u0000No category selected\u0001": [
	"Keine Kategorie ausgewählt"
],
	"\u0000No color\u0001": [
	"Keine Farbe"
],
	"\u0000No connection to server. Please check your internet connection and retry.\u0001": [
	"Keine Verbindung zum Server. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut."
],
	"\u0000No contacts found.\u0001": [
	"Keine Kontakte gefunden."
],
	"\u0000No elements selected\u0001": [
	"Keine Objekte markiert"
],
	"\u0000No export format available\u0001": [
	"Kein Exportformat vorhanden"
],
	"\u0000No files have been changed recently\u0001": [
	"Es wurden kürzlich keine Dateien geändert"
],
	"\u0000No icon\u0001": [
	"Kein Symbol"
],
	"\u0000No items with this category found\u0001No items with these categories found": [
	"Keine Elemente mit dieser Kategorie gefunden",
	"Keine Elemente mit diesen Kategorien gefunden"
],
	"\u0000No link\u0001": [
	"Kein Link"
],
	"\u0000No location\u0001": [
	"Kein Ort"
],
	"\u0000No mails in your inbox\u0001": [
	"Der Posteingang enthält keine E-Mails"
],
	"\u0000No matching items found.\u0001": [
	"Keine passenden Objekte gefunden."
],
	"\u0000No member\u0001": [
	"Kein Mitglied"
],
	"\u0000No members\u0001": [
	"Keine Mitglieder"
],
	"\u0000No message selected\u0001": [
	"Keine Nachricht markiert"
],
	"\u0000No notifications\u0001": [
	"Keine Benachrichtigungen"
],
	"\u0000No providers available\u0001": [
	"Keine Anbieter verfügbar"
],
	"\u0000No recipients\u0001": [
	"Keine Empfänger"
],
	"\u0000No reminder\u0001": [
	"Keine Erinnerung"
],
	"\u0000No search results\u0001": [
	"Keine Suchergebnisse"
],
	"\u0000No signature\u0001": [
	"Keine Signatur"
],
	"\u0000No subject\u0001": [
	"Kein Betreff"
],
	"\u0000No subscription services available for this module\u0001": [
	"Für dieses Modul stehen keine Abonnement-Dienste zur Verfügung"
],
	"\u0000No thanks\u0001": [
	"Nein danke"
],
	"\u0000Nobody\u0001": [
	"Niemand"
],
	"\u0000Non-blocking time frame\u0001": [
	"Nicht-blockierender Zeitrahmen"
],
	"\u0000None\u0001": [
	"Keine"
],
	"Tasks priority\u0000None\u0001": [
	"Keine"
],
	"\u0000None of the uploaded files matches the requested file type.\u0001": [
	"Keine der hochgeladenen Dateien stimmt mit dem angeforderten Dateityp überein."
],
	"E-Mail priority\u0000Normal\u0001": [
	"Normal"
],
	"\u0000Not Regex\u0001": [
	"Kein regulärer Ausdruck"
],
	"\u0000Not flagged\u0001": [
	"Nicht markiert"
],
	"\u0000Not likely at all\u0001": [
	"Sehr unwahrscheinlich"
],
	"\u0000Not spam\u0001": [
	"Kein Spam"
],
	"\u0000Not started\u0001": [
	"Nicht begonnen"
],
	"\u0000Note\u0001": [
	"Notiz"
],
	"contact\u0000Note\u0001": [
	"Notiz"
],
	"\u0000Note on CSV files\u0001": [
	"Hinweis zu CSV-Dateien"
],
	"\u0000Note:\u0001": [
	"Hinweis:"
],
	"\u0000Note: %1$d contact is not shown due to missing phone numbers\u0001Note: %1$d contacts are not shown due to missing phone numbers": [
	"Hinweis: Ein Kontakt wird wegen fehlender Telefonnummern nicht angezeigt",
	"Hinweis: %1$d Kontakte werden wegen fehlender Telefonnummern nicht angezeigt"
],
	"\u0000Note: Refreshing this subscription will replace the calendar content with the external content. Changes you have made inside %1$s will be overwritten.\u0001": [
	"Hinweis: Das Aktualisieren des Abonnements überschreibt den Kalenderinhalt mit dem externen Inhalt. Änderungen, die Sie innerhalb von %1$s vorgenommen haben, werden überschrieben."
],
	"\u0000Notification\u0001": [
	"Benachrichtigung"
],
	"\u0000Notification area\u0001": [
	"Infobereich"
],
	"\u0000Notifications\u0001": [
	"Benachrichtigungen"
],
	"\u0000Notifications for incoming calls\u0001": [
	"Benachrichtigungen für eingehende Anrufe"
],
	"\u0000Notifications related to appointments\u0001": [
	"Terminbezogene Benachrichtigungen"
],
	"\u0000Notifications related to emails\u0001": [
	"E-Mail-bezogene Benachrichtigungen"
],
	"\u0000Notifications related to tasks\u0001": [
	"Aufgabenbezogene Benachrichtigungen"
],
	"\u0000Notify %1$s after end.\u0001": [
	"%1$s nach Ende benachrichtigen."
],
	"\u0000Notify %1$s after start.\u0001": [
	"%1$s nach Beginn benachrichtigen."
],
	"\u0000Notify %1$s before end.\u0001": [
	"%1$s vor Ende benachrichtigen."
],
	"\u0000Notify %1$s before start.\u0001": [
	"%1$s vor Beginn benachrichtigen."
],
	"\u0000Notify at %1$s.\u0001": [
	"Am %1$s benachrichtigen."
],
	"\u0000Notify at end.\u0001": [
	"Bei Ende benachrichtigen."
],
	"\u0000Notify at start.\u0001": [
	"Bei Beginn benachrichtigen."
],
	"\u0000Now active\u0001": [
	"jetzt aktiv"
],
	"\u0000Number format\u0001": [
	"Zahlenformat"
],
	"\u0000OK\u0001": [
	"OK"
],
	"native app\u0000OX Drive\u0001": [
	"OX Drive"
],
	"native app\u0000OX Mail\u0001": [
	"OX Mail"
],
	"\u0000OX Sync App\u0001": [
	"OX Sync-App"
],
	"\u0000Objects\u0001": [
	"Objekte"
],
	"\u0000Occurrences\u0001": [
	"Ereignisse"
],
	"\u0000Ocean\u0001": [
	"Ozean"
],
	"\u0000Offline\u0001": [
	"Offline"
],
	"\u0000Ok\u0001": [
	"OK"
],
	"\u0000On %1$s %2$s wrote:\u0001": [
	"%2$s hat am %1$s geschrieben:"
],
	"\u0000On behalf of\u0001": [
	"Im Auftrag von"
],
	"\u0000On behalf of the owner\u0001": [
	"im Auftrag des Eigentümers "
],
	"\u0000On replies or forwardings\u0001": [
	"Bei Antworten oder Weiterleitungen"
],
	"\u0000On specific date\u0001": [
	"An bestimmtem Datum"
],
	"weekly\u0000On workdays.\u0001": [
	"An Werktagen."
],
	"\u0000Once complete, please enter an authentication code to verify everything is configured properly.\u0001": [
	"Wenn Sie fertig sind, geben Sie bitte einen Authentifizierungscode ein, um zu überprüfen, ob alles korrekt konfiguriert ist."
],
	"\u0000One day\u0001": [
	"Ein Tag"
],
	"\u0000One month\u0001": [
	"Ein Monat"
],
	"\u0000One of the embedded images could not be used.\u0001": [
	"Eines der eingebetteten Bilder konnte nicht verwendet werden."
],
	"\u0000One tap mobile (%1$s): %2$s\u0001": [
	"Schnelleinwahl mobil (%1$s): %2$s"
],
	"\u0000One week\u0001": [
	"Eine Woche"
],
	"\u0000One year\u0001": [
	"Ein Jahr"
],
	"\u0000Online help\u0001": [
	"Online-Hilfe"
],
	"\u0000Online help: %1$s\u0001": [
	"Online-Hilfe: %1$s"
],
	"\u0000Only from known senders\u0001": [
	"Nur von bekannten Absendern"
],
	"\u0000Only numbers allowed\u0001": [
	"Nur Zahlen erlaubt"
],
	"\u0000Open %1$s\u0001": [
	"%1$s öffnen"
],
	"\u0000Open %1$s in %2$s\u0001": [
	"%1$s in %2$s öffnen"
],
	"\u0000Open Drafts\u0001": [
	"\"Entwürfe\" öffnen"
],
	"\u0000Open Inbox\u0001": [
	"\"Posteingang\" öffnen"
],
	"\u0000Open Sent\u0001": [
	"\"Gesendet\" öffnen"
],
	"\u0000Open Street Map\u0001": [
	"Open Street Map"
],
	"\u0000Open Zoom profile\u0001": [
	"Zoom-Profil öffnen"
],
	"\u0000Open attachment\u0001": [
	"Anhang öffnen"
],
	"\u0000Open description panel\u0001": [
	"Beschreibungspanel öffnen"
],
	"\u0000Open file\u0001": [
	"Datei öffnen"
],
	"\u0000Open file. Drag to your desktop to download.\u0001": [
	"Datei öffnen. Zum Herunterladen bitte per Drag & Drop auf Ihrem Desktop ablegen."
],
	"\u0000Open folder view\u0001": [
	"Ordneransicht öffnen"
],
	"\u0000Open in %1$s\u0001": [
	"In %1$s öffnen"
],
	"\u0000Open in calendar\u0001": [
	"Im Kalender öffnen"
],
	"\u0000Open in pop out viewer\u0001": [
	"In eigenem Viewer öffnen"
],
	"\u0000Open installation instructions\u0001": [
	"Installationsanleitung öffnen"
],
	"\u0000Open online help\u0001": [
	"Online-Hilfe öffnen"
],
	"\u0000Open original email in new browser tab.\u0001": [
	"Ursprüngliche E-Mail in einem neuen Browser-Tab öffnen."
],
	"\u0000Open parental control settings\u0001": [
	"Jugendschutz-Einstellungen öffnen"
],
	"\u0000Open settings\u0001": [
	"Einstellungen öffnen"
],
	"\u0000Open sharing dialog\u0001": [
	"Freigabedialog öffnen"
],
	"\u0000Open the app on your device and enter the following information.\u0001": [
	"Öffnen Sie die App auf Ihrem Gerät und geben Sie die folgenden Informationen ein."
],
	"\u0000Optional\u0001": [
	"Optional"
],
	"\u0000Optional 01\u0001": [
	"Optional 01"
],
	"\u0000Optional 02\u0001": [
	"Optional 02"
],
	"\u0000Optional 03\u0001": [
	"Optional 03"
],
	"\u0000Optional 04\u0001": [
	"Optional 04"
],
	"\u0000Optional 05\u0001": [
	"Optional 05"
],
	"\u0000Optional 06\u0001": [
	"Optional 06"
],
	"\u0000Optional 07\u0001": [
	"Optional 07"
],
	"\u0000Optional 08\u0001": [
	"Optional 08"
],
	"\u0000Optional 09\u0001": [
	"Optional 09"
],
	"\u0000Optional 10\u0001": [
	"Optional 10"
],
	"\u0000Optional 11\u0001": [
	"Optional 11"
],
	"\u0000Optional 12\u0001": [
	"Optional 12"
],
	"\u0000Optional 13\u0001": [
	"Optional 13"
],
	"\u0000Optional 14\u0001": [
	"Optional 14"
],
	"\u0000Optional 15\u0001": [
	"Optional 15"
],
	"\u0000Optional 16\u0001": [
	"Optional 16"
],
	"\u0000Optional 17\u0001": [
	"Optional 17"
],
	"\u0000Optional 18\u0001": [
	"Optional 18"
],
	"\u0000Optional 19\u0001": [
	"Optional 19"
],
	"\u0000Optional 20\u0001": [
	"Optional 20"
],
	"\u0000Options\u0001": [
	"Optionen"
],
	"\u0000Orange\u0001": [
	"Orange"
],
	"\u0000Organizer\u0001": [
	"Organisator"
],
	"\u0000Organizer changed\u0001": [
	"Organisator geändert"
],
	"\u0000Original\u0001": [
	"Original"
],
	"\u0000Original email\u0001": [
	"Ursprüngliche E-Mail"
],
	"\u0000Other\u0001": [
	"Weitere"
],
	"\u0000Other Address\u0001": [
	"Weitere Anschrift"
],
	"\u0000Other address\u0001": [
	"Weitere Anschrift"
],
	"\u0000Our mobile feature set just got an upgrade! Now, you can enjoy even more features on your mobile device that were once exclusive to desktops. Say hello to customizable mail signatures, email formatting, reminders, move and archive functions, and even printing - all available right at your fingertips.\u0001": [
	"Unser Funktionsumfang auf Smartphones hat ein Upgrade erhalten! Jetzt können Sie noch mehr Funktionen auf Ihrem Mobilgerät nutzen, die bisher nur auf dem Desktop verfügbar waren. Freuen Sie sich auf anpassbare E-Mail-Signaturen, E-Mail-Formatierungen, Erinnerungen, Verschiebe- und Archivierfunktionen sowie sogar das Drucken."
],
	"\u0000Our newly designed notification center keeps you always up to date. Find all your appointments, reminders and birthdays at a glance.\u0001": [
	"Mit unserer neu gestalteten Mitteilungszentrale bleiben Sie immer auf dem Laufenden. Finden Sie alle Ihre Termine, Erinnerungen und Geburtstage auf einen Blick."
],
	"\u0000Outgoing Server Settings (SMTP)\u0001": [
	"Einstellungen für den Ausgangsserver (SMTP)"
],
	"\u0000Outgoing server (SMTP)\u0001": [
	"Ausgehender Server (SMTP)"
],
	"\u0000Outlook.com\u0001": [
	"Outlook.com"
],
	"\u0000Overdue\u0001": [
	"Überfällig"
],
	"\u0000Overdue Tasks\u0001": [
	"Überfällige Aufgaben"
],
	"\u0000Overdue task\u0001": [
	"Überfällige Aufgabe"
],
	"\u0000Owner\u0001": [
	"Eigentümer"
],
	"\u0000PB\u0001": [
	"PB"
],
	"\u0000PDF file is being created. This might take a while.\u0001": [
	"Die PDF-Datei wird gerade erstellt. Dies kann eine Weile dauern."
],
	"\u0000PDF file was created successfully.\u0001": [
	"Die PDF-Datei wurde erfolgreich erstellt."
],
	"\u0000PDFs\u0001": [
	"PDFs"
],
	"\u0000PGP signature\u0001": [
	"PGP-Signatur"
],
	"\u0000Pacific\u0001": [
	"Pazifik"
],
	"\u0000Page %1$d of %2$d\u0001": [
	"Seite %1$d von %2$d"
],
	"\u0000Page %1$s\u0001": [
	"Seite %1$s"
],
	"\u0000Page number\u0001": [
	"Seitenzahl"
],
	"\u0000Pager\u0001": [
	"Pager"
],
	"\u0000Part\u0001": [
	"Teil"
],
	"\u0000Participant\u0001": [
	"Teilnehmer"
],
	"\u0000Participant related actions\u0001": [
	"Teilnehmerbezogene Aktionen"
],
	"\u0000Participants\u0001": [
	"Teilnehmer"
],
	"\u0000Participants (%1$d)\u0001": [
	"Teilnehmer (%1$d)"
],
	"\u0000Participants accept or decline appointments\u0001": [
	"Teilnehmer bestätigen Termine oder lehnen sie ab"
],
	"\u0000Participants accept or decline tasks\u0001": [
	"Teilnehmer bestätigen Aufgaben oder lehnen sie ab"
],
	"\u0000Participants accept or decline your invitation\u0001": [
	"Teilnehmer bestätigen Ihre Einladung oder lehnen sie ab"
],
	"\u0000Participants and resources\u0001": [
	"Teilnehmer und Ressourcen"
],
	"\u0000Participants can make changes\u0001": [
	"Teilnehmer können Änderungen vornehmen"
],
	"\u0000Participation\u0001": [
	"Teilnahme"
],
	"\u0000Participation is optional\u0001": [
	"Die Teilnahme ist optional"
],
	"\u0000Password\u0001": [
	"Passwort"
],
	"\u0000Password (optional)\u0001": [
	"Passwort (optional)"
],
	"\u0000Password Created\u0001": [
	"Passwort erstellt"
],
	"\u0000Password length must be between %1$d and %2$d characters.\u0001": [
	"Passwortlänge muss zwischen %1$d und %2$d Zeichen liegen."
],
	"\u0000Password name\u0001": [
	"Passwortname"
],
	"\u0000Password strength: Good\u0001": [
	"Passwortstärke: gut"
],
	"\u0000Password strength: Legendary!\u0001": [
	"Passwortstärke: legendär!"
],
	"\u0000Password strength: Strong\u0001": [
	"Passwortstärke: stark"
],
	"\u0000Password strength: Too short\u0001": [
	"Passwortstärke: zu kurz"
],
	"\u0000Password strength: Very strong\u0001": [
	"Passwortstärke: sehr stark"
],
	"\u0000Password strength: Very weak\u0001": [
	"Passwortstärke: sehr schwach"
],
	"\u0000Password strength: Weak\u0001": [
	"Passwortstärke: schwach"
],
	"\u0000Password strength: Wrong length\u0001": [
	"Passwortstärke: falsche Länge"
],
	"\u0000Password: %s\u0001": [
	"Passwort: %s"
],
	"\u0000Pasting images is not supported by your browser!\u0001": [
	"Das Einfügen von Bildern wird von Ihrem Browser nicht unterstützt."
],
	"\u0000People\u0001": [
	"Menschen"
],
	"\u0000Performance is slowed down by the large size of this email’s content.\u0001": [
	"Die Leistung wird durch den großen Umfang des Inhalts dieser E-Mail beeinträchtigt."
],
	"\u0000Permanently remove deleted emails\u0001": [
	"Gelöschte E-Mails unwiderruflich entfernen"
],
	"\u0000Permissions\u0001": [
	"Berechtigungen"
],
	"\u0000Permissions for %1$s \"%2$s\"\u0001": [
	"Berechtigungen für %1$s \"%2$s\""
],
	"\u0000Permissions: %1$s\u0001": [
	"Berechtigungen: %1$s"
],
	"\u0000Personal Meeting ID:\u0001": [
	"Persönliche Meeting-ID:"
],
	"\u0000Personal information\u0001": [
	"Persönliche Daten"
],
	"\u0000Personalize the general appearance\u0001": [
	"Personalisieren Sie das allgemeine Erscheinungsbild"
],
	"\u0000Petrol\u0001": [
	"Petrol"
],
	"\u0000Phone\u0001": [
	"Telefon"
],
	"\u0000Phone (assistant)\u0001": [
	"Telefon (Assistent)"
],
	"\u0000Phone (business alt)\u0001": [
	"Telefon (geschäftlich 2)"
],
	"\u0000Phone (business)\u0001": [
	"Telefon (geschäftlich)"
],
	"\u0000Phone (car)\u0001": [
	"Autotelefon"
],
	"\u0000Phone (company)\u0001": [
	"Telefon (Zentrale)"
],
	"\u0000Phone (home alt)\u0001": [
	"Telefon (privat 2)"
],
	"\u0000Phone (home)\u0001": [
	"Telefon (privat)"
],
	"\u0000Phone (other)\u0001": [
	"Telefon (weiteres)"
],
	"\u0000Phone list\u0001": [
	"Telefonliste"
],
	"\u0000Phone number\u0001": [
	"Telefonnummer"
],
	"\u0000Photos and images\u0001": [
	"Fotos und Bilder"
],
	"\u0000Pick a date and time\u0001": [
	"Wählen Sie ein Datum und eine Uhrzeit"
],
	"\u0000Pink\u0001": [
	"Pink"
],
	"\u0000Places\u0001": [
	"Orte"
],
	"\u0000Plain Text\u0001": [
	"Nur Text"
],
	"\u0000Plain text\u0001": [
	"Nur Text"
],
	"\u0000Play audio\u0001": [
	"Audio wiedergeben"
],
	"\u0000Play ringtone\u0001": [
	"Klingelton abspielen"
],
	"\u0000Play sound %1$s after end.\u0001": [
	"%1$s nach Ende Ton abspielen."
],
	"\u0000Play sound %1$s after start.\u0001": [
	"%1$s nach Beginn Ton abspielen."
],
	"\u0000Play sound %1$s before end.\u0001": [
	"%1$s vor Ende Ton abspielen."
],
	"\u0000Play sound %1$s before start.\u0001": [
	"%1$s vor Beginn Ton abspielen."
],
	"\u0000Play sound at %1$s.\u0001": [
	"Am %1$s Ton abspielen.."
],
	"\u0000Play sound at end.\u0001": [
	"Bei Ende Ton abspielen."
],
	"\u0000Play sound at start.\u0001": [
	"Bei Beginn Ton abspielen."
],
	"\u0000Play sound on incoming email\u0001": [
	"Bei eingehender E-Mail Ton abspielen"
],
	"\u0000Please check your browser settings and enable desktop notifications for this domain\u0001": [
	"Bitte überprüfen Sie Ihre Browsereinstellungen und aktivieren Sie Desktop-Benachrichtigungen für diese Domain"
],
	"\u0000Please choose your email account provider.\u0001": [
	"Bitte wählen Sie Ihren E-Mail-Anbieter."
],
	"\u0000Please click \"Continue\" if you'd like to continue editing.\u0001": [
	"Wenn Sie das Objekt weiter bearbeiten möchten, klicken Sie bitte auf \"Fortfahren\"."
],
	"\u0000Please comment your confirmation status.\u0001": [
	"Kommentieren Sie bitte Ihren Bestätigungsstatus."
],
	"\u0000Please confirm\u0001": [
	"Bitte bestätigen"
],
	"\u0000Please define at least one action.\u0001": [
	"Bitte legen Sie mindestens eine Aktion fest."
],
	"\u0000Please download the configuration to automatically set up your account.\u0001": [
	"Bitte laden Sie die Konfiguration herunter, um Ihr Konto automatisch einzurichten."
],
	"\u0000Please download the file using the button below.\u0001": [
	"Bitte laden Sie die Datei über die Schaltfläche unten herunter."
],
	"\u0000Please enter a date in the past\u0001": [
	"Bitte geben Sie ein Datum in der Vergangenheit ein"
],
	"\u0000Please enter a description\u0001": [
	"Bitte geben Sie eine Beschreibung ein"
],
	"\u0000Please enter a feed URL.\u0001": [
	"Bitte geben Sie eine Feed-URL ein."
],
	"\u0000Please enter a name.\u0001": [
	"Bitte geben Sie einen Namen ein."
],
	"\u0000Please enter a positive whole number\u0001": [
	"Bitte geben Sie eine positive Ganzzahl ein"
],
	"\u0000Please enter a search query\u0001": [
	"Bitte geben Sie einen Suchbegriff ein"
],
	"\u0000Please enter a valid date\u0001": [
	"Bitte geben Sie ein gültiges Datum ein"
],
	"\u0000Please enter a valid email address\u0001": [
	"Bitte geben Sie eine gültige E-Mail-Adresse ein"
],
	"\u0000Please enter a valid name\u0001": [
	"Bitte geben Sie einen gültigen Namen ein"
],
	"\u0000Please enter a valid number\u0001": [
	"Bitte geben Sie eine gültige Zahl ein"
],
	"\u0000Please enter a valid object\u0001": [
	"Bitte geben Sie ein gültiges Objekt ein"
],
	"\u0000Please enter a valid phone number. Allowed characters are: %1$s\u0001": [
	"Bitte geben Sie eine gültige Telefonnummer ein. Folgende Zeichen sind zulässig: %1$s"
],
	"\u0000Please enter a value\u0001": [
	"Bitte geben Sie einen Wert ein"
],
	"\u0000Please enter correct password\u0001": [
	"Bitte geben Sie ein korrektes Passwort ein"
],
	"\u0000Please enter password.\u0001": [
	"Bitte Passwort eingeben."
],
	"\u0000Please enter the following data: %1$s\u0001": [
	"Bitte geben Sie die folgenden Daten ein: %1$s"
],
	"\u0000Please enter the password.\u0001": [
	"Bitte das Passwort eingeben."
],
	"\u0000Please enter the phone number for the device.\u0001": [
	"Bitte geben Sie die Telefonnummer für das Gerät ein."
],
	"\u0000Please enter the recovery code\u0001": [
	"Bitte geben Sie den Wiederherstellungscode ein"
],
	"\u0000Please enter the same password.\u0001": [
	"Bitte geben Sie das gleiche Passwort ein."
],
	"\u0000Please enter the validation code we just sent to your device.\u0001": [
	"Bitte geben Sie den Validierungscode ein, der gerade an ihr Gerät gesendet wurde."
],
	"\u0000Please enter value between 0 and 100.\u0001": [
	"Bitte geben Sie einen Wert zwischen 0 und 100 ein."
],
	"\u0000Please enter your credentials.\u0001": [
	"Bitte geben Sie Ihre Zugangsdaten ein."
],
	"\u0000Please enter your email address associated with %1$s. You will receive an email that contains a link to reset your password.\u0001": [
	"Bitte geben Sie Ihre mit %1$s verknüpfte E-Mail-Adresse ein. Sie erhalten eine E-Mail, die einen Link zum Zurücksetzen Ihres Passworts enthält."
],
	"\u0000Please enter your mobile phone number, and we´ll send you a link to automatically configure your iOS device! It´s that simple!\u0001": [
	"Bitte geben Sie Ihre Mobilrufnummer ein und wir senden Ihnen einen Link zur automatischen Konfiguration Ihres iOS-Geräts. Es ist ganz einfach!"
],
	"\u0000Please enter your new password.\u0001": [
	"Bitte geben Sie Ihr neues Passwort ein."
],
	"\u0000Please enter your password.\u0001": [
	"Bitte geben Sie Ihr Passwort ein."
],
	"\u0000Please grant access to your webcam first.\u0001": [
	"Bitte gewähren Sie zuerst den Zugriff auf Ihre Webcam."
],
	"\u0000Please insert a date after the start date\u0001": [
	"Bitte geben Sie ein Datum nach dem Startdatum ein"
],
	"\u0000Please note that other participants are removed on calendar import.\u0001": [
	"Bitte beachten Sie, dass andere Teilnehmer beim Kalenderimport entfernt werden."
],
	"\u0000Please note that some categories are predefined and you might not be able to rename or disable them.\u0001": [
	"Bitte beachten Sie, dass einige Kategorien vordefiniert sind und möglicherweise nicht umbenannt oder deaktiviert werden können."
],
	"\u0000Please note that support requests cannot be handled via the feedback form. If you have questions or problems please contact our support directly.\u0001": [
	"Bitte beachten Sie, dass Support-Anfragen nicht über das Feedback-Formular bearbeitet werden können. Sollten Sie Fragen oder Probleme haben, kontaktieren Sie unseren Support bitte direkt."
],
	"\u0000Please note, changing or removing the file extension will cause problems when viewing or editing.\u0001": [
	"Bitte beachten Sie, dass das Ändern oder Entfernen der Dateiendung Probleme beim Betrachten und Bearbeiten der Datei verursacht."
],
	"\u0000Please note: After downloading you will have to enable the profile in the Settings app to complete the installation.\u0001": [
	"Bitte beachten Sie: Nach dem Herunterladen müssen Sie das Profil in der App \"Einstellungen\" aktivieren, um die Installation abzuschließen."
],
	"\u0000Please only drop images here. If you want to send other files, you can send them as attachments.\u0001": [
	"Bitte legen Sie nur Bilder hier ab. Wenn Sie andere Dateien senden möchten, können Sie sie als Anhänge senden."
],
	"\u0000Please only use numeric characters for phone number\u0001": [
	"Bitte verwenden Sie nur numerische Zeichen für die Telefonnummer"
],
	"\u0000Please rate the following application:\u0001": [
	"Bitte bewerten Sie die folgende Applikation:"
],
	"\u0000Please rate this product\u0001": [
	"Bitte bewerten Sie dieses Produkt"
],
	"\u0000Please scan this code with your phone's camera:\u0001": [
	"Scannen Sie diesen Code bitte mit Ihrer Telefonkamera:"
],
	"\u0000Please select a device to use for additional authentication\u0001": [
	"Bitte wählen Sie ein Gerät aus, das Sie für eine zusätzliche Authentifizierung verwenden können"
],
	"\u0000Please select a file to import\u0001": [
	"Bitte wählen Sie eine zu importierende Datei"
],
	"\u0000Please select a rating.\u0001": [
	"Bitte wählen Sie eine Bewertung."
],
	"\u0000Please select a time for the appointment\u0001": [
	"Bitte wählen Sie eine Uhrzeit für den Termin"
],
	"\u0000Please select a valid iCal file to import\u0001": [
	"Wählen Sie bitte eine gültige iCal-Datei für den Import"
],
	"\u0000Please select a valid image file to insert\u0001": [
	"Wählen Sie bitte eine gültige Bilddatei zum Einfügen"
],
	"\u0000Please select at least one day\u0001": [
	"Bitte wählen Sie mindestens einen Tag"
],
	"\u0000Please select the folder to apply the rule to\u0001": [
	"Wählen Sie den Ordner aus, auf den die Regel angewendet werden soll"
],
	"\u0000Please select the platform of your device.\u0001": [
	"Bitte wählen Sie die Plattform Ihres Geräts."
],
	"\u0000Please set day and month properly\u0001": [
	"Bitte geben Sie einen gültigen Tag und Monat ein"
],
	"\u0000Please sign in again to continue\u0001": [
	"Zum Fortfahren bitte erneut anmelden"
],
	"\u0000Please touch/activate your device\u0001": [
	"Bitte aktivieren Sie Ihr Gerät"
],
	"\u0000Please try to add your email address <b>%1$s</b> to your email client to check if it can be automatically configured.\u0001": [
	"Versuchen Sie bitte, Ihre E-Mailadresse <b>%1$s</b> zu Ihrem E-Mail-Client hinzuzufügen, um zu prüfen, ob sie automatisch konfiguriert werden kann."
],
	"\u0000Please use the \"Connect your device\" wizard to download %s\u0001": [
	"Bitte verwenden Sie den Assistenten \"Ihr Gerät verbinden\" zum Herunterladen von %s"
],
	"\u0000Please wait for the previous operation to finish\u0001": [
	"Bitte warten Sie, bis der vorherige Vorgang beendet ist"
],
	"\u0000Plus\u0001": [
	"Plus"
],
	"\u0000Pop out standalone viewer\u0001": [
	"In eigenem Fenster öffnen"
],
	"\u0000Port\u0001": [
	"Port"
],
	"\u0000Portal\u0001": [
	"Portal"
],
	"app\u0000Portal\u0001": [
	"Portal"
],
	"\u0000Portal Widgets\u0001": [
	"Portal-Widgets"
],
	"\u0000Portal widgets\u0001": [
	"Portal-Widgets"
],
	"\u0000Position\u0001": [
	"Position"
],
	"\u0000Position %s\u0001": [
	"Position %s"
],
	"\u0000Postal addresses might appear in address book entries as well as in the appointment location field.\u0001": [
	"Postadressen können sowohl in Adressbucheinträgen als auch im Feld für den Terminort erscheinen."
],
	"\u0000Postcode\u0001": [
	"PLZ"
],
	"\u0000PowerDNS parental control\u0001": [
	"PowerDNS-Jugendschutz"
],
	"\u0000Premium\u0001": [
	"Premium"
],
	"\u0000Presentations\u0001": [
	"Präsentationen"
],
	"\u0000Press ENTER\u0001": [
	"Eingabetaste drücken"
],
	"\u0000Press [enter] to jump to %1$s\u0001": [
	"Durch Drücken der Eingabetaste öffnen Sie %1$s"
],
	"\u0000Press [enter] to jump to the flicker stream.\u0001": [
	"Durch Drücken der Eingabetaste öffnen Sie den Flicker-Stream."
],
	"\u0000Press [enter] to jump to the rss stream.\u0001": [
	"Durch Drücken der Eingabetaste öffnen Sie den RSS-Stream."
],
	"\u0000Press enter to play\u0001": [
	"Zum Abspielen Enter drücken"
],
	"\u0000Press spacebar to grab and re-order. Press backspace to delete.\u0001": [
	"Drücken Sie die Leertaste zum Markieren und Neusortieren. Drücken Sie die Rücktaste zum Löschen."
],
	"\u0000Press to open Details\u0001": [
	"Zum Öffnen der Details drücken"
],
	"\u0000Preview\u0001": [
	"Vorschau"
],
	"\u0000Preview generated. Downloading the file.\u0001": [
	"Vorschau generiert. Datei wird heruntergeladen."
],
	"\u0000Previous\u0001": [
	"Zurück"
],
	"\u0000Previous day\u0001": [
	"Vorheriger Tag"
],
	"\u0000Previous file\u0001": [
	"Vorherige Datei"
],
	"\u0000Previous message\u0001": [
	"Vorherige Nachricht"
],
	"\u0000Previous month\u0001": [
	"Letzter Monat"
],
	"\u0000Previous page\u0001": [
	"Vorherige Seite"
],
	"\u0000Previous week\u0001": [
	"Letzte Woche"
],
	"\u0000Previous year\u0001": [
	"Vorheriges Jahr"
],
	"\u0000Previously exclusive to desktop, the year view is now also available when using your mobile device!\u0001": [
	"Die Jahresansicht, die bisher nur auf dem Desktop verfügbar war, ist jetzt auch auf Ihrem mobilen Gerät verfügbar!"
],
	"\u0000Primary account\u0001": [
	"Primäres Konto"
],
	"\u0000Print\u0001": [
	"Drucken"
],
	"\u0000Print as PDF\u0001": [
	"Als PDF drucken"
],
	"\u0000Print preview\u0001": [
	"Druckvorschau"
],
	"\u0000Print tasks\u0001": [
	"Aufgaben drucken"
],
	"\u0000Printout\u0001": [
	"Ausdruck"
],
	"\u0000Priority\u0001": [
	"Priorität"
],
	"E-Mail\u0000Priority\u0001": [
	"Wichtigkeit"
],
	"Tasks\u0000Priority\u0001": [
	"Priorität"
],
	"\u0000Privacy Policy\u0001": [
	"Datenschutzrichtlinie"
],
	"\u0000Private\u0001": [
	"Privat"
],
	"\u0000Private contact\u0001": [
	"Privater Kontakt"
],
	"\u0000Private link: Only people who have access to the file/folder can use it. Use it to point to members of your organization to this file/folder.\u0001": [
	"Privater Link: Nur Personen, die Zugriff auf die Datei/den Ordner haben, können sie/ihn verwenden. Verwenden Sie ihn, um Mitglieder Ihrer Organisation auf diese Datei/diesen Ordner zu verweisen."
],
	"\u0000Problem getting 2-step verification providers\u0001": [
	"Problem beim Abrufen von verfügbaren Zwei-Faktor-Authentifizierungs-Anbietern"
],
	"\u0000Problem registering device\u0001": [
	"Problem beim Registrieren des Geräts"
],
	"\u0000Process subsequent rules\u0001": [
	"Gegen nachfolgende Regeln prüfen"
],
	"\u0000Process subsequent rules of %1$s\u0001": [
	"Gegen nachfolgende Regeln von %1$s prüfen"
],
	"\u0000Profession\u0001": [
	"Beruf"
],
	"\u0000Progress\u0001": [
	"Fortschritt"
],
	"\u0000Progress %1$s %\u0001": [
	"Fortschritt %1$s %"
],
	"\u0000Progress in %\u0001": [
	"Fortschritt in %"
],
	"\u0000Progress must be a valid number between 0 and 100\u0001": [
	"Der Fortschritt muss mit einer gültigen Ziffer zwischen 0 und 100 angegeben werden"
],
	"\u0000Properties\u0001": [
	"Eigenschaften"
],
	"\u0000Public\u0001": [
	"Öffentlich"
],
	"\u0000Public address books\u0001": [
	"Öffentliche Adressbücher"
],
	"\u0000Public address lists\u0001": [
	"Öffentliche Adresslisten"
],
	"\u0000Public calendars\u0001": [
	"Öffentliche Kalender"
],
	"\u0000Public folders\u0001": [
	"Öffentliche Ordner"
],
	"\u0000Public link\u0001": [
	"Öffentlicher Link"
],
	"\u0000Public link options\u0001": [
	"Optionen für öffentlichen Link"
],
	"\u0000Public lists\u0001": [
	"Öffentliche Listen"
],
	"\u0000Public photos by user\u0001": [
	"Öffentliche Fotos nach Benutzer"
],
	"\u0000Public tasks folders\u0001": [
	"Öffentliche Aufgabenordner"
],
	"\u0000Purple\u0001": [
	"Violett"
],
	"\u0000QR code expired\u0001": [
	"QR-Code abgelaufen"
],
	"\u0000QR code will expire in %1$ds\u0001": [
	"QR-Code wird in %1$d Sek. ablaufen"
],
	"\u0000Quick launch bar\u0001": [
	"Schnellstartleiste"
],
	"\u0000Quota\u0001": [
	"Speicherplatz"
],
	"compose\u0000RE\u0001": [
	"AW"
],
	"\u0000RSS Feed\u0001": [
	"RSS-Feed"
],
	"\u0000RSS Feeds\u0001": [
	"RSS-Feeds"
],
	"\u0000Read all objects\u0001": [
	"Alle Objekte lesen"
],
	"\u0000Read and write\u0001": [
	"Lesen und schreiben"
],
	"\u0000Read only\u0001": [
	"Nur lesen"
],
	"\u0000Read own objects\u0001": [
	"Eigene Objekte lesen"
],
	"\u0000Read permissions\u0001": [
	"Leseberechtigungen"
],
	"\u0000Read, write and delete\u0001": [
	"Lesen, schreiben und löschen"
],
	"\u0000Reading\u0001": [
	"Lesen"
],
	"\u0000Reading pane\u0001": [
	"Lesebereich"
],
	"\u0000Reauthentication required for this action\u0001": [
	"Diese Aktion erfordert eine erneute Authentifizierung"
],
	"\u0000Reauthorize\u0001": [
	"Erneut autorisieren"
],
	"\u0000Receive notification when someone accesses the file(s)\u0001": [
	"Benachrichtigung beim Zugriff auf eine oder mehrere Dateien"
],
	"\u0000Receive notification when someone finished downloading file(s)\u0001": [
	"Benachrichtigung nach Beenden des Herunterladens einer oder mehrerer Dateien"
],
	"\u0000Receive notification when the link expires\u0001": [
	"Benachrichtigung bei Ablauf des Links"
],
	"\u0000Receive notifications when a participant accepted or declined a task created by you\u0001": [
	"Benachrichtigung als Aufgabenersteller, wenn Teilnehmer zusagen oder ablehnen"
],
	"\u0000Receive notifications when a participant accepted or declined a task in which you participate\u0001": [
	"Benachrichtigung als Aufgabenteilnehmer, wenn andere Teilnehmer zusagen oder ablehnen"
],
	"\u0000Receive notifications when a task in which you participate is created, modified or deleted\u0001": [
	"Benachrichtigung als Aufgabenteilnehmer, wenn Aufgabe erstellt, geändert oder gelöscht wird"
],
	"\u0000Received\u0001": [
	"Empfangen"
],
	"\u0000Received mails\u0001": [
	"Erhaltene E-Mails"
],
	"\u0000Recent conversations\u0001": [
	"Kürzlicher E-Mail-Austausch"
],
	"\u0000Recent files\u0001": [
	"Neueste Dateien"
],
	"\u0000Recently changed files\u0001": [
	"Kürzlich geänderte Dateien"
],
	"\u0000Recently used\u0001": [
	"Kürzlich verwendet"
],
	"\u0000Recipient\u0001": [
	"Empfänger"
],
	"\u0000Recover\u0001": [
	"Wiederherstellen"
],
	"\u0000Recover external account passwords\u0001": [
	"Passwörter für externe Konten wiederherstellen"
],
	"\u0000Recovery Code\u0001": [
	"Wiederherstellungscode"
],
	"\u0000Recovery Options\u0001": [
	"Wiederherstellungsoptionen"
],
	"\u0000Recovery code\u0001": [
	"Wiederherstellungscode"
],
	"\u0000Recovery code must be 32 characters long.\u0001": [
	"Der Wiederherstellungscode muss 32 Zeichen lang sein."
],
	"\u0000Recurring tasks need a valid due date.\u0001": [
	"Serienaufgaben benötigen ein gültiges Enddatum."
],
	"\u0000Recurring tasks need a valid start date.\u0001": [
	"Serienaufgaben benötigen ein gültiges Startdatum."
],
	"\u0000Red\u0001": [
	"Rot"
],
	"\u0000Redirect mails from %1$s to %2$s\u0001": [
	"E-Mails von %1$s nach %2$s umleiten"
],
	"\u0000Redirect mails to %1$s to %2$s\u0001": [
	"E-Mails an %1$s nach %2$s umleiten"
],
	"\u0000Redirect mails with subject %1$s to %2$s\u0001": [
	"E-Mails mit dem Betreff %1$s nach %2$s umleiten"
],
	"\u0000Redirect to\u0001": [
	"Umleiten nach"
],
	"\u0000Reduce to widget summary on smartphones\u0001": [
	"Auf Smartphones auf Widget-Übersicht reduzieren"
],
	"\u0000Refresh\u0001": [
	"Aktualisieren"
],
	"\u0000Refresh folders\u0001": [
	"Ordner aktualisieren"
],
	"\u0000Refresh rate in minutes\u0001": [
	"Aktualisierungsintervall in Minuten"
],
	"\u0000Refresh this calendar\u0001": [
	"Diesen Kalender aktualisieren"
],
	"\u0000Refresh. Current interval (%1$s min) can be customized in settings.\u0001": [
	"Aktualisieren. Das aktuelle Intervall (%1$s Minuten) kann in den Einstellungen angepasst werden."
],
	"\u0000Refreshing calendar might take some time…\u0001": [
	"Das Aktualisieren des Kalenders kann einige Zeit in Anspruch nehmen…"
],
	"\u0000Regex\u0001": [
	"Regex"
],
	"\u0000Regional settings\u0001": [
	"Regionale Einstellungen"
],
	"\u0000Register now\u0001": [
	"Jetzt registrieren"
],
	"\u0000Registered phone number:\u0001": [
	"Registrierte Telefonnummer:"
],
	"\u0000Reject changes\u0001": [
	"Änderungen ablehnen"
],
	"\u0000Reject mails from %1$s with reason %2$s\u0001": [
	"E-Mails von %1$s mit der Begründung %2$s ablehnen"
],
	"\u0000Reject mails to %1$s with reason %2$s\u0001": [
	"E-Mails an %1$s mit der Begründung %2$s ablehnen"
],
	"\u0000Reject mails with subject %1$s with reason %2$s\u0001": [
	"E-Mails mit dem Betreff %1$s mit der Begründung %2$s ablehnen"
],
	"\u0000Reject participant\u0001": [
	"Teilnehmer ablehnen"
],
	"\u0000Reject with reason\u0001": [
	"Ablehnen mit Begründung"
],
	"\u0000Reload\u0001": [
	"Neu laden"
],
	"\u0000Reload QR code\u0001": [
	"QR-Code neu laden"
],
	"\u0000Reload now\u0001": [
	"Jetzt neu laden"
],
	"\u0000Reload page\u0001": [
	"Seite neu laden"
],
	"\u0000Remaining time: %1$s\u0001": [
	"Verbleibende Zeit: %1$s"
],
	"\u0000Remind me\u0001": [
	"Mich erinnern"
],
	"\u0000Remind me again\u0001": [
	"Erneut erinnern"
],
	"\u0000Remind me later\u0001": [
	"Später erinnern"
],
	"\u0000Reminder\u0001": [
	"Erinnerung"
],
	"\u0000Reminder %1$d\u0001": [
	"Erinnerung %1$d"
],
	"\u0000Reminder date\u0001": [
	"Datum für Erinnerung"
],
	"\u0000Reminder for appointment %1$s.\u0001": [
	"Erinnerung für Termin %1$s."
],
	"\u0000Reminder for task %1$s.\u0001": [
	"Erinnerung für Aufgabe %1$s."
],
	"\u0000Reminder for: %1$s\u0001": [
	"Erinnerung für: %1$s"
],
	"\u0000Reminder has been created\u0001": [
	"Erinnerung wurde erstellt"
],
	"\u0000Reminders\u0001": [
	"Erinnerungen"
],
	"\u0000Remove\u0001": [
	"Entfernen"
],
	"\u0000Remove %1$s\u0001": [
	"%1$s entfernen"
],
	"\u0000Remove Appointment\u0001": [
	"Termin entfernen"
],
	"\u0000Remove IMAP keyword\u0001": [
	"IMAP-Schlüsselwort entfernen"
],
	"\u0000Remove account\u0001": [
	"Konto entfernen"
],
	"\u0000Remove all shares\u0001": [
	"Alle Freigaben entfernen"
],
	"\u0000Remove attachment \"%1$s\"\u0001": [
	"Anhang \"%1$s\" entfernen"
],
	"\u0000Remove category %s\u0001": [
	"Kategorie %s entfernen"
],
	"\u0000Remove certificate\u0001": [
	"Zertifikat entfernen"
],
	"\u0000Remove certificate %1$s\u0001": [
	"Zertifikat %1$s entfernen"
],
	"\u0000Remove contact\u0001": [
	"Kontakt entfernen"
],
	"\u0000Remove contact from selection\u0001": [
	"Kontakt aus der Auswahl entfernen"
],
	"\u0000Remove copy from server after retrieving a message\u0001": [
	"Kopie nach Empfang einer Nachricht vom Server löschen"
],
	"\u0000Remove deputy %1$s\u0001": [
	"Stellvertreter %1$s entfernen"
],
	"\u0000Remove filter \"%1$s %2$s\"\u0001": [
	"Filter \"%1$s %2$s\" entfernen"
],
	"\u0000Remove from %1$s\u0001": [
	"Aus %1$s entfernen"
],
	"\u0000Remove from favorites\u0001": [
	"Aus Favoriten entfernen"
],
	"\u0000Remove member\u0001": [
	"Mitglied entfernen"
],
	"\u0000Remove passwords\u0001": [
	"Passwörter entfernen"
],
	"\u0000Remove photo\u0001": [
	"Foto entfernen"
],
	"\u0000Remove reminder\u0001": [
	"Erinnerung entfernen"
],
	"\u0000Remove resource calendar\u0001": [
	"Ressourcenkalender entfernen"
],
	"\u0000Remove shares\u0001": [
	"Freigaben entfernen"
],
	"\u0000Removed %1$s, %2$s.\u0001": [
	"%1$s, %2$s entfernt."
],
	"\u0000Removed %1$s.\u0001": [
	"%1$s wurde entfernt."
],
	"\u0000Rename\u0001": [
	"Umbenennen"
],
	"\u0000Rename File\u0001": [
	"Datei umbenennen"
],
	"\u0000Rename automatically and keep both files separately\u0001": [
	"Automatisch umbenennen und beide Dateien getrennt speichern"
],
	"\u0000Rename folder\u0001": [
	"Ordner umbenennen"
],
	"\u0000Rename resource group\u0001": [
	"Ressourcengruppe umbenennen"
],
	"\u0000Repeat\u0001": [
	"Wiederholen"
],
	"\u0000Repeat by\u0001": [
	"Wiederholen am"
],
	"\u0000Repeat new password\u0001": [
	"Neues Passwort wiederholen"
],
	"\u0000Repeat slideshow\u0001": [
	"Diashow wiederholen"
],
	"\u0000Reply\u0001": [
	"Antworten"
],
	"\u0000Reply To\u0001": [
	"Antwort an"
],
	"compose\u0000Reply To\u0001": [
	"Antwort an"
],
	"\u0000Reply all\u0001": [
	"Allen antworten"
],
	"\u0000Reply to\u0001": [
	"Antwort an"
],
	"\u0000Reply to all recipients\u0001": [
	"Antwort an alle Empfänger"
],
	"\u0000Reply to email\u0001": [
	"Auf E-Mail antworten"
],
	"\u0000Reply to sender\u0001": [
	"Antwort an Absender"
],
	"\u0000Request Appointment\u0001": [
	"Terminanfrage senden"
],
	"\u0000Request download\u0001": [
	"Download anfordern"
],
	"\u0000Request new download\u0001": [
	"Neuen Download anfordern"
],
	"\u0000Request read receipt\u0001": [
	"Lesebestätigung anfordern"
],
	"\u0000Requesting device information. Please wait…\u0001": [
	"Geräteinformationen werden angefordert. Bitte warten…"
],
	"\u0000Resend invitation\u0001": [
	"Einladung erneut senden"
],
	"\u0000Resent-From\u0001": [
	"Resent-From"
],
	"\u0000Resent-To\u0001": [
	"Resent-To"
],
	"\u0000Reservation for: %1$s\u0001": [
	"Reservierung für: %1$s"
],
	"\u0000Reservation not possible in the past\u0001": [
	"Reservierung in der Vergangenheit nicht möglich"
],
	"\u0000Reserved\u0001": [
	"Gebucht"
],
	"\u0000Reset\u0001": [
	"Zurücksetzen"
],
	"\u0000Reset password\u0001": [
	"Passwort zurücksetzen"
],
	"\u0000Reset this list\u0001": [
	"Diese Liste zurücksetzen"
],
	"\u0000Resource\u0001": [
	"Ressource"
],
	"\u0000Resource booking request\u0001": [
	"Buchungsanfrage für Ressourcen"
],
	"\u0000Resource booking request for: %1$s\u0001": [
	"Ressourcen-Buchungsanfrage für: %1$s"
],
	"\u0000Resource booking requests\u0001": [
	"Buchungsanfragen für Ressourcen"
],
	"\u0000Resource calendar group name\u0001": [
	"Name der Ressourcenkalendergruppe"
],
	"\u0000Resource delegates\u0001": [
	"Ressourcenbeauftragte"
],
	"\u0000Resource delegates manually accept or decline the booking request.\u0001": [
	"Ressourcenbeauftragte bestätigen oder lehnen die Buchungsanfrage manuell ab."
],
	"\u0000Resource group\u0001": [
	"Ressourcengruppe"
],
	"\u0000Resource list\u0001": [
	"Ressourcenliste"
],
	"\u0000Resources\u0001": [
	"Ressourcen"
],
	"\u0000Restart initial setup\u0001": [
	"Ersteinrichtung neu starten"
],
	"\u0000Restore\u0001": [
	"Wiederherstellen"
],
	"\u0000Restore contact\u0001": [
	"Kontakt wiederherstellen"
],
	"\u0000Restore draft\u0001": [
	"Entwurf wiederherstellen"
],
	"\u0000Restored into folder:\n\n%s\u0001": [
	"Wiederhergestellt in Ordner:\n\n%s"
],
	"\u0000Restored into multiple folders:\n\n%s\u0001": [
	"Wiederhergestellt in mehreren Ordnern:\n\n%s"
],
	"\u0000Restrict showing external images to reduce tracking\u0001": [
	"Die Anzeige externer Bilder einschränken, um die Nachverfolgung zu reduzieren"
],
	"\u0000Retry\u0001": [
	"Erneut versuchen"
],
	"\u0000Reviewer\u0001": [
	"Überarbeiter"
],
	"\u0000Revoke\u0001": [
	"Widerrufen"
],
	"\u0000Revoke access\u0001": [
	"Zugriff widerrufen"
],
	"\u0000Rich Text Area. Press ALT-F10 for toolbar\u0001": [
	"Rich-Text-Bereich. Drücken Sie ALT-F10 für Werkzeugleiste"
],
	"\u0000Room number\u0001": [
	"Raumnummer"
],
	"\u0000Rotate left\u0001": [
	"Nach links drehen"
],
	"\u0000Rotate right\u0001": [
	"Nach rechts drehen"
],
	"\u0000Rows\u0001": [
	"Zeilen"
],
	"\u0000Rule name\u0001": [
	"Regelname"
],
	"\u0000Rules\u0001": [
	"Regeln"
],
	"\u0000Rules provide you with the power to effortlessly organize and streamline your email inbox, enabling actions like automatically moving emails from specific senders to designated folders, deleting or marking them as read, or forwarding them to another email address.\u0001": [
	"Mit Regeln können Sie Ihren E-Mail-Posteingang mühelos organisieren und optimieren, indem Sie beispielsweise E-Mails von bestimmten Absendern automatisch in bestimmte Ordner verschieben, löschen, als gelesen markieren oder an eine andere E-Mail-Adresse weiterleiten."
],
	"\u0000Run slideshow\u0001": [
	"Diashow starten"
],
	"\u0000SMS\u0001": [
	"SMS"
],
	"\u0000SMS Code\u0001": [
	"SMS-Code"
],
	"\u0000SMTP\u0001": [
	"SMTP"
],
	"\u0000SSL/TLS\u0001": [
	"SSL / TLS"
],
	"\u0000Sales Volume\u0001": [
	"Umsatz"
],
	"superessive\u0000Saturday\u0001": [
	"Samstag"
],
	"\u0000Save\u0001": [
	"Speichern"
],
	"\u0000Save and apply rule now\u0001": [
	"Regel jetzt speichern und anwenden"
],
	"\u0000Save and close\u0001": [
	"Speichern und schließen"
],
	"\u0000Save appointment\u0001": [
	"Termin speichern"
],
	"\u0000Save as PDF\u0001": [
	"Als PDF speichern"
],
	"\u0000Save as distribution list\u0001": [
	"Als Verteilerliste speichern"
],
	"\u0000Save as file\u0001": [
	"Als Datei speichern"
],
	"\u0000Save attachment\u0001": [
	"Anhang speichern"
],
	"\u0000Save changes\u0001": [
	"Änderungen speichern"
],
	"\u0000Save contact\u0001": [
	"Kontakt speichern"
],
	"\u0000Save draft\u0001": [
	"Entwurf speichern"
],
	"\u0000Save draft and close\u0001": [
	"Entwurf speichern und schließen"
],
	"\u0000Save task\u0001": [
	"Aufgabe speichern"
],
	"\u0000Save to %1$s\u0001": [
	"In %1$s speichern"
],
	"\u0000Saved %s\u0001": [
	"Gespeichert %s"
],
	"\u0000Saved appointment attachment\u0001": [
	"Terminanhang wurde gespeichert"
],
	"\u0000Saved attachment\u0001": [
	"Anhang wurde gespeichert"
],
	"\u0000Saved contact attachment\u0001": [
	"Kontaktanhang wurde gespeichert"
],
	"\u0000Saved email attachment\u0001": [
	"E-Mail-Anhang wurde gespeichert"
],
	"\u0000Saved in\u0001": [
	"Gespeichert unter"
],
	"\u0000Saved task attachment\u0001": [
	"Aufgabenanhang wurde gespeichert"
],
	"\u0000Saving attachments…\u0001": [
	"Anhänge werden gespeichert…"
],
	"\u0000Saving attachment…\u0001": [
	"Anhang wird gespeichert…"
],
	"\u0000Saving…\u0001": [
	"Speichern…"
],
	"\u0000Scan the QR code with your authenticator.\u0001": [
	"Scannen Sie den QR-Code mit Ihrem Authentifikator."
],
	"\u0000Scan this QR code to sign in on another device\u0001": [
	"Scannen Sie diesen QR-Code, um sich auf einem anderen Gerät anzumelden"
],
	"\u0000Scan this code with your phone's camera to synchronize your \"%1$s\":\u0001": [
	"Zum Synchronisieren Ihres %1$s scannen Sie diesen Code mit Ihrer Telefonkamera:"
],
	"\u0000Scan this code with your phone's camera to synchronize your Mail, Calendar and Address Book via Exchange Active Sync:\u0001": [
	"Zum Synchronisieren Ihrer E-Mails, Ihres Kalenders und Adressbuchs via Exchange Active Sync scannen Sie diesen Code mit Ihrer Telefonkamera:"
],
	"\u0000Schedule\u0001": [
	"Planen"
],
	"\u0000Schedule email\u0001": [
	"E-Mail-Versand planen"
],
	"\u0000Schedule send\u0001": [
	"Senden planen"
],
	"\u0000Schedule will be discarded\u0001": [
	"Die Planung wird verworfen"
],
	"\u0000Scheduled date\u0001": [
	"Geplantes Datum"
],
	"\u0000Scheduled email sending\u0001": [
	"Geplanter E-Mail-Versand"
],
	"\u0000Scheduling\u0001": [
	"Planung"
],
	"app\u0000Scheduling\u0001": [
	"Planung"
],
	"\u0000Search\u0001": [
	"Suchen"
],
	"\u0000Search all address lists\u0001": [
	"In allen Adresslisten suchen"
],
	"\u0000Search appointments\u0001": [
	"In Terminen suchen"
],
	"\u0000Search contacts\u0001": [
	"In Kontakten suchen"
],
	"\u0000Search email\u0001": [
	"In E-Mail suchen"
],
	"\u0000Search files\u0001": [
	"In Dateien suchen"
],
	"\u0000Search for contacts\u0001": [
	"Nach Kontakten suchen"
],
	"\u0000Search for name, department, position\u0001": [
	"Nach Name, Abteilung, Position suchen"
],
	"\u0000Search for resources\u0001": [
	"Nach Ressourcen suchen"
],
	"\u0000Search in\u0001": [
	"Suchen in"
],
	"search\u0000Search in\u0001": [
	"Suchen in"
],
	"\u0000Search in %1$s\u0001": [
	"In %1$s suchen"
],
	"\u0000Search in %1$s, after %2$s\u0001": [
	"In %1$s suchen, nach %2$s"
],
	"\u0000Search in %1$s, before %2$s \u0001": [
	"In %1$s suchen, vor %2$s "
],
	"\u0000Search in %1$s, between %2$s and %3$s\u0001": [
	"In %1$s suchen, zwischen %2$s und %3$s"
],
	"\u0000Search photos\u0001": [
	"Fotos suchen"
],
	"\u0000Search resources\u0001": [
	"Ressourcen durchsuchen"
],
	"\u0000Search results\u0001": [
	"Suchergebnisse"
],
	"\u0000Search tasks\u0001": [
	"In Aufgaben suchen"
],
	"\u0000Search: %1$s\u0001": [
	"Suchen: %1$s"
],
	"\u0000Searching is one of the most used functions. We have simplified and improved the search feature. It is now located in the most prominent position: upper, top central navigation bar. It's a simple and easy-to-use text field and more sophisticated filters are available in a separate dropdown.\u0001": [
	"Als eines der meistbenutzten Features haben wir die Suchfunktion vereinfacht und verbessert. Die Suchleiste wurde nach oben in die Mitte des Navigationsbereichs verschoben. Es ist ein simples und einfach zu bedienendes Eingabefeld mit einem zusätzlichen Ausklappmenü, falls komplexere Suchfilter benötigt werden."
],
	"\u0000Secret\u0001": [
	"Geheim"
],
	"\u0000Security\u0001": [
	"Sicherheit"
],
	"\u0000Security & Privacy\u0001": [
	"Sicherheit & Datenschutz"
],
	"\u0000Security Token\u0001": [
	"Sicherheits-Token"
],
	"\u0000See which devices are currently signed in\u0001": [
	"Hier sehen Sie, welche Geräte derzeit angemeldet sind"
],
	"\u0000Select\u0001": [
	"Wählen"
],
	"dropdown\u0000Select\u0001": [
	"Wählen"
],
	"select-contacts\u0000Select\u0001": [
	"Auswählen"
],
	"\u0000Select 2-step verification method\u0001": [
	"Zwei-Faktor-Authentifizierung wählen"
],
	"\u0000Select <b>Add to Dock</b>\u0001": [
	"Wählen Sie <b>Zum Dock hinzufügen</b>"
],
	"\u0000Select <b>Add to Home Screen</b>\u0001": [
	"Wählen Sie <b>Zum Startbildschirm hinzufügen</b>"
],
	"\u0000Select <b>Add to Home Screen</b>.\u0001": [
	"Wählen Sie <b>Zum Startbildschirm hinzufügen</b>."
],
	"\u0000Select BCC contacts\u0001": [
	"BCC-Kontakte auswählen"
],
	"\u0000Select CC contacts\u0001": [
	"CC-Kontakte auswählen"
],
	"\u0000Select a checkbox to define a custom name for that address; otherwise the mail account's default name will be used. If you want to use an address anonymously, select the checkbox and leave the field empty.\u0001": [
	"Bestimmen Sie einen benutzerdefinierten Namen für diese Adresse, indem Sie ein Kontrollfeld markieren. Andernfalls wird der Standardname des E-Mail-Kontos verwendet. Wollen Sie eine Adresse anonym verwenden, markieren Sie das Kontrollfeld und lassen Sie das Feld leer."
],
	"\u0000Select all\u0001": [
	"Alle wählen"
],
	"\u0000Select all messages\u0001": [
	"Alle Nachrichten auswählen"
],
	"\u0000Select contacts\u0001": [
	"Kontakte auswählen"
],
	"\u0000Select file\u0001": [
	"Datei wählen"
],
	"\u0000Select folder\u0001": [
	"Ordner wählen"
],
	"\u0000Select newest read message automatically at start\u0001": [
	"Beim Start automatisch die neueste gelesene E-Mail auswählen"
],
	"\u0000Select print layout\u0001": [
	"Drucklayout wählen"
],
	"\u0000Select reply-to email addresses\u0001": [
	"Empfängeradressen auswählen"
],
	"\u0000Select resources\u0001": [
	"Ressourcen wählen"
],
	"\u0000Select time zone\u0001": [
	"Zeitzone auswählen"
],
	"\u0000Select users\u0001": [
	"Benutzer auswählen"
],
	"\u0000Select your default sender address\u0001": [
	"Wählen Sie Ihre Standard-Absenderadresse"
],
	"\u0000Select your language and time zone\u0001": [
	"Wählen Sie Ihre Sprache und Zeitzone"
],
	"\u0000Select your preferred mail app layout.\u0001": [
	"Wählen Sie Ihr bevorzugtes Mail-App-Layout."
],
	"\u0000Selected resources were automatically added to this appointment.\u0001": [
	"Ausgewählte Ressourcen wurden automatisch zu diesem Termin hinzugefügt."
],
	"\u0000Selection Details\u0001": [
	"Auswahl-Details"
],
	"\u0000Send\u0001": [
	"Senden"
],
	"\u0000Send Appointment\u0001": [
	"Termin senden"
],
	"\u0000Send Monday morning\u0001": [
	"Montagmorgen senden"
],
	"\u0000Send SMS %1$s after end.\u0001": [
	"%1$s nach Ende SMS senden."
],
	"\u0000Send SMS %1$s after start.\u0001": [
	"%1$s nach Beginn SMS senden."
],
	"\u0000Send SMS %1$s before end.\u0001": [
	"%1$s vor Ende SMS senden."
],
	"\u0000Send SMS %1$s before start.\u0001": [
	"%1$s vor Beginn SMS senden."
],
	"\u0000Send SMS at %1$s.\u0001": [
	"Am %1$s SMS senden."
],
	"\u0000Send SMS at end.\u0001": [
	"Am Ende SMS senden."
],
	"\u0000Send SMS at start.\u0001": [
	"Bei Beginn SMS senden."
],
	"\u0000Send a read receipt\u0001": [
	"Lesebestätigung senden"
],
	"\u0000Send as vCard\u0001": [
	"Als vCard senden"
],
	"\u0000Send by email\u0001": [
	"Per E-Mail senden"
],
	"\u0000Send email\u0001": [
	"E-Mail senden"
],
	"\u0000Send email %1$s after end.\u0001": [
	"%1$s nach Ende E-Mail senden."
],
	"\u0000Send email %1$s after start.\u0001": [
	"%1$s nach Start E-Mail senden."
],
	"\u0000Send email %1$s before end.\u0001": [
	"%1$s vor Ende E-Mail senden."
],
	"\u0000Send email %1$s before start.\u0001": [
	"%1$s vor Start E-Mail senden."
],
	"\u0000Send email at %1$s.\u0001": [
	"Am %1$s E-Mail senden."
],
	"\u0000Send email at end.\u0001": [
	"Am Ende E-Mail senden."
],
	"\u0000Send email at start.\u0001": [
	"Am Beginn E-Mail senden."
],
	"\u0000Send email to all participants\u0001": [
	"E-Mail an alle Teilnehmer senden"
],
	"\u0000Send from\u0001": [
	"Absenden von"
],
	"\u0000Send invitations\u0001": [
	"Einladungen senden"
],
	"\u0000Send notification by email\u0001": [
	"Benachrichtigung per E-Mail senden"
],
	"\u0000Send this morning\u0001": [
	"Heute Morgen senden"
],
	"\u0000Send tomorrow morning\u0001": [
	"Morgen früh senden"
],
	"\u0000Send vacation notice during this time only\u0001": [
	"Abwesenheitsbenachrichtigung nur für diese Dauer versenden"
],
	"\u0000Send with empty attachment\u0001": [
	"Mit leerem Anhang senden"
],
	"\u0000Send without attachment\u0001": [
	"Ohne Anhang senden"
],
	"\u0000Sender\u0001": [
	"Absender"
],
	"\u0000Sender address\u0001": [
	"Absenderadresse"
],
	"\u0000Sender email address\u0001": [
	"E-Mail-Adresse des Absenders"
],
	"\u0000Sender name\u0001": [
	"Name des Absenders"
],
	"\u0000Sending email can be delayed so that you can cancel sending if it happens by mistake or you forgot something.\u0001": [
	"Der Versand von E-Mails kann verzögert werden. Somit können Sie einen versehentlichen oder unvollständigen Versand abbrechen."
],
	"\u0000Sending email in progress\u0001": [
	"E-Mail-Versand in Bearbeitung"
],
	"\u0000Sending has been canceled. The email has been moved to the drafts folder.\u0001": [
	"Der Sendevorgang wurde abgebrochen. Die E-Mail wurde in den Ordner \"Entwürfe\" verschoben."
],
	"\u0000Sending planned for\u0001": [
	"Senden geplant für"
],
	"\u0000Sending…\u0001": [
	"Senden…"
],
	"\u0000Sent\u0001": [
	"Gesendet"
],
	"\u0000Sent by\u0001": [
	"Gesendet von"
],
	"\u0000Sent date\u0001": [
	"Versanddatum"
],
	"\u0000Sent mails\u0001": [
	"Gesendete E-Mails"
],
	"folder\u0000Sent messages\u0001": [
	"Gesendete Nachrichten"
],
	"\u0000Serial number\u0001": [
	"Seriennummer"
],
	"\u0000Server\u0001": [
	"Server"
],
	"\u0000Server Name\u0001": [
	"Server-Name"
],
	"\u0000Server URL\u0001": [
	"Server-URL"
],
	"\u0000Server did not send a response\u0001": [
	"Server hat keine Antwort gesendet"
],
	"\u0000Server name\u0001": [
	"Server-Name"
],
	"\u0000Server port\u0001": [
	"Server-Port"
],
	"\u0000Server shutting down.\u0001": [
	"Server wird heruntergefahren"
],
	"\u0000Server type\u0001": [
	"Server-Typ"
],
	"\u0000Server unreachable\u0001": [
	"Der Server ist nicht erreichbar"
],
	"\u0000Set IMAP keywords\u0001": [
	"IMAP-Schlüsselwörter festlegen"
],
	"\u0000Set categories\u0001": [
	"Kategorien festlegen"
],
	"\u0000Set color\u0001": [
	"Farbe zuweisen"
],
	"\u0000Set color flag\u0001": [
	"Farbig markieren"
],
	"\u0000Set default signatures\u0001": [
	"Standardsignaturen festlegen"
],
	"\u0000Set how long the \"Undo\" notification stays visible after an action, such as deleting an email. Only the most recent action can be undone.\u0001": [
	"Legen Sie fest, wie lange die \"Rückgängig\"-Benachrichtigung nach einer Aktion, z. B. dem Löschen einer E-Mail, sichtbar bleibt. Nur die letzte Aktion kann rückgängig gemacht werden."
],
	"\u0000Set inbox category\u0001": [
	"Posteingangskategorie festlegen"
],
	"\u0000Set password\u0001": [
	"Passwort festlegen"
],
	"\u0000Set up and configure %s meetings\u0001": [
	"%s-Meetings einrichten und konfigurieren"
],
	"\u0000Set up and configure Zoom meetings\u0001": [
	"Richten Sie Zoom-Meetings ein und konfigurieren Sie diese"
],
	"\u0000Set your preferred duration here %1$s\u0001": [
	"Legen Sie hier Ihre bevorzugte Dauer fest %1$s"
],
	"\u0000Set your preferred setting for reading e-mails.\u0001": [
	"Legen Sie Ihre bevorzugte Einstellung für das Lesen von E-Mails fest."
],
	"\u0000Set your preferred working hours. This timeframe will be highlighted in day, week, and workweek view.\u0001": [
	"Legen Sie Ihre bevorzugten Arbeitszeiten fest. Dieser Zeitrahmen wird in der Tages-, Wochen- und Arbeitswochenansicht hervorgehoben."
],
	"\u0000Settings\u0001": [
	"Einstellungen"
],
	"\u0000Settings Folders\u0001": [
	"Ordnereinstellungen"
],
	"\u0000Settings got a new search\u0001": [
	"Einstellungen haben eine neue Suche erhalten"
],
	"\u0000Share\u0001": [
	"Freigeben"
],
	"\u0000Share %1$s \"%2$s\"\u0001": [
	"%1$s \"%2$s\" freigeben"
],
	"\u0000Share / Permissions\u0001": [
	"Freigeben / Berechtigungen"
],
	"\u0000Share with subfolders\u0001": [
	"Mit Unterordnern freigeben"
],
	"\u0000Shared\u0001": [
	"Freigegeben"
],
	"\u0000Shared Appointments\u0001": [
	"Gemeinsame Termine"
],
	"\u0000Shared Categories\u0001": [
	"Freigegebene Kategorien"
],
	"\u0000Shared address books\u0001": [
	"Freigegebene Adressbücher"
],
	"\u0000Shared address lists\u0001": [
	"Freigegebene Adresslisten"
],
	"\u0000Shared by other users\u0001": [
	"Von anderen Benutzern freigegeben"
],
	"\u0000Shared by public link\u0001": [
	"Durch öffentlichen Link freigegeben"
],
	"\u0000Shared calendars\u0001": [
	"Freigegebene Kalender"
],
	"\u0000Shared folders\u0001": [
	"Freigegebene Ordner"
],
	"\u0000Shared folders from \"%1$s\"\u0001": [
	"Freigegebene Ordner von \"%1$s\""
],
	"\u0000Shared lists\u0001": [
	"Freigegebene Listen"
],
	"\u0000Shared tasks folders\u0001": [
	"Freigegebene Aufgabenordner"
],
	"\u0000Shared with guest users\u0001": [
	"Für Gastbenutzer freigegeben"
],
	"\u0000Shared with internal and guest users\u0001": [
	"Für interne und Gastbenutzer freigegeben"
],
	"\u0000Shared with internal users\u0001": [
	"Für interne Benutzer freigegeben"
],
	"\u0000Shared with others\u0001": [
	"Für andere freigegeben"
],
	"\u0000Shares\u0001": [
	"Freigaben"
],
	"\u0000Sharing folders without permissions\u0001": [
	"Freigabe von Ordnern ohne Berechtigungen"
],
	"\u0000Sharing options\u0001": [
	"Freigabeoptionen"
],
	"\u0000Shortcut profile\u0001": [
	"Profil für Tastaturkürzel"
],
	"\u0000Shortcuts can be configured in %1$s\u0001": [
	"Tastaturkürzel können in %1$s eingerichtet und konfiguriert werden"
],
	"\u0000Shortly\u0001": [
	"In Kürze"
],
	"\u0000Show\u0001": [
	"Anzeigen"
],
	"\u0000Show advanced options\u0001": [
	"Erweiterte Optionen anzeigen"
],
	"\u0000Show all\u0001": [
	"Alle anzeigen"
],
	"\u0000Show all calendars\u0001": [
	"Alle Kalender anzeigen"
],
	"\u0000Show all images just once\u0001": [
	"Alle Bilder nur einmal anzeigen"
],
	"\u0000Show appointment details\u0001": [
	"Termindetails anzeigen"
],
	"\u0000Show as free\u0001": [
	"Als frei anzeigen"
],
	"\u0000Show birthday calendar\u0001": [
	"Geburtstagskalender anzeigen"
],
	"\u0000Show birthdays in notification area\u0001": [
	"Geburtstage im Infobereich anzeigen"
],
	"\u0000Show blind carbon copy input field\u0001": [
	"BCC-Eingabefeld anzeigen"
],
	"\u0000Show carbon copy input field\u0001": [
	"CC-Eingabefeld anzeigen"
],
	"\u0000Show categories\u0001": [
	"Kategorien anzeigen"
],
	"\u0000Show contact details\u0001": [
	"Kontaktdetails anzeigen"
],
	"\u0000Show countdown\u0001": [
	"Countdown anzeigen"
],
	"\u0000Show countdowns only for appointments with multiple participants or a link to join online meetings\u0001": [
	"Countdowns nur für Termine mit mehreren Teilnehmern oder einem Link zur Teilnahme an Online-Meetings anzeigen"
],
	"\u0000Show declined appointments\u0001": [
	"Abgelehnte Termine anzeigen"
],
	"\u0000Show desktop notifications\u0001": [
	"Desktop-Benachrichtigungen anzeigen"
],
	"\u0000Show details\u0001": [
	"Details anzeigen"
],
	"\u0000Show done tasks\u0001": [
	"Erledigte Aufgaben anzeigen"
],
	"\u0000Show editor toolbar\u0001": [
	"Editor-Werkzeugleiste anzeigen"
],
	"\u0000Show entire message\u0001": [
	"Gesamte Nachricht anzeigen"
],
	"\u0000Show entire message including all external images\u0001": [
	"Gesamte Nachricht einschließlich aller externen Bilder anzeigen"
],
	"\u0000Show fine grid\u0001": [
	"Feinraster anzeigen"
],
	"\u0000Show folders\u0001": [
	"Ordner anzeigen"
],
	"\u0000Show free/busy information to others.\u0001": [
	"Frei/Gebucht-Informationen für andere anzeigen."
],
	"\u0000Show hidden files and folders\u0001": [
	"Ausgeblendete Dateien und Ordner anzeigen"
],
	"\u0000Show icons\u0001": [
	"Symbole anzeigen"
],
	"\u0000Show images\u0001": [
	"Bilder anzeigen"
],
	"\u0000Show in  %1$s\u0001": [
	"Anzeigen in %1$s"
],
	"\u0000Show less options\u0001": [
	"Weniger Optionen anzeigen"
],
	"\u0000Show list\u0001": [
	"Liste anzeigen"
],
	"\u0000Show manual configuration options\u0001": [
	"Manuelle Konfigurationsoptionen anzeigen"
],
	"\u0000Show message size\u0001": [
	"Nachrichtengröße anzeigen"
],
	"\u0000Show mini calendar\u0001": [
	"Minikalender anzeigen"
],
	"\u0000Show more options\u0001": [
	"Weitere Optionen anzeigen"
],
	"\u0000Show name\u0001": [
	"Namen anzeigen"
],
	"\u0000Show or hide alternative options for advanced users.\u0001": [
	"Aktionen für fortgeschrittene Anwender ein- oder ausblenden."
],
	"\u0000Show quoted text\u0001": [
	"Zitierten Text anzeigen"
],
	"\u0000Show reminders for past appointments\u0001": [
	"Erinnerungen für vergangene Termine anzeigen"
],
	"\u0000Show reply-to input field\u0001": [
	"Eingabefeld \"Antwort an\" anzeigen"
],
	"\u0000Show requests for read receipts\u0001": [
	"Anfragen für Lesebestätigungen anzeigen"
],
	"\u0000Show shortcut help\u0001": [
	"Hilfe für Tastaturkürzel anzeigen"
],
	"\u0000Show task details\u0001": [
	"Aufgabendetails anzeigen"
],
	"\u0000Show text preview\u0001": [
	"Textvorschau anzeigen"
],
	"\u0000Show this calendar only\u0001": [
	"Nur diesen Kalender anzeigen"
],
	"\u0000Show this group only\u0001": [
	"Nur diese Gruppe anzeigen"
],
	"\u0000Show this resource only\u0001": [
	"Nur diese Ressource anzeigen"
],
	"\u0000Show tiles\u0001": [
	"Kacheln anzeigen"
],
	"\u0000Show toolbar\u0001": [
	"Werkzeugleiste anzeigen"
],
	"\u0000Shown as\u0001": [
	"Angezeigt als"
],
	"\u0000Shown as %1$s\u0001": [
	"Angezeigt als %1$s"
],
	"\u0000Shrink\u0001": [
	"Verkleinern"
],
	"\u0000Sign in\u0001": [
	"Anmelden"
],
	"word\u0000Sign in\u0001": [
	"Anmeldung"
],
	"\u0000Sign in with Google. This will add your Gmail account.\u0001": [
	"Melden Sie sich bei Google an. Dadurch wird Ihr Gmail-Konto hinzugefügt."
],
	"\u0000Sign out\u0001": [
	"Abmelden"
],
	"\u0000Sign out from all devices\u0001": [
	"Von allen Geräten abmelden"
],
	"\u0000Sign out from device\u0001": [
	"Vom Gerät abmelden"
],
	"\u0000Sign out now\u0001": [
	"Jetzt abmelden"
],
	"\u0000Signature\u0001": [
	"Signatur"
],
	"\u0000Signature Position\u0001": [
	"Signaturposition"
],
	"\u0000Signature name\u0001": [
	"Name der Signatur"
],
	"\u0000Signatures\u0001": [
	"Signaturen"
],
	"\u0000Signatures for all mail accounts\u0001": [
	"Signaturen für alle E-Mail-Konten"
],
	"\u0000Signed in as\u0001": [
	"Angemeldet als"
],
	"\u0000Simple\u0001": [
	"Einfach"
],
	"\u0000Simply scan the QR code and your device will connect seamlessly - no need to manually enter login credentials or go through lengthy setup processes.\u0001": [
	"Scannen Sie einfach den QR-Code und Ihr Gerät verbindet sich nahtlos - ohne manuelle Eingabe von Anmeldedaten oder langwierige Einrichtungsprozesse."
],
	"\u0000Six months\u0001": [
	"Sechs Monate"
],
	"\u0000Size\u0001": [
	"Größe"
],
	"\u0000Skip to main content\u0001": [
	"Zum Hauptinhalt wechseln"
],
	"\u0000Slideshow\u0001": [
	"Diashow"
],
	"\u0000Slideshow for images\u0001": [
	"Diashow für Bilder"
],
	"\u0000Small\u0001": [
	"Klein"
],
	"\u0000Small (%1$s px)\u0001": [
	"Klein (%1$s px)"
],
	"\u0000Smarter participant sorting\u0001": [
	"Teilnehmer immer passend sortiert"
],
	"\u0000Smoke Gray\u0001": [
	"Rauchgrau"
],
	"\u0000Snooze\u0001": [
	"Später erinnern"
],
	"\u0000Some contacts could not be added as they have no valid email field.\u0001": [
	"Einige Kontakte konnten nicht hinzugefügt werden, da sie kein gültiges E-Mail-Feld enthalten."
],
	"\u0000Some contacts could not be added because their email address is already in the list.\u0001": [
	"Einige Kontakte konnten nicht hinzugefügt werden, da deren E-Mail-Adressen bereits in der Liste enthalten sind."
],
	"\u0000Some files or folders are shared with others. They will not be available for them anymore.\u0001": [
	"Einige Dateien oder Ordner wurden für andere freigegeben. Sie werden nicht mehr für sie verfügbar sein."
],
	"\u0000Some mandatory configuration could not be loaded.\u0001": [
	"Einige obligatorische Konfigurationen konnten nicht geladen werden."
],
	"\u0000Something went wrong. Maybe the session expired or the token is invalid.\u0001": [
	"Es trat ein Fehler auf. Vielleicht ist die Sitzung abgelaufen oder das Token ist ungültig."
],
	"\u0000Something went wrong. Please close this browser tab and try again.\u0001": [
	"Es trat ein Fehler auf. Bitte schließen Sie diesen Browser-Tab und versuchen Sie es erneut."
],
	"\u0000Something went wrong. Please try again later.\u0001": [
	"Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
],
	"\u0000Something went wrong. Please try again.\u0001": [
	"Ein Fehler ist aufgetreten. Bitte erneut versuchen ."
],
	"\u0000Sorry, there is no preview available for this file.\u0001": [
	"Für diese Datei ist leider keine Voransicht verfügbar."
],
	"\u0000Sorry, there is no preview available for this image.\u0001": [
	"Für dieses Bild ist leider keine Voransicht verfügbar."
],
	"\u0000Sorry, there is no preview available.\u0001": [
	"Leider ist keine Voransicht verfügbar."
],
	"\u0000Sort by\u0001": [
	"Sortieren nach"
],
	"dropdown\u0000Sort by\u0001": [
	"Sortieren nach"
],
	"\u0000Sort options\u0001": [
	"Sortieroptionen"
],
	"\u0000Sort order\u0001": [
	"Sortierreihenfolge"
],
	"\u0000Sound\u0001": [
	"Ton"
],
	"\u0000Source\u0001": [
	"Quelle"
],
	"folder\u0000Spam\u0001": [
	"Spam"
],
	"\u0000Split\u0001": [
	"Trennen"
],
	"\u0000Spouse's name\u0001": [
	"Ehepartner"
],
	"\u0000Spreadsheet\u0001": [
	"Tabellendokument"
],
	"\u0000Spreadsheets\u0001": [
	"Tabellendokumente"
],
	"\u0000Standard\u0001": [
	"Standard"
],
	"\u0000Standard folders\u0001": [
	"Standardordner"
],
	"\u0000Standard time zone\u0001": [
	"Standard-Zeitzone"
],
	"\u0000Start\u0001": [
	"Beginn"
],
	"\u0000Start app\u0001": [
	"Start-App"
],
	"\u0000Start countdown\u0001": [
	"Countdown starten"
],
	"\u0000Start date\u0001": [
	"Beginnt am"
],
	"\u0000Start date time zone\u0001": [
	"Zeitzone für Startdatum"
],
	"\u0000Start in \"%1$s\" address book\u0001": [
	"Im Adressbuch \"%1$s\" starten"
],
	"\u0000Start in global address book\u0001": [
	"Im globalen Adressbuch starten"
],
	"\u0000Start time\u0001": [
	"Beginnt um"
],
	"\u0000Start tour\u0001": [
	"Tour starten"
],
	"\u0000Start typing to search for user names\u0001": [
	"Tippen Sie, um nach Benutzernamen zu suchen"
],
	"\u0000Start video\u0001": [
	"Video starten"
],
	"\u0000StartTLS\u0001": [
	"StartTLS"
],
	"\u0000Starting letter index\u0001": [
	"A-Z Index"
],
	"\u0000Starts not with\u0001": [
	"Beginnt nicht mit"
],
	"\u0000Starts on\u0001": [
	"Beginnt am"
],
	"\u0000Starts with\u0001": [
	"Beginnt mit"
],
	"\u0000State\u0001": [
	"Bundesland"
],
	"\u0000Statistics\u0001": [
	"Statistiken"
],
	"\u0000Status\u0001": [
	"Status"
],
	"\u0000Stay informed about what's new and discover the latest features and enhancements in our latest updates of %1$s.\u0001": [
	"Bleiben Sie auf dem Laufenden über Neuigkeiten und entdecken Sie die neuesten Funktionen und Verbesserungen in den aktuellen Updates von %1$s."
],
	"\u0000Stay signed in\u0001": [
	"Angemeldet bleiben"
],
	"\u0000Stay up-to-date on your favorite devices.\u0001": [
	"Bleiben Sie auf Ihren bevorzugten Geräten auf dem Laufenden."
],
	"\u0000Steel gray\u0001": [
	"Stahlgrau"
],
	"\u0000Step\u0001": [
	"Schritt"
],
	"\u0000Stick to the right side\u0001": [
	"Rechts verankern"
],
	"\u0000Stop slideshow\u0001": [
	"Diashow stoppen"
],
	"\u0000Storage\u0001": [
	"Speicherplatz"
],
	"\u0000Street\u0001": [
	"Straße"
],
	"\u0000String\u0001": [
	"Zeichenkette"
],
	"\u0000Subject\u0001": [
	"Betreff"
],
	"\u0000Subject: %1$s\u0001": [
	"Betreff: %1$s"
],
	"\u0000Subscribe\u0001": [
	"Abonnieren"
],
	"\u0000Subscribe to Google calendar\u0001": [
	"Google-Kalender abonnieren"
],
	"\u0000Subscribe to IMAP folders\u0001": [
	"IMAP-Ordner abonnieren"
],
	"\u0000Subscribe to address book\u0001": [
	"Adressbuch abonnieren"
],
	"\u0000Subscribe to calendar\u0001": [
	"Kalender abonnieren"
],
	"\u0000Subscribe to folder\u0001": [
	"Ordner abonnieren"
],
	"\u0000Subscribe to iCal feed\u0001": [
	"iCal-Feed abonnieren"
],
	"\u0000Subscribe to shared address books\u0001": [
	"Freigegebene Adressbücher abonnieren"
],
	"\u0000Subscribe to shared calendars\u0001": [
	"Freigegebene Kalender abonnieren"
],
	"\u0000Subscribe to shared task folders\u0001": [
	"Freigegebene Aufgabenordner abonnieren"
],
	"\u0000Subscribe to shared tasks folders\u0001": [
	"Freigegebene Aufgabenordner abonnieren"
],
	"\u0000Subscribe to task folder\u0001": [
	"Aufgabenordner abonnieren"
],
	"\u0000Subscription refresh\u0001": [
	"Abonnement aktualisieren"
],
	"\u0000Subscription successfully created.\u0001": [
	"Das Abonnement wurde erfolgreich angelegt."
],
	"\u0000Subscriptions\u0001": [
	"Abonnements"
],
	"\u0000Success\u0001": [
	"Erfolg"
],
	"\u0000Successfully refreshed calendar\u0001": [
	"Kalender erfolgreich aktualisiert"
],
	"\u0000Suffix\u0001": [
	"Namenszusatz"
],
	"\u0000Summary\u0001": [
	"Übersicht"
],
	"superessive\u0000Sunday\u0001": [
	"Sonntag"
],
	"\u0000Sunsets\u0001": [
	"Sonnenuntergänge"
],
	"\u0000Support starts with Chrome %1$d, Firefox %2$d, Edge %3$d, and Safari %4$d.\u0001": [
	"Die Unterstützung beginnt mit Chrome %1$d, Firefox %2$d, Edge %3$d und Safari %4$d."
],
	"\u0000Switch camera\u0001": [
	"Kamera wechseln"
],
	"\u0000Switch to parent folder\u0001": [
	"In den übergeordneten Ordner wechseln"
],
	"\u0000Symbols\u0001": [
	"Symbole"
],
	"\u0000Sync via DAV\u0001": [
	"Über DAV synchronisieren"
],
	"\u0000System\u0001": [
	"System"
],
	"\u0000TAX ID\u0001": [
	"Steuernummer"
],
	"\u0000TB\u0001": [
	"TB"
],
	"\u0000TTY/TDD\u0001": [
	"Texttelefon"
],
	"\u0000Tag mails from %1$s with %2$s\u0001": [
	"E-Mails von %1$s mit %2$s kennzeichnen"
],
	"\u0000Tag mails to %1$s with %2$s\u0001": [
	"E-Mails an %1$s mit %2$s kennzeichnen"
],
	"\u0000Tag mails with subject %1$s with %2$s\u0001": [
	"E-Mails mit dem Betreff %1$s mit %2$s kennzeichnen"
],
	"\u0000Take %1$s with you!\u0001": [
	"Nehmen Sie %1$s mit!"
],
	"\u0000Take %1$s with you! Stay up-to-date on your favorite devices.\u0001": [
	"Nehmen Sie %1$s mit! Bleiben Sie auf all Ihren Geräten auf dem neuesten Stand."
],
	"\u0000Take a photo\u0001": [
	"Ein Foto machen"
],
	"\u0000Tap <b>Install</b> in the popup.\u0001": [
	"Tippen Sie im Popup auf <b>Installieren</b>."
],
	"\u0000Tap on the sharing icon\u0001": [
	"Tippen Sie auf das Freigabesymbol"
],
	"\u0000Tap the More button\u0001": [
	"Tippen Sie auf die Schaltfläche Weitere Aktionen"
],
	"\u0000Tap the install icon\u0001": [
	"Tippen Sie auf das Installationssymbol"
],
	"\u0000Task\u0001": [
	"Aufgabe"
],
	"\u0000Task Details\u0001": [
	"Aufgaben-Details"
],
	"\u0000Task actions\u0001": [
	"Aufgaben-Aktionen"
],
	"\u0000Task has been deleted\u0001": [
	"Die Aufgabe wurde gelöscht"
],
	"\u0000Task has been deleted already\u0001": [
	"Die Aufgabe wurde bereits gelöscht"
],
	"\u0000Task invitation\u0001": [
	"Aufgabeneinladung"
],
	"\u0000Task invitations, changes or deletions\u0001": [
	"Aufgabeneinladung, -änderung oder -löschung"
],
	"\u0000Task marked as done\u0001": [
	"Aufgabe als erledigt markiert"
],
	"\u0000Task marked as undone\u0001": [
	"Aufgabe als unerledigt markiert"
],
	"\u0000Task reminder\u0001": [
	"Aufgabenerinnerung"
],
	"\u0000Tasks\u0001": [
	"Aufgaben"
],
	"app\u0000Tasks\u0001": [
	"Aufgaben"
],
	"\u0000Tasks can not be moved to or out of shared folders\u0001": [
	"Aufgaben können nicht in freigegebene Ordner oder daraus verschoben werden"
],
	"\u0000Tasks have been deleted\u0001": [
	"Die Aufgaben wurden gelöscht"
],
	"\u0000Tasks in folders\u0001": [
	"Aufgaben in Ordnern"
],
	"\u0000Tasks in public folders\u0001": [
	"Aufgaben in öffentlichen Ordnern"
],
	"\u0000Tasks in shared folders\u0001": [
	"Aufgaben in freigegebenen Ordnern"
],
	"\u0000Tasks marked as done\u0001": [
	"Aufgaben als erledigt markiert"
],
	"\u0000Tasks marked as undone\u0001": [
	"Aufgaben als unerledigt markiert"
],
	"\u0000Tasks toolbar\u0001": [
	"Aufgaben-Werkzeugleiste"
],
	"\u0000Telephone (ISDN)\u0001": [
	"Telefon (ISDN)"
],
	"\u0000Telephone callback\u0001": [
	"Telefonnummer für Rückruf"
],
	"\u0000Telephone primary\u0001": [
	"Haupttelefon"
],
	"\u0000Telephone radio\u0001": [
	"Funktelefon"
],
	"\u0000Telex\u0001": [
	"Telex"
],
	"\u0000Tell us about yourself\u0001": [
	"Erzählen Sie uns von sich"
],
	"\u0000Template name\u0001": [
	"Name der Vorlage"
],
	"\u0000Templates\u0001": [
	"Vorlagen"
],
	"\u0000Tentative\u0001": [
	"Vorläufig"
],
	"\u0000Tentatively accepted\u0001": [
	"Vorläufig bestätigt"
],
	"\u0000Text documents\u0001": [
	"Textdokumente"
],
	"\u0000Text templates\u0001": [
	"Textvorlagen"
],
	"\u0000Text templates: A powerful tool for creating and editing pre-defined snippets that enable quick responses and visually captivating content. Seamlessly insert plain or formatted text, including images, into new emails with ease, boosting productivity and efficiency.\u0001": [
	"Textvorlagen: Ein leistungsstarkes Werkzeug zum Erstellen und Bearbeiten vordefinierter Textbausteine, die schnelle Antworten und visuell ansprechende Inhalte ermöglichen. Fügen Sie einfachen oder formatierten Text, einschließlich Bildern, nahtlos in neue E-Mails ein und steigern Sie so die Produktivität und Effizienz."
],
	"\u0000Thank you for your feedback\u0001": [
	"Danke für Ihr Feedback"
],
	"\u0000The \"Connect your device\" wizard now allows you to setup email, contacts, and calendar synchronization with your iPhone, iPad, or Macbook in one step\u0001": [
	"Mit dem Assistenten \"Gerät verbinden\" können Sie jetzt in einem Schritt die Synchronisierung von E-Mails, Kontakten und Kalendern mit Ihrem iPhone, iPad oder MacBook einrichten"
],
	"\u0000The %1$s client lets you store and share your photos, files, documents and videos, anytime, anywhere. Access any file you save to %1$s from all your computers, iPhone, iPad or from within %2$s itself.\u0001": [
	"Mit dem %1$s-Client können Sie jederzeit und überall Ihre Fotos, Dateien, Dokumente und Videos speichern und freigeben. Sie können von Ihrem Rechner, iPhone, iPad oder von %2$s auf jede beliebige in %1$s gespeicherte Datei zugreifen."
],
	"\u0000The PDF could not be exported. The file name contains invalid characters:\u0001": [
	"Die PDF-Datei konnte nicht exportiert werden. Der Dateiname enthält ungültige Zeichen:"
],
	"\u0000The PDF file is password protected and cannot be displayed\u0001": [
	"Die PDF-Datei ist passwortgeschützt und kann nicht angezeigt werden"
],
	"\u0000The PDF file structure is invalid.\u0001": [
	"Die Struktur der PDF-Datei ist ungültig."
],
	"\u0000The PDF has been saved to \"/drive/myfiles/documents\" due to not having write access for the current folder.\u0001": [
	"Die PDF-Datei wurde in \"/Drive/Meine Dateien/Dokumente\" gespeichert, da für den aktuellen Ordner keine Schreibrechte bestehen."
],
	"\u0000The Zoom integration service is currently unavailable. Please try again later.\u0001": [
	"Der Zoom-Integrationsdienst ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut."
],
	"\u0000The account must be named\u0001": [
	"Das Konto muss benannt werden"
],
	"\u0000The allowed quota is reached.\u0001": [
	"Der zulässige Speicherplatz ist erreicht."
],
	"\u0000The appointment description might contain outdated information from a previous zoom conference that needs to be deleted manually.\u0001": [
	"Die Terminbeschreibung kann veraltete Informationen aus einer früheren Zoom-Konferenz enthalten, die manuell gelöscht werden müssen."
],
	"\u0000The appointment has been added to your calendar\u0001": [
	"Der Termin wurde Ihrem Kalender hinzugefügt"
],
	"\u0000The appointment has been deleted\u0001": [
	"Der Termin wurde gelöscht"
],
	"\u0000The appointment has been updated\u0001": [
	"Der Termin wurde aktualisiert"
],
	"\u0000The appointment was added\u0001": [
	"Der Termin wurde hinzugefügt"
],
	"\u0000The attached file is empty. Maybe this file was deleted on your local hard drive. Do you want to send it anyway?\u0001": [
	"Die angehängte Datei ist leer. Vielleicht wurde diese Datei auf Ihrer lokalen Festplatte gelöscht. Möchten Sie sie trotzdem senden?"
],
	"\u0000The attachment cannot be uploaded because it exceeds the infostore quota limit of %2$s\u0001": [
	"Der Anhang kann nicht hochgeladen werden, da er das Infostore-Speicherlimit von %2$s überschreitet"
],
	"\u0000The below item was open last time you exited %1$s.\u0001": [
	"Folgendes Objekt war beim letzten Beenden von %1$s geöffnet."
],
	"\u0000The below items were open last time you exited %1$s.\u0001": [
	"Folgende Objekte waren beim letzten Beenden von %1$s geöffnet."
],
	"\u0000The categories will appear once your search is done.\u0001": [
	"Die Kategorien werden angezeigt, sobald die Suche abgeschlossen ist."
],
	"\u0000The certificate list is empty\u0001": [
	"Die Zertifikatsliste ist leer"
],
	"\u0000The changes have been accepted\u0001": [
	"Die Änderungen wurden übernommen"
],
	"\u0000The changes have been rejected\u0001": [
	"Die Änderungen wurden abgelehnt"
],
	"\u0000The countdown window will pop up before a scheduled meeting.\u0001": [
	"Das Countdown-Fenster wird vor einem geplanten Meeting eingeblendet."
],
	"\u0000The current folder is not supported\u0001": [
	"Der aktuelle Ordner wird nicht unterstützt"
],
	"\u0000The deputy has the following permissions\u0001": [
	"Der Stellvertreter hat die folgenden Berechtigungen"
],
	"\u0000The dialog contains invalid data\u0001": [
	"Der Dialog enthält ungültige Daten"
],
	"\u0000The due date cannot be before start date. Adjust start date?\u0001": [
	"Das Fälligkeitsdatum darf nicht vor dem Startdatum liegen. Wollen Sie das Startdatum anpassen?"
],
	"\u0000The due date must not be before the start date.\u0001": [
	"Das Fälligkeitsdatum darf nicht vor dem Startdatum liegen."
],
	"\u0000The email has been sent\u0001": [
	"Die E-Mail wurde gesendet"
],
	"\u0000The end date must be after the start date.\u0001": [
	"Das Enddatum muss nach dem Startdatum liegen."
],
	"\u0000The entered credential or authentication information does not work\u0001": [
	"Die eingegebenen Zugangsdaten oder Authentifizierungsinformationen funktionieren nicht"
],
	"\u0000The file \"%1$s\" cannot be uploaded because it exceeds the attachment publication maximum file size of %2$s\u0001": [
	"Die Datei \"%1$s\" kann nicht hochgeladen werden. Sie überschreitet die maximale Dateigröße von %2$s für veröffentlichte Anhänge."
],
	"\u0000The file \"%1$s\" cannot be uploaded because it exceeds the maximum file size of %2$s\u0001": [
	"Die Datei \"%1$s\" kann nicht hochgeladen werden. Sie überschreitet die maximale Dateigröße von %2$s."
],
	"\u0000The file \"%1$s\" cannot be uploaded because it exceeds the total attachment size limit of %2$s\u0001": [
	"Die Datei \"%1$s\" kann nicht hochgeladen werden. Sie überschreitet die maximale Dateigröße von %2$s für Anhänge."
],
	"\u0000The file cannot be uploaded because it exceeds the maximum email size of %1$s\u0001": [
	"Die Datei kann nicht hochgeladen werden, da sie die maximale E-Mail-Größe von %1$s überschreitet"
],
	"\u0000The file type \"%1$s\" cannot be used as a contact photo. Supported file types are JPEG, GIF, BMP, and PNG.\u0001": [
	"Der Dateityp \"%1$s\" kann nicht als Kontaktfoto verwendet werden. Unterstützte Dateitypen sind JPEG, GIF, BMP und PNG."
],
	"\u0000The first record of a valid CSV file must define proper column names. Supported separators are comma and semi-colon.\u0001": [
	"Der erste Eintrag einer gültigen CSV-Datei muss passende Spaltennamen definieren. Unterstützte Trennzeichen sind das Komma und das Semikolon."
],
	"\u0000The folder cannot be added because it was removed by the owner.\u0001": [
	"Der Ordner kann nicht hinzugefügt werden, da er vom Besitzer entfernt wurde."
],
	"\u0000The folder cannot be added because the link is invalid.\u0001": [
	"Der Ordner kann nicht hinzugefügt werden, da der Link ungültig ist."
],
	"\u0000The folder has been cleaned up.\u0001": [
	"Der Ordner wurde aufgeräumt."
],
	"\u0000The folder has been emptied\u0001": [
	"Der Ordner wurde geleert"
],
	"\u0000The folder is currently unavailable and cannot be added. Please try again later.\u0001": [
	"Der Ordner ist derzeit nicht verfügbar und kann nicht hinzugefügt werden. Bitte versuchen Sie es später erneut."
],
	"\u0000The folder was added successfully.\u0001": [
	"Der Ordner wurde erfolgreich hinzugefügt."
],
	"\u0000The folder was removed successfully.\u0001": [
	"Der Ordner wurde erfolgreich entfernt."
],
	"\u0000The following apps will not be shown on the mobile quick launcher bar due to space limitations.\u0001": [
	"Die folgenden Apps werden aus Platzgründen nicht in der Schnellstartleiste für Mobilgeräte angezeigt."
],
	"\u0000The following email addresses cannot be used: %1$s\u0001": [
	"Folgende E-Mail-Adressen können nicht verwendet werden: %1$s"
],
	"\u0000The following external applications/services can access your data:\u0001": [
	"Die folgenden externen Applikationen/Dienste können auf Ihre Daten zugreifen:"
],
	"\u0000The given address is always added to BCC when replying or composing new emails.\u0001": [
	"Die angegebene Adresse wird beim Beantworten oder beim Verfassen neuer E-Mails immer zu BCC hinzugefügt."
],
	"\u0000The image cannot not be resized because it was not found on your hard drive.\u0001": [
	"Die Bildgröße kann nicht verändert werden, da das Bild nicht auf Ihrer Festplatte gefunden wurde."
],
	"\u0000The link has been copied to the clipboard.\u0001": [
	"Der Link wurde in die Zwischenablage kopiert."
],
	"\u0000The list below shows all devices you're currently signed in to. There might be multiple sessions from the same device.\u0001": [
	"Die folgende Liste zeigt alle Geräte, auf denen Sie derzeit angemeldet sind. Es kann mehrere Sitzungen von demselben Gerät geben."
],
	"\u0000The loading behavior has been improved to achieve faster loading times\u0001": [
	"Das Ladeverhalten wurde verbessert, um schnellere Ladezeiten zu erreichen"
],
	"\u0000The mail draft could not be found on the server. It was sent or deleted in the meantime.\u0001": [
	"Der E-Mail-Entwurf konnte nicht auf dem Server gefunden werden. Er wurde zwischenzeitlich verschickt oder gelöscht."
],
	"\u0000The majority of app icons have been visually updated\u0001": [
	"Die meisten App-Symbole wurden visuell überarbeitet"
],
	"\u0000The meeting has already started\u0001": [
	"Das Meeting hat bereits begonnen"
],
	"\u0000The meeting has just started\u0001": [
	"Das Meeting hat soeben begonnen"
],
	"\u0000The meeting will start in a minute\u0001": [
	"Das Meeting beginnt in einer Minute"
],
	"\u0000The meeting will start soon\u0001": [
	"Das Meeting beginnt bald"
],
	"\u0000The new appointment conflicts with existing appointments.\u0001": [
	"Zwischen dem neuen Termin und bestehenden Terminen ist ein Konflikt aufgetreten."
],
	"\u0000The notice is sent out for messages received by %1$s. You may choose to send it out for other recipient addresses too:\u0001": [
	"Die Mitteilung wird für Nachrichten an den Empfänger %1$s versendet. Sie können sie auch an andere Empfängeradressen senden:"
],
	"\u0000The notification has been resent\u0001": [
	"Die Benachrichtigung wurde erneut gesendet"
],
	"\u0000The number of versions is limited to %1$d version.\u0001The number of versions is limited to %1$d versions.": [
	"Die Anzahl der Versionen ist auf eine Version begrenzt.",
	"Die Anzahl der Versionen ist auf %1$d Versionen begrenzt."
],
	"\u0000The number of versions is not limited.\u0001": [
	"Die Anzahl der Versionen ist nicht begrenzt."
],
	"\u0000The order of participants has been adjusted to better suit different use cases: When viewing appointment details, participants are now ordered by their participation status, prioritizing those who have accepted or declined. In contrast, when creating or editing an appointment, participants are sorted alphabetically by name for easier reference.\u0001": [
	"Die Reihenfolge der Teilnehmer wurde angepasst, um unterschiedlichen Anwendungsfällen besser gerecht zu werden: Bei der Ansicht von Termindetails werden die Teilnehmer nun nach ihrem Teilnahmestatus sortiert, wobei jene priorisiert werden, die angenommen oder abgelehnt haben. Dagegen werden bei der Erstellung oder Bearbeitung eines Termins die Teilnehmer alphabetisch nach Namen sortiert, um Personen in der Liste leichter zu finden."
],
	"\u0000The password was changed recently. Please enter the new password.\u0001": [
	"Das Kennwort wurde kürzlich geändert. Bitte geben Sie das neue Kennwort ein."
],
	"\u0000The photo exceeds the allowed file size of %1$s\u0001": [
	"Das Foto überschreitet die zulässige Dateigröße von %1$s"
],
	"\u0000The provided filename exceeds the allowed length.\u0001": [
	"Der angegebene Dateiname ist zu lang."
],
	"\u0000The provided password for the email address %1$s is incorrect\u0001": [
	"Das angegebene Passwort für die E-Mail-Adresse %1$s ist falsch"
],
	"\u0000The requested application is not available at this moment.\u0001": [
	"Die gewünschte Anwendung ist im Moment nicht verfügbar."
],
	"\u0000The search section has been cleaned up and made easier to navigate, with the most important settings now prioritized and placed upfront. We've also improved the wording throughout the interface to ensure better understandability.\u0001": [
	"Der Suchbereich wurde aufgeräumt und übersichtlicher gestaltet, wobei die wichtigsten Einstellungen nun priorisiert und an vorderster Stelle platziert wurden. Außerdem haben wir die Formulierungen der gesamten Benutzeroberfläche verbessert, um eine bessere Verständlichkeit zu gewährleisten."
],
	"\u0000The selected addresses. Press Backspace or Delete to remove.\u0001": [
	"Die ausgewählten Adressen. Zum Entfernen drücken Sie die Rück- oder Löschtaste."
],
	"\u0000The selected calendar \"%1$s\" is public. Do you really want to create an appointment in this calendar?\u0001": [
	"Der ausgewählte Kalender \"%1$s\" ist öffentlich. Wollen Sie wirklich einen Termin in diesem Kalender anlegen?"
],
	"\u0000The selected calendar is shared by %1$s. Appointments in shared calendars will generally be created on behalf of the owner.\u0001": [
	"Der gewählte Kalender wurde von %1$s freigegeben. Termine in freigegebenen Kalendern werden generell im Auftrag des Eigentümers angelegt."
],
	"\u0000The selected items. Press Backspace or Delete to remove.\u0001": [
	"Die ausgewählten Objekte. Zum Entfernen drücken Sie die Rück- oder Löschtaste."
],
	"\u0000The selected timezone is already a favorite.\u0001": [
	"Die gewählte Zeitzone ist bereits ein Favorit."
],
	"\u0000The sender wants to get notified when you have read this email\u0001": [
	"Der Absender wünscht eine Benachrichtigung, dass Sie die E-Mail gelesen haben"
],
	"\u0000The sending of the message has been canceled.\u0001": [
	"Das Versenden der Nachricht wurde abgebrochen."
],
	"\u0000The series ends after %1$d occurrence.\u0001The series ends after %1$d occurrences.": [
	"Die Serie endet nach %1$d Ereignis.",
	"Die Serie endet nach %1$d Ereignissen."
],
	"\u0000The series ends on %1$s.\u0001": [
	"Die Serie endet am %1$s."
],
	"\u0000The series never ends.\u0001": [
	"Die Serie endet nie."
],
	"\u0000The server provided an invalid configuration. Please try again or contact support.\u0001": [
	"Der Server hat eine ungültige Konfiguration geliefert. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support."
],
	"\u0000The service is not available right now.\u0001": [
	"Der Dienst ist derzeit nicht verfügbar."
],
	"\u0000The setting requires a reload or logging in again to take effect.\u0001": [
	"Sie müssen die Seite neu laden oder sich neu anmelden, damit die Einstellung wirksam wird."
],
	"\u0000The signature exists and is valid\u0001": [
	"Die Signatur ist vorhanden und gültig"
],
	"\u0000The signature is missing or is not valid\u0001": [
	"Die Signatur fehlt oder ist ungültig"
],
	"\u0000The start date must be before the due date.\u0001": [
	"Das Startdatum muss vor dem Enddatum liegen."
],
	"\u0000The subscription could not be created.\u0001": [
	"Das Abonnement konnte nicht erstellt werden."
],
	"\u0000The subscription could not be updated due to an error and must be recreated.\u0001": [
	"Das Abonnement konnte aufgrund eines Fehlers nicht aktualisiert werden und muss neu erstellt werden."
],
	"\u0000The task could not be deleted.\u0001": [
	"Die Aufgabe konnte nicht gelöscht werden."
],
	"\u0000The tasks could not be deleted.\u0001": [
	"Die Aufgaben konnten nicht gelöscht werden."
],
	"\u0000The time frame is in the past.\u0001": [
	"Der Zeitrahmen liegt in der Vergangenheit."
],
	"\u0000The time scale works like a zoom level in the calendar view. A lower number zooms in.\u0001": [
	"Die Zeitskala funktioniert wie eine Zoomstufe in der Kalenderansicht. Eine niedrigere Zahl vergrößert die Ansicht."
],
	"\u0000The timeframe is limited to %1$d day.\u0001The timeframe is limited to %1$d days.": [
	"Der Zeitrahmen ist auf einen Tag begrenzt.",
	"Der Zeitrahmen ist auf %1$d Tage begrenzt."
],
	"\u0000The timeframe is not limited.\u0001": [
	"Der Zeitrahmen ist nicht begrenzt."
],
	"\u0000The two newly entered passwords do not match.\u0001": [
	"Die neu eingegebenen Passwörter stimmen nicht überein."
],
	"\u0000The unrecoverable items have been cleaned up successfully. Please refresh this page to see the changes.\u0001": [
	"Die nicht wiederherstellbaren Objekte wurden erfolgreich bereinigt. Bitte aktualisieren Sie die Seite, um die Änderungen zu sehen."
],
	"\u0000The uploaded attachment exceeds the maximum email size of %1$s\u0001": [
	"Der hochgeladene Anhang überschreitet die maximale E-Mail-Größe von %1$s"
],
	"\u0000The uploaded file does not match the requested file type.\u0001": [
	"Die hochgeladene Datei stimmt nicht mit dem angeforderten Dateityp überein."
],
	"\u0000The user doesn't share his free/busy information with you.\u0001": [
	"Der Benutzer hat seine Frei/Gebucht-Informationen nicht für Sie freigegeben."
],
	"\u0000The user interface is now more resilient in handling unstable internet connections\u0001": [
	"Die Benutzeroberfläche ist jetzt robuster im Umgang mit instabilen Internetverbindungen"
],
	"\u0000The widget \"%s\" was disabled as the account might have been removed or is no longer available.\u0001": [
	"Das Widget \"%s\" wurde deaktiviert, da das Konto entweder entfernt wurde oder nicht mehr verfügbar ist."
],
	"\u0000Theme\u0001": [
	"Theme"
],
	"\u0000Theme preference\u0001": [
	"Bevorzugtes Theme"
],
	"\u0000Theme settings\u0001": [
	"Theme-Einstellungen"
],
	"\u0000Themes\u0001": [
	"Themes"
],
	"\u0000There are currently no compatible media devices available on your device.\u0001": [
	"Es sind derzeit keine kompatiblen Mediengeräte auf Ihrem Gerät verfügbar."
],
	"\u0000There are no backup devices available for this account. Please notify support for help.\u0001": [
	"Für dieses Konto sind keine Backup-Geräte verfügbar. Bitte wenden Sie sich an den Support."
],
	"\u0000There are no external applications/services which can access your account.\u0001": [
	"Es sind keine externen Applikationen/Dienste vorhanden, die auf Ihr Konto zugreifen können."
],
	"\u0000There are no notifications\u0001": [
	"Es gibt keine Benachrichtigungen"
],
	"\u0000There are unsaved changes.\u0001": [
	"Es gibt ungesicherte Änderungen."
],
	"\u0000There is %1$d message in this folder; not all messages are displayed in the list currently.\u0001There are %1$d messages in this folder; not all messages are displayed in the list currently.": [
	"Dieser Ordner enthält eine Nachricht. Nicht alle Nachrichten werden derzeit in der Liste angezeigt.",
	"Dieser Ordner enthält %1$d Nachrichten. Nicht alle Nachrichten werden derzeit in der Liste angezeigt."
],
	"\u0000There is a new notification\u0001There are %1$d new notifications": [
	"Es gibt eine neue Benachrichtigung",
	"Es gibt %1$d neue Benachrichtigungen"
],
	"\u0000There is a notification\u0001There are %1$d notifications": [
	"Es gibt eine Benachrichtigung",
	"Es gibt %1$d Benachrichtigungen"
],
	"\u0000There is a problem with this account. Click for more information\u0001": [
	"Es liegt ein Problem mit diesem Konto vor. Klicken Sie für weitere Informationen."
],
	"\u0000There is an update available! Please reload the app.\u0001": [
	"Es ist ein Update verfügbar! Bitte aktualisieren Sie die App."
],
	"\u0000There is currently an archive download available. By requesting a new download the current archive will be deleted and is no longer available.\u0001": [
	"Derzeit ist ein Archiv zum Herunterladen verfügbar. Durch das Anfordern eines neuen Archivs wird das aktuelle Archiv gelöscht und ist nicht mehr verfügbar."
],
	"\u0000There is no preview for this file type.\u0001": [
	"Für diesen Dateityp ist keine Voransicht möglich."
],
	"\u0000There is no rule defined\u0001": [
	"Es wurde keine Regel definiert"
],
	"\u0000There was a problem adding the password.\u0001": [
	"Beim Hinzufügen des Passworts ist ein Problem aufgetreten."
],
	"\u0000There was a problem getting the list of available applications from the server.\u0001": [
	"Beim Abrufen der Liste der verfügbaren Anwendungen vom Server ist ein Problem aufgetreten."
],
	"\u0000There was a problem getting the list of passwords from the server.\u0001": [
	"Beim Abrufen der Liste der Passwörter vom Server ist ein Problem aufgetreten."
],
	"\u0000There was a problem removing the password.\u0001": [
	"Beim Entfernen des Passworts ist ein Problem aufgetreten."
],
	"\u0000There was an error scheduling the email\u0001": [
	"Bei der E-Mail-Planung ist ein Fehler aufgetreten"
],
	"\u0000There was no appointment data to import\u0001": [
	"Es sind keine Termindaten zum Importieren vorhanden"
],
	"\u0000There was no contact data to import\u0001": [
	"Es sind keine Kontaktdaten zum Importieren vorhanden"
],
	"\u0000There was no suitable server found for this email/password combination\u0001": [
	"Es wurde kein passender Server für diese E-Mail/Passwort-Kombination gefunden"
],
	"\u0000There was no task data to import\u0001": [
	"Es sind keine Aufgabendaten zum Importieren vorhanden"
],
	"\u0000These files have not been deleted\u0001": [
	"Diese Dateien wurden nicht gelöscht"
],
	"\u0000These files have not been deleted, as they are locked by their owner.\u0001": [
	"Diese Dateien konnten nicht gelöscht werden, da sie von Ihrem Eigentümer gesperrt wurden."
],
	"\u0000This action may take some time.\u0001": [
	"Diese Aktion kann einige Zeit in Anspruch nehmen."
],
	"\u0000This action takes some time, so please be patient, while the import runs in the background.\u0001": [
	"Dieser Vorgang dauert einige Zeit. Bitte haben Sie Geduld, während der Import im Hintergrund ausgeführt wird."
],
	"\u0000This address book is empty\u0001": [
	"Dieses Adressbuch ist leer"
],
	"\u0000This afternoon\u0001": [
	"Heute Nachmittag"
],
	"\u0000This appointment has just started\u0001": [
	"Dieser Termin hat soeben begonnen"
],
	"\u0000This appointment has started %s ago\u0001": [
	"Dieser Termin hat vor %s begonnen"
],
	"\u0000This appointment is an exception. Changing the exception does not affect the series.\u0001": [
	"Dieser Termin ist eine Ausnahme. Das Ändern der Ausnahme hat keinen Einfluss auf die Serie."
],
	"\u0000This appointment is part of a series.\u0001": [
	"Dieser Termin ist Teil einer Serie."
],
	"\u0000This appointment is part of a series. Do you want to change your confirmation for the whole series or just for this appointment within the series?\u0001": [
	"Dieser Termin ist Teil einer Serie. Möchten Sie Ihre Bestätigung für die gesamte Serie oder nur für diesen Termin innerhalb der Serie ändern?"
],
	"\u0000This appointment is part of a series. Do you want to change your reminders for the whole series or just for this appointment within the series?\u0001": [
	"Dieser Termin ist Teil einer Serie. Möchten Sie Ihre Erinnerungen für die gesamte Serie oder nur für diesen Termin innerhalb der Serie ändern?"
],
	"\u0000This appointment is part of a series. Do you want to delete all appointments of the series or just this appointment?\u0001": [
	"Dieser Termin ist Teil einer Serie. Möchten Sie alle Termine der Serie oder nur diesen Termin löschen?"
],
	"\u0000This appointment is part of a series. Do you want to delete this and all future appointments of the series or just this appointment?\u0001": [
	"Dieser Termin ist Teil einer Serie. Möchten Sie diesen und alle zukünftigen Termine der Serie oder nur diesen Termin löschen?"
],
	"\u0000This appointment might not take place because all other attendees declined\u0001": [
	"Dieser Termin findet möglicherweise nicht statt, weil alle anderen Teilnehmer abgelehnt haben"
],
	"\u0000This appointment starts in %s\u0001": [
	"Dieser Termin beginnt in %s"
],
	"\u0000This appointment was canceled.\u0001": [
	"Dieser Termin wurde verworfen."
],
	"\u0000This browser is not compatible with your configured authentication device. Please use Chrome browser, or Firefox with U2F enabled.\u0001": [
	"Dieser Browser ist nicht mit Ihrem konfigurierten Authentifizierungsgerät kompatibel. Bitte verwenden Sie den Chrome-Browser oder Firefox mit aktiviertem U2F."
],
	"\u0000This browser is not supported on your current platform.\u0001": [
	"Dieser Browser wird auf Ihrer aktuellen Plattform nicht unterstützt."
],
	"\u0000This calendar is shared with others. It won't be available for them any more.\u0001": [
	"Dieser Ordner wurde für andere freigegeben. Er wird nicht mehr für sie verfügbar sein."
],
	"\u0000This contact is private and cannot be shared\u0001": [
	"Dies ist ein privater Kontakt und kann nicht freigegeben werden"
],
	"\u0000This device is not eligible for this request. Wrong hardware key?\u0001": [
	"Für diese Anfrage ist dieses Gerät nicht geeignet. Falscher Hardware-Schlüssel?"
],
	"\u0000This dialog is limited to %1$d entries and this group exceeds this limitation. Therefore, some entries are not listed.\u0001": [
	"Dieses Dialogfeld ist auf %1$d Einträge beschränkt. Diese Gruppe überschreitet diese Einschränkung. Daher werden einige Einträge nicht aufgeführt."
],
	"\u0000This dialog is limited to %1$d entries and your address book exceeds this limitation. Therefore, some entries are not listed.\u0001": [
	"Dieses Dialogfeld ist auf %1$d Einträge beschränkt. Ihr Adressbuch überschreitet diese Einschränkung. Daher werden einige Einträge nicht aufgeführt."
],
	"\u0000This distribution list has been added to the portal\u0001": [
	"Diese Verteilerliste wurde dem Portal hinzugefügt"
],
	"\u0000This document cannot be viewed at the moment because a new version is being uploaded. Please wait until the upload is completed.\u0001": [
	"Dieses Dokument kann im Moment nicht angezeigt werden, da eine neue Version hochgeladen wird. Bitte warten Sie, bis der Upload abgeschlossen ist."
],
	"\u0000This document is password protected and cannot be displayed.\u0001": [
	"Dieses Dokument ist passwortgeschützt und kann nicht angezeigt werden."
],
	"\u0000This draft has been changed in another tab or browser. Please continue editing the most recent version. If you have closed that tab in the meantime, you can restore the most recent draft here.\u0001": [
	"Dieser Entwurf wurde in einem anderen Tab oder Browser geändert. Bitte bearbeiten Sie die neueste Version weiter. Wenn Sie den Tab in der Zwischenzeit geschlossen haben, können Sie den neuesten Entwurf hier wiederherstellen."
],
	"\u0000This email address cannot be used\u0001": [
	"Diese E-Mail-Adresse kann nicht verwendet werden"
],
	"\u0000This email address is already used. Please choose a different one.\u0001": [
	"Diese E-Mail-Adresse ist bereits vergeben. Bitte wählen Sie eine andere."
],
	"\u0000This email address is invalid.\u0001": [
	"Diese E-Mail-Adresse ist ungültig."
],
	"\u0000This email contains a task\u0001": [
	"Diese E-Mail enthält eine Aufgabe"
],
	"\u0000This email contains an appointment\u0001": [
	"Diese E-Mail enthält einen Termin"
],
	"\u0000This email contains images from external sources that are currently hidden.\u0001": [
	"Diese E-Mail enthält Bilder aus externen Quellen, die derzeit ausgeblendet sind."
],
	"\u0000This email has been added to the portal\u0001": [
	"Diese E-Mail wurde dem Portal hinzugefügt"
],
	"\u0000This email has no content\u0001": [
	"Diese E-Mail hat keinen Inhalt"
],
	"\u0000This email has no subject. Do you want to send it anyway?\u0001": [
	"Diese E-Mail hat keinen Betreff. Wollen Sie sie trotzdem senden?"
],
	"\u0000This email has not been sent. You can save the draft to work on later.\u0001": [
	"Diese E-Mail wurde nicht gesendet. Sie können den Entwurf zum späteren Bearbeiten speichern."
],
	"\u0000This email is scheduled to be sent on %1$s.\u0001": [
	"Diese E-Mail ist für den Versand am %1$s geplant."
],
	"\u0000This email just contains your email address as sender. Your real name is not used.\u0001": [
	"Diese E-Mail enthält nur Ihre E-Mail-Adresse als Absender. Ihr richtiger Name wird nicht verwendet."
],
	"\u0000This email may contain images from external sources.\u0001": [
	"Diese E-Mail kann Bilder aus externen Quellen enthalten."
],
	"\u0000This email was sent on behalf of another person.\u0001": [
	"Diese E-Mail wurde im Auftrag einer anderen Person gesendet."
],
	"\u0000This email will be sent by %1$s on behalf of %2$s.\u0001": [
	"Diese E-Mail wird von %1$s im Auftrag von %2$s gesendet."
],
	"\u0000This evening\u0001": [
	"Heute Abend"
],
	"\u0000This feature isn't available for non-secure connections.\u0001": [
	"Diese Funktion steht nicht für unsichere Verbindungen zur Verfügung."
],
	"\u0000This field is mandatory\u0001": [
	"Dieses Feld muss ausgefüllt werden"
],
	"\u0000This file could not be uploaded.\u0001": [
	"Die Datei konnte nicht hochgeladen werden."
],
	"\u0000This file has been added to the portal\u0001": [
	"Diese Datei wurde dem Portal hinzugefügt"
],
	"\u0000This file has not been deleted\u0001": [
	"Diese Datei wurde nicht gelöscht"
],
	"\u0000This file has not been deleted, as it is locked by its owner.\u0001": [
	"Diese Datei konnte nicht gelöscht werden, da sie von Ihrem Eigentümer gesperrt wurde."
],
	"\u0000This file or folder is shared with others. It will not be available for them anymore.\u0001": [
	"Diese Datei oder dieser Ordner wurde für andere freigegeben. Die Datei bzw. der Ordner wird nicht mehr für sie verfügbar sein."
],
	"\u0000This file will be written in your default folder to allow editing\u0001": [
	"Diese Datei wird in Ihrem Standardordner gespeichert, um das Bearbeiten zu ermöglichen"
],
	"\u0000This folder has been shared with another user. You are not allowed to add this folder.\u0001": [
	"Dieser Ordner wurde für einen anderen Benutzer freigegeben. Sie dürfen diesen Ordner nicht hinzufügen."
],
	"\u0000This folder has no publications\u0001": [
	"Dieser Ordner enthält keine Veröffentlichungen"
],
	"\u0000This folder has no subscriptions\u0001": [
	"Dieser Ordner enthält keine Abonnements"
],
	"\u0000This folder has publications but you are not allowed to view or edit them\u0001": [
	"Dieser Ordner enthält Veröffentlichungen. Sie haben jedoch keine Berechtigung, diese zu sehen oder zu bearbeiten."
],
	"\u0000This folder has subscriptions\u0001": [
	"Dieser Ordner enthält Abonnements"
],
	"\u0000This folder has subscriptions but you are not allowed to view or edit them\u0001": [
	"Dieser Ordner enthält Abonnements. Sie haben jedoch keine Berechtigung, diese zu sehen oder zu bearbeiten."
],
	"\u0000This folder is empty\u0001": [
	"Dieser Ordner ist leer"
],
	"\u0000This folder is shared with others. It won't be available for them any more.\u0001": [
	"Dieser Ordner wurde für andere freigegeben. Er wird nicht mehr für sie verfügbar sein."
],
	"\u0000This info will be shown in your profile and to the recipients of your emails\u0001": [
	"Diese Informationen werden in Ihrem Profil und den Empfängern Ihrer E-Mails angezeigt"
],
	"\u0000This is a booking request for %1$s\u0001": [
	"Dies ist eine Buchungsanfrage für %1$s"
],
	"\u0000This is a browser feature for developers. If you were asked to copy and paste anything here, somebody might want to take over your account. Do not enter any script code without knowing what it does.\u0001": [
	"Dies ist eine Browserfunktion für Entwickler. Wenn Sie aufgefordert wurden, etwas zu kopieren und hier einzufügen, könnte jemand Ihr Konto übernehmen wollen. Geben Sie keinen Script-Code ein, von dem Sie nicht wissen, was er bewirkt."
],
	"\u0000This is a dangerous email containing spam or malware.\u0001": [
	"Dies ist eine gefährliche E-Mail, die Spam oder Schadsoftware enthält."
],
	"\u0000This is a standard folder, which can't be renamed.\u0001": [
	"Dies ist ein Standardordner, der nicht umbenannt werden kann."
],
	"\u0000This is an invalid email address.\u0001": [
	"Dies ist eine ungültige E-Mail-Adresse."
],
	"\u0000This is how your message text will look like.\u0001": [
	"So wird Ihr Nachrichtentext aussehen."
],
	"\u0000This is not a valid email address\u0001": [
	"Dies ist keine gültige E-Mail-Adresse"
],
	"\u0000This is not a valid email address. If you want to specify multiple addresses, please use a comma to separate them.\u0001": [
	"Dies ist keine gültige E-Mail Adresse. Wenn Sie mehrere Adressen angeben möchten, trennen Sie diese bitte mit einem Komma."
],
	"\u0000This is the email preview. You can also turn it off.\u0001": [
	"Dies ist die E-Mail-Vorschau. Sie können sie auch ausschalten."
],
	"\u0000This is your recovery code. Please write it down, print it, or save the file. Be sure to save this in a secure location.\u0001": [
	"Dies ist Ihr Wiederherstellungscode. Bitte notieren Sie ihn, drucken Sie ihn oder speichern Sie die Datei. Bewahren Sie ihn an einem sicheren Ort auf."
],
	"\u0000This list has no delegates yet\u0001": [
	"Diese Liste hat noch keine Beauftragten"
],
	"\u0000This list has no entries yet\u0001": [
	"Diese Liste hat noch keine Einträge"
],
	"\u0000This list has no members yet\u0001": [
	"Diese Liste hat noch keine Mitglieder"
],
	"\u0000This list has no participants yet\u0001": [
	"Diese Liste hat noch keine Teilnehmer"
],
	"\u0000This message has been truncated due to size limitations.\u0001": [
	"Diese Nachricht wurde wegen Größenbeschränkungen abgeschnitten."
],
	"\u0000This message was sent via a mailing list.\u0001": [
	"Diese Nachricht wurde über eine Mailingliste gesendet."
],
	"\u0000This message was sent via the mailing list %1$s.\u0001": [
	"Diese Nachricht wurde über die Mailingliste %1$s gesendet."
],
	"\u0000This name is already used. Please choose a different one.\u0001": [
	"Dieser Name ist bereits vergeben. Bitte wählen Sie einen anderen."
],
	"\u0000This note will not be printed\u0001": [
	"Dieser Hinweis wird nicht gedruckt"
],
	"\u0000This page is not served with http2. It is likely that you encounter performance issues. \u0001": [
	"Diese Seiten verwenden kein http2. Möglicherweise treten Leistungsprobleme auf. "
],
	"\u0000This platform is currently not supported.\u0001": [
	"Diese Plattform wird derzeit nicht unterstützt."
],
	"\u0000This release brings a completely new look and feel to your mobile device, including a faster navigation for switching apps, a redesigned mail app, updated compose windows, a new launcher design, and many more.\u0001": [
	"Diese Version bringt ein völlig neues Erscheinungsbild auf Ihr mobiles Endgerät, einschließlich einer schnelleren Navigation beim Wechseln zwischen Apps, einer neu gestalteten E-Mail-App, aktualisierter Fenster zum Verfassen, einem neuen Startprogramm-Design und vielem mehr."
],
	"\u0000This release brings a completely new look and feel to your mobile device, including a faster navigation for switching apps, a redesigned mail app, updated compose windows, a new launcher design, and many more. You can now also install %1$s on your device like an App. On Android using Chrome, tap the three dots in the top right, and select \"Install app\". On iOS, tap the share icon at the bottom, and choose \"Add to Home Screen\" to install.\u0001": [
	"Diese Version bringt ein völlig neues Erscheinungsbild auf Ihr mobiles Endgerät, einschließlich einer schnelleren Navigation beim Wechseln zwischen Apps, einer neu gestalteten E-Mail-App, aktualisierter Fenster zum Verfassen von E-Mails, einem neuen Startprogramm-Design und vielem mehr. Sie können %1$s jetzt auch wie eine App auf Ihrem Gerät installieren. Tippen Sie auf Android mit Chrome auf die drei Punkte oben rechts und wählen Sie \"App installieren\". Unter iOS tippen Sie unten auf das Freigabesymbol und wählen Sie zum Installieren \"Zum Startbildschirm hinzufügen\"."
],
	"\u0000This rule applies to all messages. Please add a condition to restrict this rule to specific messages.\u0001": [
	"Diese Regel gilt für alle Nachrichten. Fügen Sie bitte eine Bedingung hinzu, um diese Regel auf bestimmte Nachrichten zu beschränken."
],
	"\u0000This rule contains unsupported properties. \u0001": [
	"Diese Regel enthält nicht unterstützte Eigenschaften. "
],
	"\u0000This sender address is related to a disabled email account. Please choose another sender address or visit settings to enable again.\u0001": [
	"Diese Absenderadresse ist mit einem deaktivierten E-Mail-Konto verbunden. Bitte wählen Sie eine andere Absenderadresse oder aktivieren Sie in den Einstellungen das Konto wieder."
],
	"\u0000This setting allows you to choose how names consisting of first and last name are formatted.\u0001": [
	"Mit dieser Einstellung können Sie die Formatierung von Namen festlegen, die aus Vor- und Nachnamen bestehen."
],
	"\u0000This setting defines for how long file version are kept until they get deleted automatically after next sign-in\u0001": [
	"Diese Einstellung legt fest, wie lange Dateiversionen aufbewahrt werden, bis sie nach der nächsten Anmeldung automatisch gelöscht werden"
],
	"\u0000This setting defines how many versions will be kept. Older versions that exceed this limit will be automatically deleted\u0001": [
	"Diese Einstellung legt fest, wie viele Versionen aufbewahrt werden sollen. Ältere Versionen, die diese Grenze überschreiten, werden automatisch gelöscht"
],
	"\u0000This task has no participants yet\u0001": [
	"Diese Aufgabe hat noch keine Teilnehmer"
],
	"\u0000This task list is empty\u0001": [
	"Diese Aufgabenliste ist leer"
],
	"\u0000This task recurs\u0001": [
	"Diese Aufgabe wiederholt sich"
],
	"\u0000This type of link is unsupported and can't be added.\u0001": [
	"Diese Art von Link wird nicht unterstützt und kann nicht hinzugefügt werden."
],
	"\u0000This value is too long. The allowed length is %1$d characters.\u0001": [
	"Dieser Wert ist zu lang. Die zulässige Länge beträgt %1$d Zeichen."
],
	"\u0000This version of %1$s introduces a fresh calendar layout and enhanced usability for mobile users. Navigate your week with ease through our new, dynamic week view. The updated month view displays additional details, optimizing your daily routine.\u0001": [
	"Diese Version von %1$s bietet ein neues Kalenderlayout und verbesserte Benutzerfreundlichkeit für mobile Nutzer. Navigieren Sie mit unserer neuen, dynamischen Wochenansicht ganz einfach durch Ihre Woche. Die aktualisierte Monatsansicht zeigt zusätzliche Details an und optimiert so Ihre tägliche Routine."
],
	"\u0000This weekend\u0001": [
	"An diesem Wochenende"
],
	"\u0000This will assign a name to the device\u0001": [
	"Hiermit wird dem Gerät ein Name zugewiesen"
],
	"\u0000This will delete the device named %s.\u0001": [
	"Hiermit wird das Gerät namens %s gelöscht."
],
	"\u0000This will edit the name for device (%s)\u0001": [
	"Hiermit wird der Name für das Gerät (%s) bearbeitet"
],
	"\u0000This would also delete a currently edited draft.\u0001This would also delete %1$d currently edited drafts.": [
	"Dadurch würde auch ein aktuell bearbeiteter Entwurf gelöscht.",
	"Dadurch würden auch %1$d aktuell bearbeitete Entwürfe gelöscht."
],
	"\u0000Thread contains %1$d message\u0001Thread contains %1$d messages": [
	"Die Konversation enthält eine Nachricht",
	"Die Konversation enthält %1$d Nachrichten"
],
	"\u0000Three months\u0001": [
	"Drei Monate"
],
	"\u0000Thumbnail\u0001": [
	"Vorschaubild"
],
	"\u0000Thumbnails\u0001": [
	"Vorschaubilder"
],
	"superessive\u0000Thursday\u0001": [
	"Donnerstag"
],
	"\u0000Tiles\u0001": [
	"Kacheln"
],
	"\u0000Time\u0001": [
	"Zeit"
],
	"\u0000Time format\u0001": [
	"Zeitformat"
],
	"\u0000Time period back\u0001": [
	"Zeitspanne zurück"
],
	"\u0000Time period forward\u0001": [
	"Zeitspanne vorwärts"
],
	"\u0000Time scale\u0001": [
	"Zeitskala"
],
	"\u0000Time zone\u0001": [
	"Zeitzone"
],
	"\u0000Timeframe\u0001": [
	"Zeitrahmen"
],
	"\u0000Timeout\u0001": [
	"Zeitüberschreitung"
],
	"\u0000Title\u0001": [
	"Titel"
],
	"salutation\u0000Title\u0001": [
	"Anrede"
],
	"title\u0000Title\u0001": [
	"Titel"
],
	"\u0000To\u0001": [
	"An"
],
	"\u0000To add a password, select an application to use with a new password, as well as a new descriptive name for the password.\u0001": [
	"Um ein Passwort hinzuzufügen, wählen Sie eine Applikation zur Verwendung mit einem neuen Passwort aus und wählen Sie einen neuen beschreibenden Namen für das Passwort."
],
	"\u0000To add contacts manually, just provide a valid email address (e.g john.doe@example.com or \"John Doe\" <jd@example.com>)\u0001": [
	"Zum manuellen Hinzufügen von Teilnehmern geben Sie einfach eine gültige E-Mail-Adresse an (z.B. john.doe@beispiel.com oder \"John Doe\" <jd@beispiel.com>)"
],
	"\u0000To install %1$s like an app, simply scan the QR code with your device's camera.\u0001": [
	"Um %1$s wie eine App zu installieren, scannen Sie einfach den QR-Code mit der Kamera Ihres Geräts."
],
	"\u0000To install %1$s, please click on the download button:\u0001": [
	"Um %1$s zu installieren, klicken Sie bitte auf die Schaltfläche Herunterladen:"
],
	"\u0000To install %1$s, please scan this QR code with your phone or click on the download button:\u0001": [
	"Um %1$s zu installieren, scannen Sie bitte diesen QR-Code mit Ihrem Telefon oder klicken Sie auf die Schaltfläche Herunterladen:"
],
	"\u0000To learn more about the new and improved features you can visit \u0001": [
	"Wenn Sie mehr über die neuen und verbesserten Funktionen erfahren möchten, besuchen Sie "
],
	"\u0000To navigate between the %1$s applications, just click on the new App Launcher icon.\u0001": [
	"Zum Navigieren zwischen den %1$s-Applikationen klicken Sie einfach auf das neue App Launcher-Symbol ."
],
	"\u0000To print this file, please use \"Print as PDF\" in the viewer.\u0001": [
	"Zum Drucken dieser Datei verwenden Sie bitte \"Drucken als PDF\" im Viewer."
],
	"\u0000To synchronize Address Book, please enter the following settings in your CardDav client:\u0001": [
	"Um das Adressbuch zu synchronisieren, geben Sie bitte die folgenden Einstellungen in Ihrem CardDav-Client ein:"
],
	"\u0000To synchronize Calendar, please enter the following settings in your CalDav client:\u0001": [
	"Um den Kalender zu synchronisieren, geben Sie bitte die folgenden Einstellungen in Ihrem CalDav-Client ein:"
],
	"\u0000To synchronize Mail, Calendar and Address Book via Exchange Active Sync, please enter the following settings:\u0001": [
	"Um E-Mail, Kalender und Adressbuch über Exchange Active Sync zu synchronisieren, geben Sie bitte die folgenden Einstellungen ein:"
],
	"\u0000To: %1$s\u0001": [
	"An: %1$s"
],
	"\u0000Today\u0001": [
	"Heute"
],
	"\u0000Today,\u0001": [
	"Heute,"
],
	"\u0000Today: %1$s\u0001": [
	"Heute: %1$s"
],
	"\u0000Toggle category\u0001": [
	"Kategorie an/aus"
],
	"\u0000Toggle panel\u0001": [
	"Panel an/aus"
],
	"\u0000Toggle preview\u0001": [
	"Vorschau an/aus"
],
	"\u0000Tomorrow\u0001": [
	"Morgen"
],
	"\u0000Tonight\u0001": [
	"Heute Abend"
],
	"\u0000Top 10 you got email from\u0001": [
	"Top 10 Ihrer E-Mail-Absender"
],
	"\u0000Top 10 you sent email to\u0001": [
	"Top 10 Ihrer E-Mail-Adressaten"
],
	"\u0000Total\u0001": [
	"Gesamt"
],
	"\u0000Total: %1$d\u0001": [
	"Gesamt: %1$d"
],
	"\u0000Trash folder\u0001": [
	"Ordner 'Papierkorb'"
],
	"\u0000Trust\u0001": [
	"Vertrauen"
],
	"\u0000Trust certificate\u0001": [
	"Zertifikat vertrauen"
],
	"\u0000Trust certificate %1$s\u0001": [
	"Zertifikat %1$s vertrauen"
],
	"\u0000Trusted\u0001": [
	"Vertrauenswürdig"
],
	"\u0000Try again\u0001": [
	"Erneut versuchen"
],
	"\u0000Try again.\u0001": [
	"Versuchen Sie es erneut."
],
	"\u0000Trying to auto-configure your email account\u0001": [
	"Es wird versucht, Ihr E-Mail-Konto automatisch zu konfigurieren"
],
	"superessive\u0000Tuesday\u0001": [
	"Dienstag"
],
	"\u0000Two-step verification\u0001": [
	"Zwei-Faktor-Authentifizierung"
],
	"\u0000Type\u0001": [
	"Typ"
],
	"search\u0000Type\u0001": [
	"Typ"
],
	"\u0000UI version\u0001": [
	"Version der Benutzeroberfläche"
],
	"\u0000URI\u0001": [
	"URI"
],
	"\u0000URL\u0001": [
	"URL"
],
	"\u0000Unable to connect to email server. Possible reasons: The email server is (temporarily) down or there are network connection problems. Please try again in a few minutes.\u0001": [
	"Die Verbindung zum Mailserver ist fehlgeschlagen. Mögliche Gründe: Der Mailserver ist (vorübergehend) ausgefallen oder es gibt Probleme mit der Netzwerkverbindung. Bitte versuchen Sie es in ein paar Minuten erneut."
],
	"\u0000Unable to delete\u0001": [
	"Löschen nicht möglich"
],
	"\u0000Unable to edit name.\u0001": [
	"Bearbeiten des Namens nicht möglich."
],
	"\u0000Unable to load email rule settings.\u0001": [
	"Die Einstellungen der E-Mail-Regeln können nicht geladen werden."
],
	"\u0000Unable to load mail filter settings.\u0001": [
	"Die Mailfilter-Einstellungen konnten nicht geladen werden."
],
	"\u0000Unable to load your auto forward settings. Please retry later.\u0001": [
	"Die Einstellungen für die automatische Weiterleitung konnten nicht geladen werden. Bitte versuchen Sie es später erneut."
],
	"\u0000Unable to load your vacation notice. Please retry later.\u0001": [
	"Ihre Abwesenheitsbenachrichtigung konnte nicht geladen werden. Bitte versuchen Sie es später erneut."
],
	"\u0000Unable to perform anti-virus check for the requested file(s)\u0001": [
	"Anti-Virus-Prüfung für die angeforderte(n) Datei(en) kann nicht durchgeführt werden"
],
	"\u0000Unable to set image. Image might be too large or malformed.\u0001": [
	"Bild kann nicht übernommen werden. Das Bild ist möglicherweise zu groß oder fehlerhaft."
],
	"\u0000Unable to upload attachment. The referenced email may no longer exist or has been moved.\u0001": [
	"Anhang kann nicht hochgeladen werden. Die referenzierte E-Mail existiert möglicherweise nicht mehr oder wurde verschoben."
],
	"\u0000Unable to upload file\u0001": [
	"Datei kann nicht hochgeladen werden"
],
	"\u0000Unable to upload files\u0001": [
	"Dateien können nicht hochgeladen werden"
],
	"\u0000Unconfirmed\u0001": [
	"Nicht bestätigt"
],
	"\u0000Underline\u0001": [
	"Unterstrichen"
],
	"\u0000Undo\u0001": [
	"Rückgängig"
],
	"\u0000Undo Send\u0001": [
	"Senden zurücknehmen"
],
	"\u0000Undo action\u0001": [
	"Aktion rückgängig machen"
],
	"\u0000Undo mail operations\u0001": [
	"E-Mail-Aktionen rückgängig machen"
],
	"\u0000Undo send\u0001": [
	"Senden zurücknehmen"
],
	"\u0000Undone\u0001": [
	"Nicht erledigt"
],
	"\u0000Unflag\u0001": [
	"Markierung aufheben"
],
	"verb\u0000Unflag\u0001": [
	"Markierung aufheben"
],
	"\u0000Unfortunately your browser doesn't support listing available media devices.\u0001": [
	"Leider unterstützt Ihr Browser das Auflisten verfügbarer Mediengeräte nicht."
],
	"\u0000Unicolor\u0001": [
	"Einfarbig"
],
	"\u0000Unknown\u0001": [
	"Unbekannt"
],
	"\u0000Unknown %1$s\u0001": [
	"Unbekannt %1$s"
],
	"\u0000Unknown Sender\u0001": [
	"Unbekannter Absender"
],
	"\u0000Unknown application\u0001": [
	"Unbekannte Anwendung"
],
	"\u0000Unknown recipient\u0001": [
	"Unbekannter Empfänger"
],
	"\u0000Unknown sender\u0001": [
	"Unbekannter Absender"
],
	"\u0000Unknown system\u0001": [
	"Unbekanntes System"
],
	"\u0000Unlimited\u0001": [
	"Unbegrenzt"
],
	"\u0000Unlock\u0001": [
	"Sperre aufheben"
],
	"\u0000Unnamed subscription\u0001": [
	"Unbenanntes Abonnement"
],
	"\u0000Unread\u0001": [
	"Ungelesen"
],
	"\u0000Unread folder that contains all unread emails\u0001": [
	"Ordner \"Ungelesen\", der alle ungelesenen Nachrichten enthält"
],
	"\u0000Unread messages\u0001": [
	"Ungelesene Nachrichten"
],
	"\u0000Unread: %1$d\u0001": [
	"Ungelesen: %1$d"
],
	"\u0000Unsaved documents will be lost. Do you want to sign out now?\u0001": [
	"Ungesicherte Dokumente werden verloren gehen. Wollen Sie sich nun abmelden?"
],
	"\u0000Unshare\u0001": [
	"Freigabe aufheben"
],
	"\u0000Unsubscribed calendars\u0001": [
	"Nicht länger abonnierte Kalender"
],
	"\u0000Unsubscribed folders\u0001": [
	"Nicht länger abonnierte Ordner"
],
	"\u0000Untrust\u0001": [
	"Nicht vertrauen"
],
	"\u0000Untrust certificate %1$s\u0001": [
	"Zertifikat %1$s nicht vertrauen"
],
	"\u0000Update\u0001": [
	"Aktualisieren"
],
	"\u0000Update Appointment\u0001": [
	"Termin aktualisieren"
],
	"\u0000Update photo\u0001": [
	"Foto aktualisieren"
],
	"\u0000Updated %1$d minutes ago\u0001": [
	"Aktualisiert vor %1$d Minuten"
],
	"\u0000Updated at %1$d\u0001": [
	"Aktualisiert um %1$d"
],
	"\u0000Updated just now\u0001": [
	"Soeben aktualisiert"
],
	"\u0000Updates\u0001": [
	"Aktualisierungen"
],
	"software\u0000Updates\u0001": [
	"Updates"
],
	"\u0000Upgrade\u0001": [
	"Upgrade"
],
	"\u0000Upgrade your account\u0001": [
	"Konto-Upgrade"
],
	"\u0000Upload\u0001": [
	"Hochladen"
],
	"\u0000Upload Recovery File\u0001": [
	"Wiederherstellungsdatei hochloaden"
],
	"\u0000Upload a photo\u0001": [
	"Ein Foto hochladen"
],
	"\u0000Upload file\u0001": [
	"Datei hochladen"
],
	"\u0000Upload files\u0001": [
	"Dateien hochladen"
],
	"\u0000Upload folder\u0001": [
	"Ordner hochladen"
],
	"\u0000Upload local file\u0001": [
	"Lokale Datei hochladen"
],
	"\u0000Upload new version\u0001": [
	"Neue Version hochladen"
],
	"\u0000Upload progress\u0001": [
	"Upload-Fortschritt"
],
	"\u0000Uploading \"%1$s\"\u0001": [
	"\"%1$s\" wird hochgeladen ..."
],
	"\u0000Uploading Attachment…\u0001": [
	"Anhang hochladen…"
],
	"\u0000Uploading attachments\u0001": [
	"Anhänge werden hochgeladen"
],
	"\u0000Uploading folders is not supported in this display area.\u0001": [
	"Das Hochladen von Ordnern wird in diesem Anzeigebereich nicht unterstützt."
],
	"\u0000Uploading folders is not supported.\u0001": [
	"Das Hochladen von Ordnern wird nicht unterstützt."
],
	"\u0000Urgency\u0001": [
	"Dringlichkeit"
],
	"\u0000Usability\u0001": [
	"Benutzerfreundlichkeit"
],
	"\u0000Use %1$s\u0001": [
	"%1$s verwenden"
],
	"\u0000Use Yubikey's One Time Password System\u0001": [
	"Einmalpasswort-System von Yubikey verwenden"
],
	"\u0000Use browser default\u0001": [
	"Browser-Standard verwenden"
],
	"\u0000Use calendar color\u0001": [
	"Kalenderfarbe verwenden"
],
	"\u0000Use colors for quoted lines\u0001": [
	"Zitierte Zeilen farbig hervorheben"
],
	"\u0000Use cursor keys to change the date. Press ctrl-key at the same time to change year or shift-key to change month. Close date-picker by pressing ESC key.\u0001": [
	"Verwenden Sie die Pfeiltasten zum Ändern des Datums. Zum Ändern des Jahres drücken Sie gleichzeitig die Strg-Taste. Zum Ändern des Monats verwenden Sie die Umschalttaste. Den Datumswähler können Sie mit der Esc-Taste wieder schließen."
],
	"\u0000Use cursor keys to navigate, press enter to select a date\u0001": [
	"Verwenden Sie die Pfeiltasten zum Navigieren. Drücken Sie die Eingabetaste, um ein Datum zu wählen."
],
	"\u0000Use cursor keys to reorder items\u0001": [
	"Verwenden Sie die Pfeiltasten zum Neusortieren von Objekten"
],
	"\u0000Use custom name\u0001": [
	"Benutzerdefinierten Namen verwenden"
],
	"\u0000Use default\u0001": [
	"Standard verwenden"
],
	"\u0000Use first category color for appointments\u0001": [
	"Erste Kategoriefarbe für Termine verwenden"
],
	"\u0000Use fixed-width font for text mails\u0001": [
	"Schrift mit fester Breite für Text-E-Mails verwenden"
],
	"\u0000Use inbox categories to organize your incoming emails in different tabs\u0001": [
	"Sie können Posteingangskategorien verwenden, um Ihre eingehenden E-Mails in verschiedenen Tabs zu organisieren"
],
	"\u0000Use native desktop notifications\u0001": [
	"Native Desktop-Benachrichtigungen verwenden"
],
	"\u0000Use password\u0001": [
	"Passwort verwenden"
],
	"\u0000Use separate username and password\u0001": [
	"Separaten Benutzernamen und Passwort verwenden"
],
	"\u0000Use system setting\u0001": [
	"Systemeinstellung verwenden"
],
	"\u0000Use the 'Forward Appointment' feature to share appointment invitations with others. Please note that the meeting organizer must approve any new attendees you invite.\u0001": [
	"Verwenden Sie die Funktion \"Termin weiterleiten\", um Termineinladungen an andere weiterzugeben. Bitte beachten Sie, dass der Organisator des Meetings alle von Ihnen eingeladenen neuen Teilnehmer genehmigen muss."
],
	"\u0000Use unified mail for this account\u0001": [
	"Unified Mail für dieses Konto verwenden"
],
	"\u0000User\u0001": [
	"Benutzer"
],
	"\u0000User Categories\u0001": [
	"Benutzerkategorien"
],
	"\u0000User ID\u0001": [
	"Benutzer-ID"
],
	"\u0000User Name\u0001": [
	"Benutzername"
],
	"\u0000User data\u0001": [
	"Benutzerdaten"
],
	"\u0000User defined color\u0001": [
	"Benutzerdefinierte Farbe"
],
	"\u0000Username\u0001": [
	"Benutzername"
],
	"\u0000Username must not be empty.\u0001": [
	"Benutzernamen dürfen nicht leer sein."
],
	"\u0000Username: %s\u0001": [
	"Benutzername: %s"
],
	"\u0000Vacation notice\u0001": [
	"Abwesenheitsbenachrichtigung"
],
	"\u0000Verification Options\u0001": [
	"Verifizierungsoptionen"
],
	"\u0000Version Comment\u0001": [
	"Anmerkung zur Version"
],
	"\u0000Version comment\u0001": [
	"Anmerkung zur Version"
],
	"\u0000Version of %1$s\u0001": [
	"Version vom %1$s"
],
	"\u0000Version retention period\u0001": [
	"Aufbewahrungsfrist der Version"
],
	"\u0000Versions\u0001": [
	"Versionen"
],
	"\u0000Vertical\u0001": [
	"Vertikal"
],
	"\u0000Very large\u0001": [
	"Sehr groß"
],
	"\u0000Very likely\u0001": [
	"Sehr wahrscheinlich"
],
	"\u0000Very small\u0001": [
	"Sehr klein"
],
	"\u0000Via\u0001": [
	"Via"
],
	"\u0000Videos\u0001": [
	"Videos"
],
	"\u0000View\u0001": [
	"Ansicht"
],
	"\u0000View all attachments\u0001": [
	"Alle Anhänge anzeigen"
],
	"\u0000View details\u0001": [
	"Details anzeigen"
],
	"\u0000View folder\u0001": [
	"Ordner anzeigen"
],
	"\u0000View message\u0001": [
	"Nachricht anzeigen"
],
	"\u0000View more\u0001": [
	"Weitere anzeigen"
],
	"\u0000View options\u0001": [
	"Anzeigeoptionen"
],
	"\u0000View source\u0001": [
	"Quelldaten anzeigen"
],
	"\u0000View the folder\u0001": [
	"Ordner anzeigen"
],
	"\u0000View this version\u0001": [
	"Diese Version anzeigen"
],
	"\u0000Viewer\u0001": [
	"Betrachter"
],
	"\u0000Viewer (read emails)\u0001": [
	"Betrachter (E-Mails lesen)"
],
	"\u0000Viewer (view appointments)\u0001": [
	"Betrachter (Termine anzeigen)"
],
	"\u0000Visibility\u0001": [
	"Sichtbarkeit"
],
	"\u0000Waiting\u0001": [
	"Warten"
],
	"\u0000Warm Gray\u0001": [
	"Warmes Grau"
],
	"\u0000Warning\u0001": [
	"Warnhinweis"
],
	"\u0000Warning!\u0001": [
	"Warnhinweis"
],
	"\u0000Warning:\u0001": [
	"Warnhinweis:"
],
	"\u0000Warning: This message might be a phishing or scam mail\u0001": [
	"Warnhinweis: Bei dieser Nachricht könnte es sich um Pishing oder ein E-Mail Scam handeln"
],
	"\u0000Warnings\u0001": [
	"Warnhinweise"
],
	"\u0000Warnings:\u0001": [
	"Warnhinweise:"
],
	"\u0000Washed out\u0001": [
	"Verwaschen"
],
	"\u0000We appreciate your feedback\u0001": [
	"Wir freuen uns über Ihr Feedback"
],
	"\u0000We are very happy to introduce you to our brand-new user interface. We changed countless little details to offer you a great and contemporary user experience.\u0001": [
	"Wir freuen uns, Ihnen unsere brandneue Benutzeroberfläche vorzustellen. Wir haben an unzähligen Details gearbeitet, um Ihnen ein großartiges und zeitgemäßes Nutzungserlebnis bieten zu können."
],
	"\u0000We could not verify that this email is from %1$s.\u0001": [
	"Wir konnten nicht verifizieren, dass diese E-Mail von %1$s stammt."
],
	"\u0000We could verify that this email is from %1$s.\u0001": [
	"Wir konnten verifizieren, dass diese E-Mail von %1$s stammt."
],
	"\u0000We encountered an issue for your upload\u0001": [
	"Es gab ein Problem beim Hochladen"
],
	"\u0000We encountered some issues for your upload\u0001": [
	"Es gab Probleme beim Hochladen"
],
	"\u0000We have given the settings a new look and added a search function. Now you can find your way around the settings even faster.\u0001": [
	"Wir haben den Einstellungen ein neues Aussehen gegeben und eine Suchfunktion hinzugefügt. Jetzt können Sie sich noch schneller in den Einstellungen zurechtfinden."
],
	"\u0000We will guide you through the basic settings\u0001": [
	"Wir werden Sie durch die Grundeinstellungen führen"
],
	"\u0000We're excited to announce that you can now schedule emails to be sent on a specific future date. This feature makes planning and sending emails at your convenience incredibly easy.\u0001": [
	"Wir freuen uns, Ihnen eine Funktion präsentieren zu können, die den Versand von E-Mails zu einem bestimmten Datum in der Zukunft ermöglicht. Diese Funktion macht die zeitliche Planung und den Versand von E-Mails nach Ihren Wünschen unglaublich einfach."
],
	"\u0000We've expanded category support! While previously limited to appointments, contacts, and tasks, you can now assign categories to your emails as well.\u0001": [
	"Wir haben die Unterstützung für Kategorien erweitert. Während diese bisher auf Termine, Kontakte und Aufgaben beschränkt war, können Sie jetzt auch Ihren E-Mails Kategorien zuweisen."
],
	"\u0000Web auth\u0001": [
	"WebAuthn"
],
	"\u0000Webcam\u0001": [
	"Webcam"
],
	"superessive\u0000Wednesday\u0001": [
	"Mittwoch"
],
	"\u0000Week\u0001": [
	"Woche"
],
	"\u0000Week that contains January 1st (e.g. US, Canada)\u0001": [
	"Woche, die den 1. Januar enthält (z.B. USA, Kanada)"
],
	"\u0000Week that contains January 4th (e.g. Europe, ISO-8601)\u0001": [
	"Woche, die den 4. Januar enthält (z.B. Europa, ISO-8601)"
],
	"\u0000Week view\u0001": [
	"Wochenansicht"
],
	"\u0000Weekday\u0001": [
	"Wochentag"
],
	"\u0000Weekly\u0001": [
	"Wöchentlich"
],
	"\u0000Welcome\u0001": [
	"Willkommen"
],
	"\u0000Welcome to %1$s\u0001": [
	"Willkommen bei %s"
],
	"\u0000Welcome to %1$s.\nWe've made some exciting changes to %1$s. This quick tour will guide you through some of the new and improved features.\u0001": [
	"Willkommen bei %1$s.\nWir haben einige spannende Änderungen an %1$s vorgenommen. Diese kurze Tour führt Sie durch einige der neuen und verbesserten Funktionen."
],
	"\u0000Welcome to %s\u0001": [
	"Willkommen bei %s"
],
	"\u0000Welcome to your calendar\u0001": [
	"Willkommen in Ihrem Kalender"
],
	"\u0000Welcome to your files\u0001": [
	"Willkommen bei Ihren Dateien"
],
	"\u0000Welcome to your inbox\u0001": [
	"Willkommen in Ihrem Posteingang"
],
	"\u0000Welcome to your tasks\u0001": [
	"Willkommen bei Ihren Aufgaben"
],
	"\u0000What do you want to use?\u0001": [
	"Was möchten Sie verwenden?"
],
	"\u0000What is the one thing we could do to make you happier?\u0001": [
	"Mit welcher Maßnahme können wir Ihr Nutzungserlebnis verbessern?"
],
	"\u0000What is the primary reason for your score?\u0001": [
	"Was ist der Hauptgrund für Ihre Wertung?"
],
	"\u0000What should happen when adding files with identical names?\u0001": [
	"Was soll geschehen, wenn Dateien mit identischen Namen hinzugefügt werden?"
],
	"\u0000What type of device do you want to configure?\u0001": [
	"Welche Art von Gerät möchten Sie konfigurieren?"
],
	"\u0000What's new\u0001": [
	"Was ist neu"
],
	"\u0000What's new in %1$s\u0001": [
	"Was ist neu in %1$s"
],
	"\u0000When you respond to an email, you typically reply to the person who sent it. However, there are situations where it's preferred that the recipients of the response are different, such as a whole team or group. In these cases, the original sender can specify one or even multiple email addresses in the \"reply-to\" field, indicating who the response should be directed to. Additionally, if the same group of people often needs to receive the responses, default \"reply-to\" addresses can be set to simplify the process.\u0001": [
	"Wenn Sie auf eine E-Mail antworten, antworten Sie normalerweise der Person, die sie gesendet hat. In manchen Situationen werden jedoch andere Empfänger für die Antwort gewünscht, z. B. ein ganzes Team oder eine Gruppe. In diesen Fällen kann der ursprüngliche Absender im Feld \"Antwort an\" eine oder sogar mehrere E-Mail-Adressen als Empfänger angeben. Wenn eine Gruppe von Personen häufiger Antworten erhalten soll, können außerdem Standard-Antwortadressen festgelegt werden, um den Prozess zu vereinfachen."
],
	"\u0000Which application do you want to use?\u0001": [
	"Welche Applikation möchten Sie verwenden?"
],
	"\u0000Which device do you want to configure?\u0001": [
	"Welches Gerät möchten Sie konfigurieren?"
],
	"\u0000Which features do you value or use the most?\u0001": [
	"Welche Funktionen schätzen oder nutzen Sie am meisten?"
],
	"\u0000While reading\u0001": [
	"Beim Lesen"
],
	"\u0000While sending\u0001": [
	"Beim Senden"
],
	"\u0000While the site may work as expected, we recommend using Safari on iOS.\u0001": [
	"Auch wenn die Website wie erwartet funktioniert, empfehlen wir die Verwendung von Safari auf iOS."
],
	"\u0000White\u0001": [
	"Weiß"
],
	"\u0000Who can access this calendar?\u0001": [
	"Wer kann auf diesen Kalender zugreifen?"
],
	"\u0000Who can access this file?\u0001": [
	"Wer kann auf diese Datei zugreifen?"
],
	"\u0000Who can access this folder?\u0001": [
	"Wer kann auf diesen Ordner zugreifen?"
],
	"\u0000Windows\u0001": [
	"Windows"
],
	"\u0000Windows PC\u0001": [
	"Windows PC"
],
	"\u0000Windows you have minimized will appear in all applications for easy access. You can maximize a window again by clicking on it.\u0001": [
	"Fenster, die Sie minimiert haben, erscheinen für einen einfachen Zugang in allen Anwendungen. Sie können ein Fenster wieder maximieren, indem Sie darauf klicken."
],
	"\u0000With this feature, you can now seamlessly switch between apps using your browser's back and forward functions, providing a level of convenience and flexibility that was not previously available.\u0001": [
	"Mit dieser Funktion können Sie jetzt nahtlos zwischen den Apps wechseln, indem Sie die Vor- und Zurück-Funktionen Ihres Browsers verwenden. Dies bietet einen vorher nicht dagewesenen Grad an Komfort und Flexibilität."
],
	"\u0000Without delay\u0001": [
	"Ohne Verzögerung"
],
	"\u0000Wood\u0001": [
	"Holz"
],
	"\u0000Work\u0001": [
	"Arbeit"
],
	"\u0000Working Time\u0001": [
	"Arbeitszeit"
],
	"\u0000Working time & workweek\u0001": [
	"Arbeitszeit & Arbeitswoche"
],
	"\u0000Working times\u0001": [
	"Arbeitszeiten"
],
	"\u0000Workweek\u0001": [
	"Arbeitswoche"
],
	"\u0000Write permissions\u0001": [
	"Schreibberechtigungen"
],
	"\u0000XML profile could not be loaded\u0001": [
	"XML-Profil konnte nicht geladen werden"
],
	"\u0000YB\u0001": [
	"YB"
],
	"\u0000Year\u0001": [
	"Jahr"
],
	"\u0000Year view\u0001": [
	"Jahresansicht"
],
	"\u0000Year view in mobile calendar\u0001": [
	"Jahresansicht im mobilen Kalender"
],
	"\u0000Yearly\u0001": [
	"Jährlich"
],
	"\u0000Yellow\u0001": [
	"Gelb"
],
	"\u0000Yes\u0001": [
	"Ja"
],
	"\u0000Yesterday\u0001": [
	"Gestern"
],
	"\u0000You are currently acting on behalf of the calendar owner.\u0001": [
	"Sie handeln derzeit im Namen des Kalendereigentümers."
],
	"\u0000You are currently signed in with the following devices\u0001": [
	"Sie sind derzeit mit folgenden Geräten angemeldet"
],
	"\u0000You are moving one or more items that are shared with other people. These people will lose access.\u0001": [
	"Sie verschieben ein oder mehrere Elemente, die für andere Personen freigegeben wurden. Diese Personen werden die Zugriffsrechte verlieren."
],
	"\u0000You are no longer using a public calendar. You were added as organizer.\u0001": [
	"Sie verwenden keinen öffentlichen Kalender mehr. Sie wurden als Organisator hinzugefügt."
],
	"\u0000You are no longer using a shared calendar. You were added as organizer.\u0001": [
	"Sie verwenden keinen freigegebenen Kalender mehr. Sie wurden als Organisator hinzugefügt."
],
	"\u0000You are the organizer\u0001": [
	"Sie sind der Organisator"
],
	"\u0000You are using a shared calendar. The calendar owner was added as organizer.\u0001": [
	"Sie verwenden einen freigegebenen Kalender. Der Kalendereigentümer wurde als Organisator hinzugefügt."
],
	"\u0000You can adjust the countdown in %1$s\u0001": [
	"Sie können den Countdown unter %1$s einstellen"
],
	"\u0000You can adjust the time to undo sending an email in %1$s\u0001": [
	"Sie können die Zeit bis zum Zurücknehmen des Versands einer E-Mail unter %1$s einstellen"
],
	"\u0000You can always change them later\u0001": [
	"Sie können sie später jederzeit ändern"
],
	"\u0000You can download a copy of your personal data from your account, if you want to save it or transfer it to another provider.\u0001": [
	"Sie können eine Kopie Ihrer persönlichen Daten von Ihrem Konto herunterladen, wenn Sie sie speichern oder an einen anderen Anbieter übertragen möchten."
],
	"\u0000You can edit the list of countries in your Zoom profile.\u0001": [
	"Sie können die Liste der Länder in Ihrem Zoom-Profil bearbeiten."
],
	"\u0000You can edit your favorite apps as a shortcut.\u0001": [
	"Sie können Ihre bevorzugten Anwendungen als Verknüpfung bearbeiten."
],
	"\u0000You can enable categories again via the \"Inbox categories\" entry in the settings dropdown\u0001": [
	"Sie können die Kategorien über den Eintrag \"Posteingangskategorien\" im Aufklappmenü der Einstellungen wieder aktivieren"
],
	"\u0000You can find these options in %1$s\u0001": [
	"Sie finden diese Optionen unter %1$s"
],
	"\u0000You can manage the templates in %1$s\u0001": [
	"Sie können die Vorlagen unter %1$s verwalten"
],
	"\u0000You can now add additional verification options to enhance the security of your account.\u0001": [
	"Sie können nun zusätzliche Verifizierungsoptionen hinzufügen, um die Sicherheit Ihres Kontos zu erhöhen."
],
	"\u0000You can now attach files from %1$s directly to appointments, contacts, or tasks\u0001": [
	"Sie können jetzt Dateien aus %1$s direkt an Termine, Kontakte oder Aufgaben anhängen"
],
	"\u0000You can now easily forward meeting invitations to others, facilitating seamless sharing and coordination of appointments.\u0001": [
	"Sie können nun problemlos Meeting-Einladungen an andere Personen weiterleiten. Dies ermöglicht eine nahtlose Freigabe und Koordination von Terminen."
],
	"\u0000You can now easily reuse attachments from your previous emails! %s automatically remembers your recent attachments and makes them easily accessible when you're composing a new message. Say goodbye to the hassle of downloading and reuploading files.\u0001": [
	"Sie können jetzt Anhänge aus Ihren früheren E-Mails ganz einfach wiederverwenden! %s merkt sich automatisch Ihre letzten Anhänge und macht sie beim Verfassen einer neuen Nachricht leicht zugänglich. Verabschieden Sie sich vom mühsamen Herunterladen und erneuten Hochladen von Dateien."
],
	"\u0000You can now install %1$s like an app for quick and easy access!\u0001": [
	"Für einen schnellen und einfachen Zugriff können Sie %1$s jetzt wie eine App installieren!"
],
	"\u0000You can now install %1$s like an app for quick and easy access! A new wizard will walk you through all the necessary steps on your device. Please note that this feature is only available if your browser supports Progressive Web Apps (PWAs) - currently some browsers do not support PWA installation.\u0001": [
	"Für einen schnellen und einfachen Zugriff können Sie %1$s jetzt wie eine App installieren! Ein neuer Assistent führt Sie durch alle notwendigen Schritte auf Ihrem Gerät. Bitte beachten Sie, dass diese Funktion nur verfügbar ist, wenn Ihr Browser Progressive Web Apps (PWAs) unterstützt - derzeit unterstützen einige Browser die PWA-Installation nicht."
],
	"\u0000You can now recover deleted contacts from the new trash folder before they are permanently removed.\u0001": [
	"Ab sofort können Sie gelöschte Kontakte aus dem neuen Papierkorb-Ordner wiederherstellen, bevor sie endgültig entfernt werden."
],
	"\u0000You can now set a default signature for alias addresses as well\u0001": [
	"Sie können nun auch für Alias-Adressen eine Standardsignatur festlegen"
],
	"\u0000You can perform common tasks with keyboard shortcuts. You can choose which profile you want to use or turn them off.\u0001": [
	"Sie können häufige Aufgaben mit Tastaturkürzeln ausführen. Sie können ein Profil wählen oder Tastaturkürzel deaktivieren."
],
	"\u0000You can quick-save your changes via Cmd+Enter.\u0001": [
	"Mit Cmd+Enter können Sie Ihre Änderungen schnell speichern."
],
	"\u0000You can quick-save your changes via Ctrl+Enter.\u0001": [
	"Sie können Ihre Änderung mit Strg+Enter speichern."
],
	"\u0000You can set the default addresses in %1$s\u0001": [
	"Sie können die Standardadressen unter %1$s einstellen"
],
	"\u0000You cannot add contacts in \"%1$s\". Do you want to add a new contact to your default address book instead?\u0001": [
	"Sie können keine Kontakte zu \"%1$s\" hinzufügen. Möchten Sie stattdessen einen neuen Kontakt zu Ihrem Standardadressbuch hinzufügen?"
],
	"\u0000You cannot add tasks in \"%1$s\". Do you want to add a new task to your default folder instead?\u0001": [
	"Sie können keine Aufgaben zu \"%1$s\" hinzufügen. Möchten Sie stattdessen eine neue Aufgabe zu Ihrem Standardordner hinzufügen?"
],
	"\u0000You cannot mark the appointment as secret, when blocking a resource.\u0001": [
	"Sie können den Termin nicht als geheim kennzeichnen, wenn Sie eine Ressource blockieren."
],
	"\u0000You cannot move items to this folder\u0001": [
	"Sie können keine Objekte in diesen Ordner verschieben"
],
	"\u0000You cannot select this folder.\u0001": [
	"Sie können diesen Ordner nicht auswählen."
],
	"\u0000You cannot work on more than %1$s drafts at the same time.\u0001": [
	"Sie können nicht an mehr als %1$s Entwürfen gleichzeitig arbeiten."
],
	"\u0000You declined this appointment\u0001": [
	"Sie haben diesen Termin abgelehnt"
],
	"\u0000You declined this task\u0001": [
	"Sie haben diese Aufgabe abgelehnt"
],
	"\u0000You don't have any appointments in the near future.\u0001": [
	"Sie haben keine Termine in naher Zukunft."
],
	"\u0000You don't have any publications yet\u0001": [
	"Sie haben noch keine Veröffentlichungen"
],
	"\u0000You don't have any subscriptions yet\u0001": [
	"Sie haben noch keine Abonnements"
],
	"\u0000You don't have any tasks that are either due soon or overdue.\u0001": [
	"Sie haben keine in Kürze fälligen oder überfälligen Aufgaben."
],
	"\u0000You first need to connect %1$s with Zoom. To do so, you need a Zoom Account. If you don't have an account yet, it is sufficient to create a free one.\u0001": [
	"Sie müssen zuerst %1$s mit Zoom verbinden. Dazu benötigen Sie ein Zoom-Konto. Wenn Sie noch kein Konto haben, ist es ausreichend, ein kostenloses Konto zu erstellen."
],
	"\u0000You forgot to sign out last time. Always use the sign-out button when you finished your work.\u0001": [
	"Sie haben letztes Mal vergessen, sich abzumelden. Verwenden Sie immer die Schaltfläche \"Abmelden\", wenn Sie Ihre Arbeit beendet haben."
],
	"\u0000You have %1$d unread message\u0001You have %1$d unread messages": [
	"Sie haben eine ungelesene Nachricht",
	"Sie haben %1$d ungelesene Nachrichten"
],
	"\u0000You have accepted the appointment\u0001": [
	"Sie haben den Termin bestätigt"
],
	"\u0000You have accepted this appointment\u0001": [
	"Sie haben diesen Termin bestätigt"
],
	"\u0000You have accepted this task\u0001": [
	"Sie haben diese Aufgabe bestätigt"
],
	"\u0000You have been automatically signed out\u0001": [
	"Sie wurden automatisch abgemeldet"
],
	"\u0000You have currently no deputies assigned.\u0001": [
	"Sie haben derzeit keine Stellvertreter zugewiesen."
],
	"\u0000You have declined the appointment\u0001": [
	"Sie haben den Termin abgelehnt"
],
	"\u0000You have linked the following Zoom account:\u0001": [
	"Sie haben folgendes Zoom-Konto verknüpft:"
],
	"\u0000You have new email\u0001": [
	"Sie haben neue E-Mails"
],
	"\u0000You have no unread messages\u0001": [
	"Sie haben keine neuen Nachrichten"
],
	"\u0000You have reached the limit of %1$d contacts to display. Please enter a search term to narrow down your results.\u0001": [
	"Sie haben die maximal anzuzeigende Anzahl von %1$d Kontakten erreicht. Bitte geben Sie einen Suchbegriff ein, um Ihre Ergebnisse einzugrenzen."
],
	"\u0000You have tentatively accepted the appointment\u0001": [
	"Sie haben den Termin vorläufig bestätigt"
],
	"\u0000You have to select a file to upload.\u0001": [
	"Bitte wählen Sie eine Datei zum Hochladen aus."
],
	"\u0000You have to sign in again\u0001": [
	"Sie müssen sich erneut anmelden"
],
	"\u0000You mentioned \"%s\" in your email, but there are no files attached.\u0001": [
	"Sie haben \"%s\" in Ihrer E-Mail erwähnt, aber es sind keine Dateien angehängt."
],
	"\u0000You must enter a folder name\u0001": [
	"Sie müssen einen Ordnernamen eingeben"
],
	"\u0000You need to invite at least one participant.\u0001": [
	"Sie müssen mindestens einen Teilnehmer einladen."
],
	"\u0000You need to use Android %n or higher.\u0001": [
	"Sie benötigen mindestens Android %n."
],
	"\u0000You need to use iOS %n or higher.\u0001": [
	"Sie benötigen mindestens iOS %n."
],
	"\u0000You recently changed your password. Please provide your last password to recover passwords for external accounts.\u0001": [
	"Sie haben vor Kurzem Ihr Passwort geändert. Geben Sie Ihr letztes Passwort an, um Passwörter für externe Konten wiederherzustellen."
],
	"\u0000You secured your account with 2-step verification. Please enter the verification code from the Authenticator App.\u0001": [
	"Sie haben Ihr Konto mit der Zwei-Faktor-Authentifizierung gesichert. Bitte geben Sie den Bestätigungscode der Authenticator-App ein."
],
	"\u0000You secured your account with 2-step verification. Please enter the verification code we sent to your phone.\u0001": [
	"Sie haben Ihr Konto mit der Zwei-Faktor-Authentifizierung gesichert. Bitte geben Sie den Bestätigungscode ein, den wir an Ihre Mobiltelefonnummer geschickt haben."
],
	"\u0000You secured your account with 2-step verification. Please use your authentication token to complete verification.\u0001": [
	"Sie haben Ihr Konto mit der Zwei-Faktor-Authentifizierung gesichert. Bitte verwenden Sie Ihren Authentifizierungs-Token, um die Verifizierung abzuschließen."
],
	"\u0000You share this folder with other users\u0001": [
	"Sie haben diesen Ordner für andere Benutzer freigegeben"
],
	"\u0000You tentatively accepted this appointment\u0001": [
	"Sie haben diesen Termin vorläufig bestätigt"
],
	"\u0000You tentatively accepted this task\u0001": [
	"Sie haben diese Aufgabe vorläufig bestätigt"
],
	"\u0000You unsubscribed from all folders on \"%1$s\". Those folders will be removed from your account.\u0001": [
	"Sie haben sich von allen Ordnern auf \"%1$s\" abgemeldet. Diese Ordner werden aus Ihrem Konto entfernt."
],
	"\u0000You will be automatically signed out in %1$d second\u0001You will be automatically signed out in %1$d seconds": [
	"Sie werden in einer Sekunde automatisch abgemeldet",
	"Sie werden in %1$d Sekunden automatisch abgemeldet"
],
	"\u0000Your Accounts\u0001": [
	"Ihre Konten"
],
	"\u0000Your Comment\u0001": [
	"Ihr Kommentar"
],
	"\u0000Your IP address has changed\u0001": [
	"Ihre IP-Adresse hat sich geändert"
],
	"\u0000Your account password\u0001": [
	"Ihr Kontopasswort"
],
	"\u0000Your approval for one or more resources is required.\u0001": [
	"Ihre Zustimmung zu mindestens einer Ressource wird benötigt."
],
	"\u0000Your archive\u0001": [
	"Ihr Archiv"
],
	"\u0000Your are sharing one or more folders for which you do not have permissions. These folders will not be shared.\u0001": [
	"Sie geben einen oder mehrere Ordner frei, für die Sie keine Berechtigung haben. Diese Ordner werden nicht freigegeben."
],
	"\u0000Your browser does not support the audio format of this file.\u0001": [
	"Ihr Browser unterstützt das Audio-Format dieser Datei nicht."
],
	"\u0000Your browser does not support the video format of this file.\u0001": [
	"Ihr Browser unterstützt das Video-Format dieser Datei nicht."
],
	"\u0000Your browser is not officially supported on your current platform.\u0001": [
	"Ihr Browser wird auf Ihrer aktuellen Plattform nicht offiziell unterstützt."
],
	"\u0000Your browser is not supported\u0001": [
	"Ihr Browser wird nicht unterstützt"
],
	"\u0000Your browser's cookie functionality is disabled. Please turn it on.\u0001": [
	"In Ihrem Browser sind Cookies nicht aktiviert. Bitte aktivieren Sie diese Funktionalität."
],
	"\u0000Your changes are automatically saved while you compose your email until you finally send it.\u0001": [
	"Bis zum Senden Ihrer E-Mail werden Ihre Änderungen beim Verfassen automatisch gespeichert."
],
	"\u0000Your credentials will be sent over a secure connection only\u0001": [
	"Ihre Zugangsdaten werden ausschließlich über eine sichere Verbindung gesendet"
],
	"\u0000Your current password\u0001": [
	"Ihr aktuelles Passwort"
],
	"\u0000Your current selection contains too many appointments for the chosen timeframe.\u0001": [
	"Ihre aktuelle Auswahl enthält zu viele Termine für den gewählten Zeitrahmen."
],
	"\u0000Your data archive from %1$s is ready for download. The download is available until %2$s.\u0001": [
	"Ihr Datenarchiv vom %1$s steht zum Herunterladen bereit. Das Archiv ist bis %2$s verfügbar."
],
	"\u0000Your default reminders will be applied to this calendar.\u0001": [
	"Ihre Standarderinnerungen werden auf diesen Kalender angewendet."
],
	"\u0000Your devices\u0001": [
	"Ihre Geräte"
],
	"\u0000Your email address\u0001": [
	"Ihre E-Mail-Adresse"
],
	"\u0000Your name\u0001": [
	"Ihr Name"
],
	"\u0000Your new password may not be empty.\u0001": [
	"Ihr neues Passwort darf nicht leer sein."
],
	"\u0000Your old password\u0001": [
	"Ihr altes Passwort"
],
	"\u0000Your password\u0001": [
	"Ihr Passwort"
],
	"\u0000Your password is expired. Please change your password to continue.\u0001": [
	"Ihr Passwort ist abgelaufen. Zum Fortfahren ändern Sie bitte Ihr Passwort."
],
	"\u0000Your password is more secure if it also contains capital letters, numbers, and special characters like %1$s\u0001": [
	"Ihr Passwort ist sicherer, wenn es auch Großbuchstaben, Zahlen und Sonderzeichen wie %1$s enthält."
],
	"\u0000Your platform is not supported\u0001": [
	"Ihre Plattform wird nicht unterstützt"
],
	"\u0000Your platform is not supported!\u0001": [
	"Ihre Plattform wird nicht unterstützt."
],
	"\u0000Your preview is being generated.\u0001": [
	"Ihre Vorschau wird generiert."
],
	"\u0000Your recurrence rule does not fit to your start date.\u0001": [
	"Ihre Serienregel passt nicht zu Ihrem Starttermin."
],
	"\u0000Your recurrence rule was changed automatically.\u0001": [
	"Ihre Serienregel wurde automatisch geändert."
],
	"\u0000Your requested archive is currently being created. Depending on the size of the requested data this may take hours or days. You will be informed via email when your download is ready.\u0001": [
	"Das angeforderte Archiv wird gerade erstellt. Je nach Größe der angeforderten Daten kann dies Stunden oder Tage dauern. Sie werden per E-Mail informiert, wenn Ihr Download abgeschlossen ist."
],
	"\u0000Your session is expired\u0001": [
	"Ihre Sitzung ist abgelaufen"
],
	"\u0000Your timezone\u0001": [
	"Ihre Zeitzone"
],
	"\u0000Your url\u0001": [
	"Ihre URL"
],
	"\u0000Your user name\u0001": [
	"Ihr Benutzername"
],
	"\u0000Your vacation notice is active\u0001": [
	"Ihre Abwesenheitsbenachrichtigung ist aktiv"
],
	"\u0000Your week\u0001": [
	"Ihre Woche"
],
	"\u0000Yubikey\u0001": [
	"Yubikey"
],
	"\u0000Yubikey, Google Security Keys, or compatible FIDO device\u0001": [
	"Yubikey, Google-Sicherheitsschlüssel oder kompatibles FIDO-Gerät"
],
	"\u0000ZB\u0001": [
	"ZB"
],
	"\u0000Zoom\u0001": [
	"Zoom"
],
	"\u0000Zoom Meeting\u0001": [
	"Zoom-Meeting"
],
	"\u0000Zoom in\u0001": [
	"Vergrößern"
],
	"\u0000Zoom meetings\u0001": [
	"Zoom-Meetings"
],
	"\u0000Zoom meetings expire after 365 days. We recommend to limit the series to one year. Alternatively, you can update the series before the Zoom meeting expires.\u0001": [
	"Zoom-Meetings laufen nach 365 Tagen ab. Wir empfehlen, die Serie auf ein Jahr zu begrenzen. Alternativ können Sie die Serie aktualisieren, bevor das Zoom-Meeting abläuft."
],
	"\u0000Zoom out\u0001": [
	"Verkleinern"
],
	"\u0000Zoom: %1$d%\u0001": [
	"Zoom: %1$d%"
],
	"\u0000[Copy] \u0001": [
	"[Kopie] "
],
	"\u0000[Copy] %1$s\u0001": [
	"[Kopie] %1$s"
],
	"\u0000a full match (allows DOS-style wildcards)\u0001": [
	"eine exakte Übereinstimmung (erlaubt Wildcards im DOS-Stil)"
],
	"\u0000accepted\u0001": [
	"bestätigt"
],
	"search\u0000address\u0001": [
	"anschrift"
],
	"search\u0000after\u0001": [
	"nach"
],
	"\u0000after end\u0001": [
	"nach Ende"
],
	"\u0000after start\u0001": [
	"nach Beginn"
],
	"\u0000an exact, full match\u0001": [
	"eine genaue, exakte Übereinstimmung"
],
	"\u0000and %1$d others\u0001": [
	"und %1$d weitere"
],
	"\u0000and %1$s more appointments\u0001": [
	"und %1$s weitere Termine"
],
	"a11y\u0000at %1$s\u0001": [
	"Ort: %1$s"
],
	"search\u0000attachments\u0001": [
	"anhänge"
],
	"\u0000autoforward\u0001": [
	"Automatische Weiterleitung"
],
	"\u0000back\u0001": [
	"zurück"
],
	"search\u0000before\u0001": [
	"vor"
],
	"\u0000before end\u0001": [
	"vor Ende"
],
	"\u0000before start\u0001": [
	"vor Beginn"
],
	"search\u0000business\u0001": [
	"geschäftlich"
],
	"\u0000calendar\u0001": [
	"Kalender"
],
	"search\u0000categories\u0001": [
	"kategorien"
],
	"\u0000choose a different platform\u0001": [
	"wählen Sie eine andere Plattform"
],
	"\u0000choose a different scenario\u0001": [
	"wählen Sie ein anderes Szenario"
],
	"\u0000continue if all conditions are met\u0001": [
	"fortsetzen, wenn alle Bedingungen erfüllt sind"
],
	"\u0000continue if all of these conditions are met\u0001": [
	"fortsetzen, wenn alle diese Bedingungen erfüllt sind"
],
	"\u0000continue if any of these conditions are met\u0001": [
	"fortsetzen, wenn irgendeine dieser Bedingungen erfüllt ist"
],
	"\u0000datepicker\u0001": [
	"Datumswähler"
],
	"\u0000day(s)\u0001": [
	"Tag(e)"
],
	"\u0000declined\u0001": [
	"abgelehnt"
],
	"\u0000deleted\u0001": [
	"gelöscht"
],
	"\u0000department %1$s\u0001": [
	"Abteilung %1$s"
],
	"\u0000does not match a substring\u0001": [
	"stimmt nicht mit einer Teilzeichenfolge überein"
],
	"search\u0000email\u0001": [
	"e-mail"
],
	"\u0000email address %1$s\u0001": [
	"E-Mail-Adresse %1$s"
],
	"\u0000ends:\u0001": [
	"endet:"
],
	"\u0000fifth / last\u0001": [
	"fünften / letzten"
],
	"\u0000file\u0001": [
	"Datei"
],
	"search\u0000file\u0001": [
	"Datei"
],
	"\u0000first\u0001": [
	"ersten"
],
	"\u0000flagged\u0001": [
	"markiert"
],
	"search\u0000flagged\u0001": [
	"markiert"
],
	"\u0000folder\u0001": [
	"Ordner"
],
	"\u0000fourth\u0001": [
	"vierten"
],
	"\u0000has attachments\u0001": [
	"enthält Anhänge"
],
	"\u0000has participants\u0001": [
	"hat Teilnehmer"
],
	"\u0000iCal URL\u0001": [
	"iCal-URL"
],
	"\u0000iCal feed\u0001": [
	"iCal-Feed"
],
	"\u0000iCal feed has been imported successfully\u0001": [
	"iCal-Feed wurde erfolgreich importiert"
],
	"\u0000iCalendar\u0001": [
	"iCalendar"
],
	"\u0000iOS\u0001": [
	"iOS"
],
	"\u0000iOS Mail\u0001": [
	"iOS Mail"
],
	"\u0000iOS devices can be automatically configured by installing the configuration profile.\u0001": [
	"iOS-Geräte können automatisch konfiguriert werden, indem das Konfigurationsprofil installiert wird."
],
	"\u0000iPhone or iPad\u0001": [
	"iPhone oder iPad"
],
	"\u0000kB\u0001": [
	"kB"
],
	"\u0000list of available actions\u0001": [
	"Liste der verfügbaren Aktionen"
],
	"\u0000list of available devices\u0001": [
	"Liste der verfügbaren Geräte"
],
	"\u0000list of available platforms\u0001": [
	"Liste der verfügbaren Plattformen"
],
	"\u0000loading\u0001": [
	"laden ..."
],
	"a11y\u0000location %1$s\u0001": [
	"Ort %1$s"
],
	"\u0000macOS\u0001": [
	"macOS"
],
	"\u0000matches a substring\u0001": [
	"stimmt mit einem Teilstring überein"
],
	"\u0000message\u0001": [
	"Nachricht"
],
	"\u0000modified\u0001": [
	"geändert"
],
	"\u0000month(s)\u0001": [
	"Monat(e)"
],
	"search\u0000name\u0001": [
	"name"
],
	"\u0000no color\u0001": [
	"keine Farbe"
],
	"\u0000none\u0001": [
	"Keiner"
],
	"\u0000not a full match (allows DOS-style wildcards)\u0001": [
	"keine exakte Übereinstimmung (erlaubt Wildcards im DOS-Stil)"
],
	"\u0000not an exact, full match \u0001": [
	"keine genaue, exakte Übereinstimmung "
],
	"search\u0000note\u0001": [
	"notiz"
],
	"\u0000of %1$d\u0001": [
	"von %1$d"
],
	"\u0000on behalf of\u0001": [
	"im Auftrag von"
],
	"\u0000one hour\u0001%d hours": [
	"1 Stunde",
	"%d Stunden"
],
	"\u0000one minute\u0001%d minutes": [
	"1 Minute",
	"%d Minuten"
],
	"\u0000only sets accent colors in darkmode\u0001": [
	"setzt Akzentfarben nur im Dunkelmodus"
],
	"\u0000or\u0001": [
	"oder"
],
	"\u0000original time zone\u0001": [
	"ursprüngliche Zeitzone"
],
	"search\u0000phone\u0001": [
	"telefon"
],
	"\u0000phone number %1$s\u0001": [
	"Telefonnummer %1$s"
],
	"\u0000position %1$s\u0001": [
	"Position %1$s"
],
	"\u0000private\u0001": [
	"Privat"
],
	"\u0000recovery\u0001": [
	"Wiederherstellung"
],
	"\u0000room %1$s\u0001": [
	"Raum %1$s"
],
	"\u0000second\u0001": [
	"zweiten"
],
	"\u0000see attached|see attachment|see included|is attached|attached is|are attached|attached are|attached to this email|attached to this message|I'm attaching|I am attaching|I've attached|I have attached|I attach|I attached|find attached|find the attached|find included|find the included|attached file|see the attached|see attachments|attached files|see the attachment\u0001": [
	"angehängt, siehe|siehe Anhang|siehe beigefügt|ist angehängt|angehängt ist|sind angehängt|angehängt sind|angehängt an diese E-Mail|angehängt an diese email|angehängt an diese Nachricht|Ich hänge an|Ich habe angehängt|siehe die angehängte Datei|siehe angehängte Datei|siehe angehängte Dateien|siehe die angehängten Dateien|siehe Anhänge|beigefügte Dateien|Ich habe beigefügt|beigefügt, siehe|dieser E-Mail beigefügt|dieser email beigefügt|siehe beigefügte Dateien|siehe beigefügte Datei|sind beigefügt|beigefügt sind|siehe Anlage|siehe Anlagen|dieser Nachricht beigefügt"
],
	"\u0000seen\u0001": [
	"gesehen"
],
	"\u0000select format\u0001": [
	"Format wählen"
],
	"\u0000size\u0001": [
	"Größe"
],
	"\u0000some category\u0001": [
	"irgendeine Kategorie"
],
	"\u0000tentative\u0001": [
	"vorläufig"
],
	"\u0000then\u0001": [
	"dann"
],
	"\u0000third\u0001": [
	"dritten"
],
	"\u0000thumbnail\u0001": [
	"Vorschaubild"
],
	"\u0000timeframe\u0001": [
	"Zeitrahmen"
],
	"\u0000timeframe relation\u0001": [
	"Zeitrahmenbezug"
],
	"\u0000toggle password visibility\u0001": [
	"Passwort-Sichtbarkeit an/aus"
],
	"\u0000type\u0001": [
	"Typ"
],
	"\u0000unconfirmed\u0001": [
	"nicht bestätigt"
],
	"\u0000unknown\u0001": [
	"unbekannt"
],
	"\u0000unknown Domain\u0001": [
	"unbekannte Domain"
],
	"\u0000unknown sender\u0001": [
	"unbekannter Absender"
],
	"\u0000unlimited\u0001": [
	"unbegrenzt"
],
	"\u0000vCard\u0001": [
	"vCard"
],
	"\u0000vacation notice\u0001": [
	"Abwesenheitsbenachrichtigung"
],
	"\u0000via\u0001": [
	"über"
],
	"\u0000week(s)\u0001": [
	"Woche(n)"
],
	"search\u0000year\u0001": [
	"jahr"
],
	"\u0000year(s)\u0001": [
	"Jahr(e)"
],
	"search\u0000yes\u0001": [
	"ja"
],
	"\u0000your platform\u0001": [
	"Ihre Plattform"
],
	"\u0000„Undo send“ is a new feature that gives you the ability to cancel sending an email shortly after you've clicked the \"send\" button. This feature is super handy if you've made a mistake, such as forgetting to attach a file or sending an email to the wrong recipient or simply hit „send“ by accident.\u0001": [
	"\"Senden zurücknehmen\" ist eine neue Funktion, mit der Sie das Senden einer E-Mail abbrechen können, kurz nachdem Sie auf die Schaltfläche \"Senden\" geklickt haben. Diese Funktion ist überaus praktisch, wenn Sie einen Fehler gemacht haben, z. B. vergessen haben, eine Datei anzuhängen oder eine E-Mail an den falschen Empfänger gesendet haben oder einfach aus Versehen auf \"Senden\" geklickt haben."
]
};
